var _defs, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _path, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _path2, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _path3, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _path4, _g335, _g336;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwards1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 322.933,
    height: 334.553,
    viewBox: "0 0 322.933 334.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202d4d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75400",
    "data-name": "Path 75400",
    d: "M44.027,0c-7.393,2.368-13.2,3.168-19.938,6.473C16.875,10.007,12.455,19.946,11.8,22.6c3.432-1.065,13.346.128,21.531-8.994A117.4,117.4,0,0,0,44.027,0Z",
    transform: "translate(-11.799)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75401",
    "data-name": "Path 75401",
    d: "M17.7,10.7c-9.743,11.361-7.367,22.6-8.2,24.988,1.525-.375,10.2-6.217,15.85-16.284C28.841,13.166,30.076,5.6,34.828.246,28.611,2.869,22.249,5.722,17.7,10.7",
    transform: "translate(-9.499 -0.246)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75402",
    "data-name": "Path 75402",
    d: "M32.7,5.653C22.849,6.735,15.533,8.361,9.563,16.2c2.921.426,11.114,3.722,20.56.945A33.963,33.963,0,0,0,47.505,2.885C43.213,4.512,37.26,5.168,32.7,5.653",
    transform: "translate(-9.563 -2.885)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75403",
    "data-name": "Path 75403",
    d: "M8.462,21.168c-2.257,9.522.784,15.867.511,18.115,0,0,8.593-3.952,9.735-16.131.894-7.282.179-15.117,3.756-21.471-6.013,5.434-12.119,11.591-14,19.487",
    transform: "translate(-7.622 -1.681)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75404",
    "data-name": "Path 75404",
    d: "M25.251,5.729C13.064,5,7.843,12.884,7.843,12.884c1.192.017,7.4,4.241,17.817,3.262,8.091-.758,15.1-5.757,21.4-10.885-6.941,1.576-14.47.681-21.812.468",
    transform: "translate(-7.843 -5.261)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75405",
    "data-name": "Path 75405",
    d: "M5.38,30.434c-.324,5.059.724,13.252,4.139,17.332,0,0,5.9-5.979,7.614-11.932,3.092-10.689,1.056-21.394,3.5-32.517C15.422,11.773,6.274,16.389,5.38,30.434",
    transform: "translate(-5.324 -3.316)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75406",
    "data-name": "Path 75406",
    d: "M15.546,11.188c-5.8,2.189-9.658,8.9-9.658,8.9,4.327,3.092,12.741,4.2,17.6,2.768C36.949,18.862,38.175,12.832,46.19,6.964c-10.569,1.993-20.227.307-30.644,4.224",
    transform: "translate(-5.888 -6.964)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75407",
    "data-name": "Path 75407",
    d: "M3.573,40.01c.988,6.575,6.141,12.136,7.955,14.061,0,0,6.439-10.663,6.422-14.8-.043-7.972-1.439-11.779-2.93-16.863-1.61-5.51-3.058-11.149-2.947-16.863C6.622,16.529,1.75,27.822,3.573,40.01",
    transform: "translate(-3.183 -5.542)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75408",
    "data-name": "Path 75408",
    d: "M30.161,13.136c-5.6,1.226-13.133,1.439-18.141,4.224C8.4,19.37,4.236,29.4,4.236,29.4c1.158,0,2.512.136,4.037.264a34.282,34.282,0,0,0,11.668-.5C30.033,26.686,37.775,18.868,44.955,8.9c-5.016,2.776-9.2,3-14.794,4.233",
    transform: "translate(-4.236 -8.903)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75409",
    "data-name": "Path 75409",
    d: "M1.634,43.206C3.908,59.1,12.5,62.284,14.384,64.234c5.3-11.915,4.769-21.6.7-32.628-2.828-7.665-5.076-13.763-5.723-23.089C4.41,19.333-.121,30.967,1.634,43.206",
    transform: "translate(-1.249 -8.517)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75410",
    "data-name": "Path 75410",
    d: "M30.347,15.669c-4.267.7-7.418,1.32-11.625,2.283-3.943.9-9.394,4.233-11.787,7.614C4.507,29,3.953,34.627,2.829,38.656c17.3.256,31.436-12.009,38.632-26.692-3.594,2.47-6.856,3-11.114,3.7",
    transform: "translate(-2.829 -11.964)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75411",
    "data-name": "Path 75411",
    d: "M3.056,44.532C8.907,57.162,17.1,56.106,19.562,58.167c0,0,.136-3.62.128-6.26a36.111,36.111,0,0,0-5.263-18.652C10.176,26.34,3.584,20.863.637,13.292.782,23.436-1.194,34.7,3.056,44.532",
    transform: "translate(-0.303 -13.292)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75412",
    "data-name": "Path 75412",
    d: "M24.01,20.759C18.269,23.876,6.874,26.806,3.186,35.68,2.76,36.7,2.1,47.289,3.263,47.417c1.925-.8,8.142-.971,14.479-6.26,10.595-8.832,10.867-17.6,14.734-26.445a35.366,35.366,0,0,1-8.466,6.047",
    transform: "translate(-2.608 -14.712)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75413",
    "data-name": "Path 75413",
    d: "M11.983,48.682c5.681,5.681,11.889,5.153,15.714,6.958,0,0-1.729-6.515-2.112-8.278-1.252-5.749-2.5-10.748-6.916-14.666C12.46,27.2,4.02,24.545,0,18.251,1.4,29.229,4.08,40.778,11.983,48.682",
    transform: "translate(0 -18.251)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75414",
    "data-name": "Path 75414",
    d: "M7.173,34.146C4.6,37.186,2.778,40.414,2.949,44.434c.341,7.461,3.373,14.4,3.509,14.121.877-1.712,10.655-4.889,15.6-19.027C24.5,32.57,25.305,25.135,26.506,17.9c-5.791,6.473-13.661,9.573-19.333,16.242",
    transform: "translate(-2.938 -17.904)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75415",
    "data-name": "Path 75415",
    d: "M7.451,36.075C5.2,40.87,3.823,45.639,4.411,51.013c.749,6.762,6.754,12.622,6.754,12.622.1-2.087,8.653-9.351,8.312-24.256-.128-5.391-1.652-13.048-2.6-18.362-2.4,6.388-6.388,8.593-9.428,15.058",
    transform: "translate(-4.275 -21.017)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75416",
    "data-name": "Path 75416",
    d: "M15.086,46.976c5.655,4.6,17.868,3.449,21.267,3.926-.894-3.364-7.333-12.443-11-15.8C18.569,28.861,9.652,26.766.82,22.695c4.872,9.283,6.711,18.141,14.266,24.281",
    transform: "translate(-0.82 -22.695)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75417",
    "data-name": "Path 75417",
    d: "M7.339,41.152c-1.678,5.519-1.158,11.6.1,17.306,1.175,5.306,8.909,10.408,8.883,10.518,1.584-6.813,7.529-7.742,2.725-27.1-1.559-6.277-5.136-11.992-6.124-18.388-1.754,4.855-3.764,11.7-5.587,17.664",
    transform: "translate(-6.276 -23.488)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75418",
    "data-name": "Path 75418",
    d: "M2.666,27.716c1.295,1.175,2.964,1.984,4.284,3.2,4,3.7,6.975,8.568,11.7,11.353,7.026,4.139,15.85,2.589,23.8.979A47.274,47.274,0,0,0,32.356,32.6a30.369,30.369,0,0,0-14.862-5.144c-2.385-.238-5.17-.485-7.921-.485a27.314,27.314,0,0,0-6.907.75",
    transform: "translate(-2.666 -26.966)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75419",
    "data-name": "Path 75419",
    d: "M15.767,26.5c-3.679,7.307-9.914,18.217-6.728,26.675,0,0,6.609,6.524,10.425,8.2-.988-2,3.56-6.345,2.01-18.754A47.166,47.166,0,0,0,15.75,26.37c-.017,0-.009.043.017.128",
    transform: "translate(-8.161 -26.37)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75420",
    "data-name": "Path 75420",
    d: "M14.41,31.19c-2.436.715-7.537,2.87-9.343,4.761a33.89,33.89,0,0,1,7.009,1.84c5.1,2.308,8.934,5.374,14.657,5.817,8.985.664,12.554-3.824,15.637-4.565,0,0-7.52-9.062-14.445-9.573-.324-.026-.681-.034-1.065-.034A57.371,57.371,0,0,0,14.41,31.19",
    transform: "translate(-5.067 -29.436)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75421",
    "data-name": "Path 75421",
    d: "M10.706,49.183c2.572,4.148,13.278,8.057,13.278,8.1,2.444-11.4-5.749-20.917-7.333-28.71-5.28,6.473-7.4,13.21-5.945,20.611",
    transform: "translate(-10.257 -28.572)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75422",
    "data-name": "Path 75422",
    d: "M7.828,38.743c3.943-.136,6.848,1.056,9.905,2.231,3.4,1.32,6.992,2.64,12.426,2.129,6.072-.554,10.1-4.284,12.145-4.752-4-2.717-7.273-5.97-12.034-6.916a16.293,16.293,0,0,0-3.185-.3c-7.946,0-17.153,4.914-19.257,7.606",
    transform: "translate(-7.828 -31.137)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75423",
    "data-name": "Path 75423",
    d: "M24.914,32.965c-3.611.767-9.479,4.718-13.7,11.2a19.028,19.028,0,0,1,6.618-.46,35.326,35.326,0,0,0,11.166-.954c4.446-1.107,7.9-4.846,10.05-5.4A46.138,46.138,0,0,0,31.6,33.6a10.489,10.489,0,0,0-4.2-.92,11.843,11.843,0,0,0-2.487.281",
    transform: "translate(-11.21 -32.684)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75424",
    "data-name": "Path 75424",
    d: "M15.4,49.866c.852,1.533,12.239,6.362,12.409,5.51-.8-1.848.656-7.665-4.761-14.4-3.032-4.054-7.469-7.2-10.127-10.748-.264,8.985-.485,14.274,2.478,19.64",
    transform: "translate(-12.78 -30.226)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75425",
    "data-name": "Path 75425",
    d: "M25.065,33.681c-2.734.324-3.7,2.512-6,4.778C18,39.523,16.471,41.874,14.1,43.33c3.7,1.456,10.833.63,14.283-1.559,3.4-2.172,5.272-3.722,7.776-4.25,0,0-5.919-3.884-10.322-3.884a7.561,7.561,0,0,0-.767.043",
    transform: "translate(-14.095 -33.638)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75426",
    "data-name": "Path 75426",
    d: "M18.277,47.505,30.2,52.164c-.043-4.318-2.555-8.517-5.74-11.421A125.763,125.763,0,0,1,15.339,31.7a21.872,21.872,0,0,0,2.938,15.807",
    transform: "translate(-14.931 -31.698)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1293",
    "data-name": "Rectangle 1293",
    width: 322.933,
    height: 300.874,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1240",
    "data-name": "Rectangle 1240",
    width: 32.205,
    height: 22.497,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 24.838,
    height: 28.309,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 32.515,
    height: 8.07,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1243",
    "data-name": "Rectangle 1243",
    width: 14.839,
    height: 26.091,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1244",
    "data-name": "Rectangle 1244",
    width: 32.695,
    height: 2.646,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1245",
    "data-name": "Rectangle 1245",
    width: 15.26,
    height: 28.625,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1246",
    "data-name": "Rectangle 1246",
    width: 34.497,
    height: 6.465,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 33.903,
    height: 9.224,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1248",
    "data-name": "Rectangle 1248",
    width: 31.091,
    height: 10.261,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1249",
    "data-name": "Rectangle 1249",
    width: 18.18,
    height: 31.221,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1250",
    "data-name": "Rectangle 1250",
    width: 27.992,
    height: 18.656,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1251",
    "data-name": "Rectangle 1251",
    width: 23.569,
    height: 21.845,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1252",
    "data-name": "Rectangle 1252",
    width: 23.518,
    height: 24.907,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1253",
    "data-name": "Rectangle 1253",
    width: 12.602,
    height: 30.183,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1254",
    "data-name": "Rectangle 1254",
    width: 25.692,
    height: 13.574,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1255",
    "data-name": "Rectangle 1255",
    width: 14.546,
    height: 31.21,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1256",
    "data-name": "Rectangle 1256",
    width: 28.36,
    height: 4.828,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1257",
    "data-name": "Rectangle 1257",
    width: 13.262,
    height: 21.731,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1258",
    "data-name": "Rectangle 1258",
    width: 25.465,
    height: 6.545,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1259",
    "data-name": "Rectangle 1259",
    width: 11.04,
    height: 16.146,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1260",
    "data-name": "Rectangle 1260",
    width: 22.85,
    height: 7.616,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1261",
    "data-name": "Rectangle 1261",
    width: 15.941,
    height: 10.199,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1262",
    "data-name": "Rectangle 1262",
    width: 11.941,
    height: 16.081,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 11.597,
    height: 9.658,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1264",
    "data-name": "Rectangle 1264",
    width: 13.386,
    height: 14.749,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1265",
    "data-name": "Rectangle 1265",
    width: 13.061,
    height: 30.236,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1266",
    "data-name": "Rectangle 1266",
    width: 15.466,
    height: 30.637,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1267",
    "data-name": "Rectangle 1267",
    width: 8.801,
    height: 17.726,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1268",
    "data-name": "Rectangle 1268",
    width: 19.428,
    height: 2.452,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1269",
    "data-name": "Rectangle 1269",
    width: 3.839,
    height: 19.151,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270",
    "data-name": "Rectangle 1270",
    width: 3.963,
    height: 23.012,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1271",
    "data-name": "Rectangle 1271",
    width: 19.397,
    height: 1.467,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1272",
    "data-name": "Rectangle 1272",
    width: 23.01,
    height: 3.977,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1273",
    "data-name": "Rectangle 1273",
    width: 2.389,
    height: 24.865,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1274",
    "data-name": "Rectangle 1274",
    width: 24.059,
    height: 7.379,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1275",
    "data-name": "Rectangle 1275",
    width: 6.812,
    height: 27.825,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1276",
    "data-name": "Rectangle 1276",
    width: 25.556,
    height: 13.564,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1277",
    "data-name": "Rectangle 1277",
    width: 13.1,
    height: 23.496,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1278",
    "data-name": "Rectangle 1278",
    width: 21.663,
    height: 16.229,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    width: 18.64,
    height: 19.58,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1280",
    "data-name": "Rectangle 1280",
    width: 14.621,
    height: 22.632,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1281",
    "data-name": "Rectangle 1281",
    width: 20.296,
    height: 12.967,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1282",
    "data-name": "Rectangle 1282",
    width: 6.096,
    height: 23.052,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1283",
    "data-name": "Rectangle 1283",
    width: 22.972,
    height: 6.963,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1284",
    "data-name": "Rectangle 1284",
    width: 2.221,
    height: 23.81,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1285",
    "data-name": "Rectangle 1285",
    width: 21.004,
    height: 2.35,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1286",
    "data-name": "Rectangle 1286",
    width: 21.004,
    height: 1.839,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1287",
    "data-name": "Rectangle 1287",
    width: 16.362,
    height: 4.79,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    width: 10.977,
    height: 5.724,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1289",
    "data-name": "Rectangle 1289",
    width: 3.442,
    height: 20.851,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1290",
    "data-name": "Rectangle 1290",
    width: 6.599,
    height: 17.666,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1291",
    "data-name": "Rectangle 1291",
    width: 8.649,
    height: 14.984,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1292",
    "data-name": "Rectangle 1292",
    width: 7.099,
    height: 10.389,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75480",
    "data-name": "Path 75480",
    d: "M100.927,1.078s-1.158,1-3.517,2.657c-2.4,1.6-5.919,3.935-10.4,6.924C78.3,16.928,65.4,25.624,52.407,38.842,39.35,51.881,25.408,68.8,15.3,89.764,5.079,110.6.131,135.942,3.461,160.692A131.047,131.047,0,0,0,13.587,196.2a128.643,128.643,0,0,0,19.333,30.09c15.237,17.664,33.607,29.886,49.951,38.453,8.185,4.344,15.961,7.742,22.9,10.621s13.048,5.664,17.834,8.006a63.816,63.816,0,0,1,10.646,6.3,21.307,21.307,0,0,1,3.109,2.819,1.405,1.405,0,0,0,.928.409h.145a1.437,1.437,0,0,0,.928-2.47,29.223,29.223,0,0,0-3.986-2.461c-2.555-1.456-6.319-3.441-11.191-5.791-4.88-2.427-10.961-5.238-17.851-8.168s-14.6-6.362-22.7-10.723c-16.165-8.619-34.246-20.858-49.125-38.36a126.36,126.36,0,0,1-18.78-29.69,128.487,128.487,0,0,1-9.7-34.928,123.753,123.753,0,0,1,.46-36.179A128.128,128.128,0,0,1,16.977,90.556c9.76-20.815,23.413-37.789,36.256-50.905C66.017,26.313,78.817,17.694,87.445,11.273c4.361-3.134,7.921-5.434,10.212-7.214s3.381-2.853,3.381-2.853a.092.092,0,0,0,.009-.128l-.06-.017-.06.017",
    transform: "translate(-2.43 -1.061)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 137.317,
    height: 274.682,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1295",
    "data-name": "Rectangle 1295",
    width: 75.885,
    height: 203.303,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75483",
    "data-name": "Path 75483",
    d: "M22.333,0A118.176,118.176,0,0,0,33.039,13.6c8.185,9.122,18.1,7.929,21.531,8.994-.656-2.649-5.068-12.588-12.29-16.122C35.543,3.168,29.734,2.368,22.333,0Z",
    transform: "translate(-22.333)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75484",
    "data-name": "Path 75484",
    d: "M34.932,19.4C40.57,29.467,49.249,35.31,50.773,35.685c-.826-2.393,1.55-13.627-8.21-24.988C38.023,5.722,31.661,2.869,25.444.246,30.2,5.6,31.431,13.166,34.932,19.4",
    transform: "translate(-25.444 -0.246)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75485",
    "data-name": "Path 75485",
    d: "M41.274,17.142c9.445,2.776,17.638-.52,20.56-.945C55.872,8.361,48.556,6.735,38.694,5.653,34.146,5.168,28.184,4.512,23.9,2.885A33.91,33.91,0,0,0,41.274,17.142",
    transform: "translate(-23.9 -2.885)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75486",
    "data-name": "Path 75486",
    d: "M32.316,23.152c1.141,12.179,9.726,16.131,9.726,16.131-.264-2.248,2.768-8.593.511-18.115-1.882-7.9-7.989-14.053-14-19.487,3.586,6.354,2.862,14.189,3.764,21.471",
    transform: "translate(-28.552 -1.681)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75487",
    "data-name": "Path 75487",
    d: "M46.864,16.146c10.416.979,16.625-3.245,17.817-3.262,0,0-5.212-7.887-17.408-7.154-7.342.213-14.862,1.107-21.8-.468,6.294,5.127,13.3,10.127,21.394,10.885",
    transform: "translate(-25.47 -5.261)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75488",
    "data-name": "Path 75488",
    d: "M34.288,35.833C36,41.787,41.9,47.765,41.9,47.765c3.415-4.08,4.463-12.273,4.139-17.332C45.155,16.389,36,11.773,30.8,3.316c2.427,11.123.4,21.829,3.492,32.517",
    transform: "translate(-30.796 -3.316)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75489",
    "data-name": "Path 75489",
    d: "M50,22.856c4.855,1.431,13.278.324,17.6-2.768,0,0-3.858-6.711-9.65-8.9C47.524,7.271,37.866,8.957,27.3,6.964c8.014,5.868,9.241,11.9,22.706,15.892",
    transform: "translate(-27.297 -6.964)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75490",
    "data-name": "Path 75490",
    d: "M35.93,22.405C34.448,27.49,33.051,31.3,33,39.269c-.017,4.139,6.422,14.8,6.422,14.8,1.814-1.925,6.967-7.486,7.955-14.061C49.2,27.822,44.336,16.529,38.885,5.542c.1,5.715-1.346,11.353-2.955,16.863",
    transform: "translate(-33 -5.542)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75491",
    "data-name": "Path 75491",
    d: "M53.914,29.165a34.234,34.234,0,0,0,11.66.5c1.524-.128,2.879-.264,4.045-.264,0,0-4.165-10.033-7.784-12.043-5-2.785-12.545-3-18.141-4.224S33.908,11.679,28.9,8.9c7.188,9.965,14.93,17.783,25.014,20.262",
    transform: "translate(-28.9 -8.903)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75492",
    "data-name": "Path 75492",
    d: "M37.834,31.606c-4.071,11.029-4.591,20.713.7,32.628C40.423,62.284,49,59.1,51.282,43.206c1.763-12.239-2.768-23.873-7.716-34.689-.647,9.326-2.9,15.424-5.732,23.089",
    transform: "translate(-34.673 -8.517)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75493",
    "data-name": "Path 75493",
    d: "M69.184,38.656c-1.124-4.028-1.678-9.658-4.1-13.09-2.4-3.381-7.844-6.711-11.787-7.614-4.216-.962-7.367-1.584-11.634-2.283s-7.52-1.235-11.114-3.7c7.2,14.683,21.335,26.947,38.632,26.692",
    transform: "translate(-30.552 -11.964)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75494",
    "data-name": "Path 75494",
    d: "M40.6,33.255a36.11,36.11,0,0,0-5.263,18.652c-.009,2.64.128,6.26.128,6.26,2.461-2.061,10.655-1,16.506-13.635,4.25-9.828,2.274-21.1,2.419-31.24C51.452,20.863,44.843,26.34,40.6,33.255",
    transform: "translate(-35.338 -13.292)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75495",
    "data-name": "Path 75495",
    d: "M46.536,41.157c6.345,5.289,12.554,5.459,14.487,6.26,1.158-.128.494-10.714.068-11.736-3.679-8.875-15.083-11.8-20.824-14.921A35.366,35.366,0,0,1,31.8,14.712c3.867,8.84,4.139,17.613,14.734,26.445",
    transform: "translate(-31.802 -14.712)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75496",
    "data-name": "Path 75496",
    d: "M43.693,32.7c-4.412,3.918-5.664,8.917-6.916,14.666-.383,1.763-2.112,8.278-2.112,8.278,3.824-1.806,10.033-1.278,15.722-6.958,7.9-7.9,10.578-19.452,11.975-30.431C58.342,24.545,49.9,27.2,43.693,32.7",
    transform: "translate(-34.665 -18.251)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75497",
    "data-name": "Path 75497",
    d: "M36.658,39.528c4.948,14.138,14.734,17.315,15.6,19.027.145.281,3.177-6.66,3.509-14.121.17-4.02-1.652-7.248-4.224-10.288C45.873,27.477,38,24.377,32.212,17.9c1.209,7.231,2.01,14.666,4.446,21.624",
    transform: "translate(-32.212 -17.904)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75498",
    "data-name": "Path 75498",
    d: "M31.866,39.379c-.341,14.9,8.21,22.169,8.312,24.256,0,0,6-5.86,6.754-12.622.588-5.374-.792-10.144-3.041-14.939-3.041-6.464-7.026-8.67-9.428-15.058-.945,5.315-2.47,12.971-2.6,18.362",
    transform: "translate(-31.856 -21.017)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75499",
    "data-name": "Path 75499",
    d: "M43.913,35.1c-3.654,3.356-10.1,12.435-10.987,15.8,3.4-.477,15.611.673,21.258-3.926,7.554-6.141,9.394-15,14.266-24.281C59.626,26.766,50.7,28.861,43.913,35.1",
    transform: "translate(-32.926 -22.695)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75500",
    "data-name": "Path 75500",
    d: "M31.761,41.876c-4.795,19.359,1.141,20.287,2.717,27.1-.017-.111,7.716-5.212,8.892-10.518,1.261-5.706,1.789-11.787.1-17.306-1.823-5.962-3.833-12.809-5.587-17.664-.988,6.4-4.565,12.111-6.124,18.388",
    transform: "translate(-29.926 -23.488)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75501",
    "data-name": "Path 75501",
    d: "M55.542,27.451A30.429,30.429,0,0,0,40.68,32.6a47.464,47.464,0,0,0-10.1,10.655c7.963,1.61,16.778,3.16,23.8-.979,4.727-2.785,7.7-7.657,11.7-11.353,1.329-1.218,2.989-2.027,4.284-3.2a27.27,27.27,0,0,0-6.907-.75c-2.742,0-5.536.247-7.921.485",
    transform: "translate(-30.579 -26.966)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75502",
    "data-name": "Path 75502",
    d: "M28.484,42.62c-1.559,12.409,2.989,16.753,2,18.754,3.816-1.678,10.433-8.2,10.433-8.2C44.1,44.715,37.861,33.805,34.19,26.5c.026-.085.034-.128.017-.128-.213.009-4.727,8.338-5.723,16.25",
    transform: "translate(-28.155 -26.37)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75503",
    "data-name": "Path 75503",
    d: "M42.915,29.47C36,29.981,28.47,39.043,28.47,39.043c3.083.741,6.66,5.229,15.645,4.565,5.715-.443,9.547-3.509,14.657-5.817a33.731,33.731,0,0,1,7-1.84c-1.806-1.891-6.9-4.046-9.334-4.761a57.527,57.527,0,0,0-12.46-1.754c-.383,0-.741.009-1.065.034",
    transform: "translate(-28.47 -29.436)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75504",
    "data-name": "Path 75504",
    d: "M26.448,57.282c0-.043,10.7-3.952,13.269-8.1,1.456-7.4-.656-14.138-5.945-20.611C32.189,36.365,24,45.878,26.448,57.282",
    transform: "translate(-25.996 -28.572)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75505",
    "data-name": "Path 75505",
    d: "M38.075,31.435c-4.761.945-8.023,4.2-12.034,6.916,2.044.468,6.072,4.2,12.154,4.752,5.417.511,9.011-.809,12.409-2.129,3.058-1.175,5.962-2.368,9.914-2.231-2.1-2.691-11.31-7.606-19.257-7.606a16.293,16.293,0,0,0-3.185.3",
    transform: "translate(-26.041 -31.137)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75506",
    "data-name": "Path 75506",
    d: "M30.884,33.6a45.79,45.79,0,0,0-7.444,3.747c2.146.554,5.6,4.292,10.041,5.4a35.276,35.276,0,0,0,11.157.954,19.141,19.141,0,0,1,6.635.46c-4.224-6.481-10.092-10.433-13.712-11.2a11.828,11.828,0,0,0-2.478-.281,10.489,10.489,0,0,0-4.2.92",
    transform: "translate(-23.44 -32.684)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75507",
    "data-name": "Path 75507",
    d: "M28.125,40.974c-5.417,6.737-3.96,12.554-4.752,14.4.162.852,11.549-3.977,12.4-5.51,2.972-5.366,2.734-10.655,2.478-19.64-2.657,3.552-7.095,6.694-10.127,10.748",
    transform: "translate(-23.373 -30.226)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75508",
    "data-name": "Path 75508",
    d: "M21.232,37.522c2.512.528,4.378,2.078,7.776,4.25,3.449,2.189,10.586,3.015,14.283,1.559-2.376-1.456-3.9-3.807-4.974-4.872-2.291-2.265-3.262-4.454-5.987-4.778a7.592,7.592,0,0,0-.775-.043c-4.4,0-10.322,3.884-10.322,3.884",
    transform: "translate(-21.232 -33.638)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75509",
    "data-name": "Path 75509",
    d: "M26.934,40.743c-3.194,2.9-5.706,7.1-5.74,11.421,0-.026,11.889-4.65,11.924-4.659A21.955,21.955,0,0,0,36.056,31.7c-3.441,3.756-5.928,6.132-9.122,9.045",
    transform: "translate(-21.194 -31.698)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1328",
    "data-name": "Rectangle 1328",
    width: 14.838,
    height: 26.091,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1330",
    "data-name": "Rectangle 1330",
    width: 15.259,
    height: 28.625,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1332",
    "data-name": "Rectangle 1332",
    width: 33.904,
    height: 9.224,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1333",
    "data-name": "Rectangle 1333",
    width: 31.092,
    height: 10.261,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1335",
    "data-name": "Rectangle 1335",
    width: 27.991,
    height: 18.656,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1336",
    "data-name": "Rectangle 1336",
    width: 23.568,
    height: 21.845,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337",
    "data-name": "Rectangle 1337",
    width: 23.517,
    height: 24.907,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338",
    "data-name": "Rectangle 1338",
    width: 12.601,
    height: 30.183,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1339",
    "data-name": "Rectangle 1339",
    width: 25.691,
    height: 13.574,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1340",
    "data-name": "Rectangle 1340",
    width: 14.547,
    height: 31.21,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1343",
    "data-name": "Rectangle 1343",
    width: 25.464,
    height: 6.545,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    width: 19.429,
    height: 2.452,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1354",
    "data-name": "Rectangle 1354",
    width: 3.84,
    height: 19.151,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1355",
    "data-name": "Rectangle 1355",
    width: 3.962,
    height: 23.012,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    width: 19.398,
    height: 1.467,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1358",
    "data-name": "Rectangle 1358",
    width: 2.39,
    height: 24.865,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1359",
    "data-name": "Rectangle 1359",
    width: 24.058,
    height: 7.379,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1364",
    "data-name": "Rectangle 1364",
    width: 18.641,
    height: 19.58,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 14.622,
    height: 22.632,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1367",
    "data-name": "Rectangle 1367",
    width: 6.095,
    height: 23.052,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1368",
    "data-name": "Rectangle 1368",
    width: 22.971,
    height: 6.963,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1369",
    "data-name": "Rectangle 1369",
    width: 2.222,
    height: 23.81,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1370",
    "data-name": "Rectangle 1370",
    width: 21.003,
    height: 2.35,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1371",
    "data-name": "Rectangle 1371",
    width: 21.003,
    height: 1.839,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1375",
    "data-name": "Rectangle 1375",
    width: 6.598,
    height: 17.666,
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75563",
    "data-name": "Path 75563",
    d: "M58.106,1.078a.092.092,0,0,0,.009.128s1.1,1.073,3.381,2.853,5.851,4.08,10.212,7.214c8.628,6.422,21.428,15.041,34.221,28.378,12.835,13.116,26.487,30.09,36.248,50.905a127.809,127.809,0,0,1,10.484,33.573,123.752,123.752,0,0,1,.46,36.179,128.473,128.473,0,0,1-9.692,34.928,126.664,126.664,0,0,1-18.788,29.69c-14.87,17.5-32.96,29.741-49.125,38.36-8.091,4.361-15.807,7.8-22.7,10.723s-12.963,5.74-17.843,8.168c-4.872,2.351-8.636,4.335-11.208,5.791a30.131,30.131,0,0,0-3.977,2.461,1.45,1.45,0,0,0-.017,2.044,1.426,1.426,0,0,0,.945.426h.153a1.423,1.423,0,0,0,.928-.409,20.2,20.2,0,0,1,3.1-2.819,64.179,64.179,0,0,1,10.646-6.3c4.786-2.342,10.9-5.119,17.834-8.006s14.717-6.277,22.91-10.621c16.335-8.568,34.706-20.79,49.943-38.453a128.671,128.671,0,0,0,19.342-30.09,131.032,131.032,0,0,0,10.118-35.507c3.339-24.75-1.618-50.1-11.838-70.928C133.744,68.8,119.8,51.881,106.746,38.842,93.757,25.624,80.854,16.928,72.133,10.659c-4.471-2.989-7.98-5.323-10.382-6.924-2.359-1.652-3.526-2.657-3.526-2.657l-.06-.017-.06.017",
    transform: "translate(-19.358 -1.061)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75566",
    "data-name": "Path 75566",
    d: "M24.545,10.521l-6.677.068,5.289,4.1-1.993,6.379L26.691,17.3l5.451,3.867L30.26,14.745l5.366-3.986-6.686-.2L26.811,4.219Z",
    transform: "translate(-17.868 -4.219)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75567",
    "data-name": "Path 75567",
    d: "M26.858,10.2l-5.51.051,4.361,3.373-1.644,5.263,4.548-3.109,4.5,3.185-1.55-5.289,4.42-3.287-5.51-.162L28.715,5.011Z",
    transform: "translate(-21.348 -5.011)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75568",
    "data-name": "Path 75568",
    d: "M20.361,10.224l-5.51.162,4.42,3.287L17.73,18.962l4.5-3.185,4.539,3.109-1.635-5.263,4.352-3.373-5.5-.051L22.116,5.011Z",
    transform: "translate(-14.851 -5.011)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75569",
    "data-name": "Path 75569",
    d: "M29.1,11.288l-4.94.051,3.909,3.032-1.473,4.71,4.08-2.776L34.7,19.157l-1.388-4.744,3.977-2.947-4.948-.145L30.766,6.638Z",
    transform: "translate(-24.157 -6.638)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75570",
    "data-name": "Path 75570",
    d: "M17.166,11.322l-4.948.145L16.2,14.413l-1.388,4.744L18.836,16.3l4.088,2.776-1.482-4.71,3.909-3.032-4.94-.051-1.669-4.65Z",
    transform: "translate(-12.218 -6.638)",
    fill: "#182a51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2412",
    "data-name": "Rectangle 2412",
    width: 70,
    height: 69,
    transform: "translate(298 4518)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 101 120"
  }, /*#__PURE__*/React.createElement("image", {
    width: 101,
    height: 120,
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76244",
    "data-name": "Path 76244",
    d: "M3974.639,5008.447c-13.782,3.932-153.508,57.393-138.743,170.818.439.59.368,86.035,117.52,124.861,1.426,1.663,15.391,6.071,20.96,13.233.447.5,18.621-12.226,21.656-13.233-2.962.947,119.994-31.846,118.088-142.535C4114.958,5161.662,4110.814,5054.623,3974.639,5008.447Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76078",
    "data-name": "Path 76078",
    d: "M44.027,0c-7.393,2.368-13.2,3.168-19.938,6.473C16.875,10.007,12.455,19.946,11.8,22.6c3.432-1.065,13.346.128,21.531-8.994A117.4,117.4,0,0,0,44.027,0Z",
    transform: "translate(-11.799)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76079",
    "data-name": "Path 76079",
    d: "M17.7,10.7c-9.743,11.361-7.367,22.6-8.2,24.988,1.525-.375,10.2-6.217,15.85-16.284C28.841,13.166,30.076,5.6,34.828.246,28.611,2.869,22.249,5.722,17.7,10.7",
    transform: "translate(-9.499 -0.246)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76080",
    "data-name": "Path 76080",
    d: "M32.7,5.653C22.849,6.735,15.533,8.361,9.563,16.2c2.921.426,11.114,3.722,20.56.945A33.963,33.963,0,0,0,47.505,2.885C43.213,4.512,37.26,5.168,32.7,5.653",
    transform: "translate(-9.563 -2.885)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76081",
    "data-name": "Path 76081",
    d: "M8.462,21.168c-2.257,9.522.784,15.867.511,18.115,0,0,8.593-3.952,9.735-16.131.894-7.282.179-15.117,3.756-21.471-6.013,5.434-12.119,11.591-14,19.487",
    transform: "translate(-7.622 -1.681)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76082",
    "data-name": "Path 76082",
    d: "M25.251,5.729C13.064,5,7.843,12.884,7.843,12.884c1.192.017,7.4,4.241,17.817,3.262,8.091-.758,15.1-5.757,21.4-10.885-6.941,1.576-14.47.681-21.812.468",
    transform: "translate(-7.843 -5.261)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76083",
    "data-name": "Path 76083",
    d: "M5.38,30.434c-.324,5.059.724,13.252,4.139,17.332,0,0,5.9-5.979,7.614-11.932,3.092-10.689,1.056-21.394,3.5-32.517C15.422,11.773,6.274,16.389,5.38,30.434",
    transform: "translate(-5.324 -3.316)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76084",
    "data-name": "Path 76084",
    d: "M15.546,11.188c-5.8,2.189-9.658,8.9-9.658,8.9,4.327,3.092,12.741,4.2,17.6,2.768C36.949,18.862,38.175,12.832,46.19,6.964c-10.569,1.993-20.227.307-30.644,4.224",
    transform: "translate(-5.888 -6.964)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76085",
    "data-name": "Path 76085",
    d: "M3.573,40.01c.988,6.575,6.141,12.136,7.955,14.061,0,0,6.439-10.663,6.422-14.8-.043-7.972-1.439-11.779-2.93-16.863-1.61-5.51-3.058-11.149-2.947-16.863C6.622,16.529,1.75,27.822,3.573,40.01",
    transform: "translate(-3.183 -5.542)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76086",
    "data-name": "Path 76086",
    d: "M30.161,13.136c-5.6,1.226-13.133,1.439-18.141,4.224C8.4,19.37,4.236,29.4,4.236,29.4c1.158,0,2.512.136,4.037.264a34.282,34.282,0,0,0,11.668-.5C30.033,26.686,37.775,18.868,44.955,8.9c-5.016,2.776-9.2,3-14.794,4.233",
    transform: "translate(-4.236 -8.903)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76087",
    "data-name": "Path 76087",
    d: "M1.634,43.206C3.908,59.1,12.5,62.284,14.384,64.234c5.3-11.915,4.769-21.6.7-32.628-2.828-7.665-5.076-13.763-5.723-23.089C4.41,19.333-.121,30.967,1.634,43.206",
    transform: "translate(-1.249 -8.517)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76088",
    "data-name": "Path 76088",
    d: "M30.347,15.669c-4.267.7-7.418,1.32-11.625,2.283-3.943.9-9.394,4.233-11.787,7.614C4.507,29,3.953,34.627,2.829,38.656c17.3.256,31.436-12.009,38.632-26.692-3.594,2.47-6.856,3-11.114,3.7",
    transform: "translate(-2.829 -11.964)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76089",
    "data-name": "Path 76089",
    d: "M3.056,44.532C8.907,57.162,17.1,56.106,19.562,58.167c0,0,.136-3.62.128-6.26a36.111,36.111,0,0,0-5.263-18.652C10.176,26.34,3.584,20.863.637,13.292.782,23.436-1.194,34.7,3.056,44.532",
    transform: "translate(-0.303 -13.292)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76090",
    "data-name": "Path 76090",
    d: "M24.01,20.759C18.269,23.876,6.874,26.806,3.186,35.68,2.76,36.7,2.1,47.289,3.263,47.417c1.925-.8,8.142-.971,14.479-6.26,10.595-8.832,10.867-17.6,14.734-26.445a35.366,35.366,0,0,1-8.466,6.047",
    transform: "translate(-2.608 -14.712)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76091",
    "data-name": "Path 76091",
    d: "M11.983,48.682c5.681,5.681,11.889,5.153,15.714,6.958,0,0-1.729-6.515-2.112-8.278-1.252-5.749-2.5-10.748-6.916-14.666C12.46,27.2,4.02,24.545,0,18.251,1.4,29.229,4.08,40.778,11.983,48.682",
    transform: "translate(0 -18.251)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76092",
    "data-name": "Path 76092",
    d: "M7.173,34.146C4.6,37.186,2.778,40.414,2.949,44.434c.341,7.461,3.373,14.4,3.509,14.121.877-1.712,10.655-4.889,15.6-19.027C24.5,32.57,25.305,25.135,26.506,17.9c-5.791,6.473-13.661,9.573-19.333,16.242",
    transform: "translate(-2.938 -17.904)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76093",
    "data-name": "Path 76093",
    d: "M7.451,36.075C5.2,40.87,3.823,45.639,4.411,51.013c.749,6.762,6.754,12.622,6.754,12.622.1-2.087,8.653-9.351,8.312-24.256-.128-5.391-1.652-13.048-2.6-18.362-2.4,6.388-6.388,8.593-9.428,15.058",
    transform: "translate(-4.275 -21.017)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76094",
    "data-name": "Path 76094",
    d: "M15.086,46.976c5.655,4.6,17.868,3.449,21.267,3.926-.894-3.364-7.333-12.443-11-15.8C18.569,28.861,9.652,26.766.82,22.695c4.872,9.283,6.711,18.141,14.266,24.281",
    transform: "translate(-0.82 -22.695)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76095",
    "data-name": "Path 76095",
    d: "M7.339,41.152c-1.678,5.519-1.158,11.6.1,17.306,1.175,5.306,8.909,10.408,8.883,10.518,1.584-6.813,7.529-7.742,2.725-27.1-1.559-6.277-5.136-11.992-6.124-18.388-1.754,4.855-3.764,11.7-5.587,17.664",
    transform: "translate(-6.276 -23.488)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76096",
    "data-name": "Path 76096",
    d: "M2.666,27.716c1.295,1.175,2.964,1.984,4.284,3.2,4,3.7,6.975,8.568,11.7,11.353,7.026,4.139,15.85,2.589,23.8.979A47.274,47.274,0,0,0,32.356,32.6a30.369,30.369,0,0,0-14.862-5.144c-2.385-.238-5.17-.485-7.921-.485a27.314,27.314,0,0,0-6.907.75",
    transform: "translate(-2.666 -26.966)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76097",
    "data-name": "Path 76097",
    d: "M15.767,26.5c-3.679,7.307-9.914,18.217-6.728,26.675,0,0,6.609,6.524,10.425,8.2-.988-2,3.56-6.345,2.01-18.754A47.166,47.166,0,0,0,15.75,26.37c-.017,0-.009.043.017.128",
    transform: "translate(-8.161 -26.37)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76098",
    "data-name": "Path 76098",
    d: "M14.41,31.19c-2.436.715-7.537,2.87-9.343,4.761a33.89,33.89,0,0,1,7.009,1.84c5.1,2.308,8.934,5.374,14.657,5.817,8.985.664,12.554-3.824,15.637-4.565,0,0-7.52-9.062-14.445-9.573-.324-.026-.681-.034-1.065-.034A57.371,57.371,0,0,0,14.41,31.19",
    transform: "translate(-5.067 -29.436)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76099",
    "data-name": "Path 76099",
    d: "M10.706,49.183c2.572,4.148,13.278,8.057,13.278,8.1,2.444-11.4-5.749-20.917-7.333-28.71-5.28,6.473-7.4,13.21-5.945,20.611",
    transform: "translate(-10.257 -28.572)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76100",
    "data-name": "Path 76100",
    d: "M7.828,38.743c3.943-.136,6.848,1.056,9.905,2.231,3.4,1.32,6.992,2.64,12.426,2.129,6.072-.554,10.1-4.284,12.145-4.752-4-2.717-7.273-5.97-12.034-6.916a16.293,16.293,0,0,0-3.185-.3c-7.946,0-17.153,4.914-19.257,7.606",
    transform: "translate(-7.828 -31.137)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76101",
    "data-name": "Path 76101",
    d: "M24.914,32.965c-3.611.767-9.479,4.718-13.7,11.2a19.028,19.028,0,0,1,6.618-.46,35.326,35.326,0,0,0,11.166-.954c4.446-1.107,7.9-4.846,10.05-5.4A46.138,46.138,0,0,0,31.6,33.6a10.489,10.489,0,0,0-4.2-.92,11.843,11.843,0,0,0-2.487.281",
    transform: "translate(-11.21 -32.684)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76102",
    "data-name": "Path 76102",
    d: "M15.4,49.866c.852,1.533,12.239,6.362,12.409,5.51-.8-1.848.656-7.665-4.761-14.4-3.032-4.054-7.469-7.2-10.127-10.748-.264,8.985-.485,14.274,2.478,19.64",
    transform: "translate(-12.78 -30.226)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76103",
    "data-name": "Path 76103",
    d: "M25.065,33.681c-2.734.324-3.7,2.512-6,4.778C18,39.523,16.471,41.874,14.1,43.33c3.7,1.456,10.833.63,14.283-1.559,3.4-2.172,5.272-3.722,7.776-4.25,0,0-5.919-3.884-10.322-3.884a7.561,7.561,0,0,0-.767.043",
    transform: "translate(-14.095 -33.638)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76104",
    "data-name": "Path 76104",
    d: "M18.277,47.505,30.2,52.164c-.043-4.318-2.555-8.517-5.74-11.421A125.763,125.763,0,0,1,15.339,31.7a21.872,21.872,0,0,0,2.938,15.807",
    transform: "translate(-14.931 -31.698)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2322",
    "data-name": "Rectangle 2322",
    width: 322.933,
    height: 300.874,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2269",
    "data-name": "Rectangle 2269",
    width: 32.205,
    height: 22.497,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-207"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2270",
    "data-name": "Rectangle 2270",
    width: 24.838,
    height: 28.309,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-208"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2271",
    "data-name": "Rectangle 2271",
    width: 32.515,
    height: 8.07,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-209"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2272",
    "data-name": "Rectangle 2272",
    width: 14.839,
    height: 26.091,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2273",
    "data-name": "Rectangle 2273",
    width: 32.695,
    height: 2.646,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2274",
    "data-name": "Rectangle 2274",
    width: 15.26,
    height: 28.625,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2275",
    "data-name": "Rectangle 2275",
    width: 34.497,
    height: 6.465,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2276",
    "data-name": "Rectangle 2276",
    width: 33.903,
    height: 9.224,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2277",
    "data-name": "Rectangle 2277",
    width: 31.091,
    height: 10.261,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2278",
    "data-name": "Rectangle 2278",
    width: 18.18,
    height: 31.221,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-216"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2279",
    "data-name": "Rectangle 2279",
    width: 27.992,
    height: 18.656,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2280",
    "data-name": "Rectangle 2280",
    width: 23.569,
    height: 21.845,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-218"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2281",
    "data-name": "Rectangle 2281",
    width: 23.518,
    height: 24.907,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-219"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2282",
    "data-name": "Rectangle 2282",
    width: 12.602,
    height: 30.183,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-220"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2283",
    "data-name": "Rectangle 2283",
    width: 25.692,
    height: 13.574,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2284",
    "data-name": "Rectangle 2284",
    width: 14.546,
    height: 31.21,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2285",
    "data-name": "Rectangle 2285",
    width: 28.36,
    height: 4.828,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-223"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2286",
    "data-name": "Rectangle 2286",
    width: 13.262,
    height: 21.731,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2287",
    "data-name": "Rectangle 2287",
    width: 25.465,
    height: 6.545,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2288",
    "data-name": "Rectangle 2288",
    width: 11.04,
    height: 16.146,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2289",
    "data-name": "Rectangle 2289",
    width: 22.85,
    height: 7.616,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-227"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2290",
    "data-name": "Rectangle 2290",
    width: 15.941,
    height: 10.199,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-228"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2291",
    "data-name": "Rectangle 2291",
    width: 11.941,
    height: 16.081,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2292",
    "data-name": "Rectangle 2292",
    width: 11.597,
    height: 9.658,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-230"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2293",
    "data-name": "Rectangle 2293",
    width: 13.386,
    height: 14.749,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-231"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2294",
    "data-name": "Rectangle 2294",
    width: 13.061,
    height: 30.236,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-232"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2295",
    "data-name": "Rectangle 2295",
    width: 15.466,
    height: 30.637,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-233"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2296",
    "data-name": "Rectangle 2296",
    width: 8.801,
    height: 17.726,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-234"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2297",
    "data-name": "Rectangle 2297",
    width: 19.428,
    height: 2.452,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-235"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2298",
    "data-name": "Rectangle 2298",
    width: 3.839,
    height: 19.151,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-236"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2299",
    "data-name": "Rectangle 2299",
    width: 3.963,
    height: 23.012,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2300",
    "data-name": "Rectangle 2300",
    width: 19.397,
    height: 1.467,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2301",
    "data-name": "Rectangle 2301",
    width: 23.01,
    height: 3.977,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-239"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2302",
    "data-name": "Rectangle 2302",
    width: 2.389,
    height: 24.865,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-240"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2303",
    "data-name": "Rectangle 2303",
    width: 24.059,
    height: 7.379,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-241"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2304",
    "data-name": "Rectangle 2304",
    width: 6.812,
    height: 27.825,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2305",
    "data-name": "Rectangle 2305",
    width: 25.556,
    height: 13.564,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-243"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2306",
    "data-name": "Rectangle 2306",
    width: 13.1,
    height: 23.496,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2307",
    "data-name": "Rectangle 2307",
    width: 21.663,
    height: 16.229,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-245"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2308",
    "data-name": "Rectangle 2308",
    width: 18.64,
    height: 19.58,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-246"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2309",
    "data-name": "Rectangle 2309",
    width: 14.621,
    height: 22.632,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-247"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2310",
    "data-name": "Rectangle 2310",
    width: 20.296,
    height: 12.967,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2311",
    "data-name": "Rectangle 2311",
    width: 6.096,
    height: 23.052,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2312",
    "data-name": "Rectangle 2312",
    width: 22.972,
    height: 6.963,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2313",
    "data-name": "Rectangle 2313",
    width: 2.221,
    height: 23.81,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-251"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2314",
    "data-name": "Rectangle 2314",
    width: 21.004,
    height: 2.35,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-252"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2315",
    "data-name": "Rectangle 2315",
    width: 21.004,
    height: 1.839,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2316",
    "data-name": "Rectangle 2316",
    width: 16.362,
    height: 4.79,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-254"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2317",
    "data-name": "Rectangle 2317",
    width: 10.977,
    height: 5.724,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-255"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2318",
    "data-name": "Rectangle 2318",
    width: 3.442,
    height: 20.851,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-256"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2319",
    "data-name": "Rectangle 2319",
    width: 6.599,
    height: 17.666,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-257"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2320",
    "data-name": "Rectangle 2320",
    width: 8.649,
    height: 14.984,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-258"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2321",
    "data-name": "Rectangle 2321",
    width: 7.099,
    height: 10.389,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76158",
    "data-name": "Path 76158",
    d: "M100.927,1.078s-1.158,1-3.517,2.657c-2.4,1.6-5.919,3.935-10.4,6.924C78.3,16.928,65.4,25.624,52.407,38.842,39.35,51.881,25.408,68.8,15.3,89.764,5.079,110.6.131,135.942,3.461,160.692A131.047,131.047,0,0,0,13.587,196.2a128.643,128.643,0,0,0,19.333,30.09c15.237,17.664,33.607,29.886,49.951,38.453,8.185,4.344,15.961,7.742,22.9,10.621s13.048,5.664,17.834,8.006a63.816,63.816,0,0,1,10.646,6.3,21.307,21.307,0,0,1,3.109,2.819,1.405,1.405,0,0,0,.928.409h.145a1.437,1.437,0,0,0,.928-2.47,29.223,29.223,0,0,0-3.986-2.461c-2.555-1.456-6.319-3.441-11.191-5.791-4.88-2.427-10.961-5.238-17.851-8.168s-14.6-6.362-22.7-10.723c-16.165-8.619-34.246-20.858-49.125-38.36a126.36,126.36,0,0,1-18.78-29.69,128.487,128.487,0,0,1-9.7-34.928,123.753,123.753,0,0,1,.46-36.179A128.128,128.128,0,0,1,16.977,90.556c9.76-20.815,23.413-37.789,36.256-50.905C66.017,26.313,78.817,17.694,87.445,11.273c4.361-3.134,7.921-5.434,10.212-7.214s3.381-2.853,3.381-2.853a.092.092,0,0,0,.009-.128l-.06-.017-.06.017",
    transform: "translate(-2.43 -1.061)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2325",
    "data-name": "Rectangle 2325",
    width: 137.317,
    height: 274.682,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-262"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2324",
    "data-name": "Rectangle 2324",
    width: 75.885,
    height: 203.303,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76161",
    "data-name": "Path 76161",
    d: "M22.333,0A118.176,118.176,0,0,0,33.039,13.6c8.185,9.122,18.1,7.929,21.531,8.994-.656-2.649-5.068-12.588-12.29-16.122C35.543,3.168,29.734,2.368,22.333,0Z",
    transform: "translate(-22.333)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76162",
    "data-name": "Path 76162",
    d: "M34.932,19.4C40.57,29.467,49.249,35.31,50.773,35.685c-.826-2.393,1.55-13.627-8.21-24.988C38.023,5.722,31.661,2.869,25.444.246,30.2,5.6,31.431,13.166,34.932,19.4",
    transform: "translate(-25.444 -0.246)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76163",
    "data-name": "Path 76163",
    d: "M41.274,17.142c9.445,2.776,17.638-.52,20.56-.945C55.872,8.361,48.556,6.735,38.694,5.653,34.146,5.168,28.184,4.512,23.9,2.885A33.91,33.91,0,0,0,41.274,17.142",
    transform: "translate(-23.9 -2.885)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76164",
    "data-name": "Path 76164",
    d: "M32.316,23.152c1.141,12.179,9.726,16.131,9.726,16.131-.264-2.248,2.768-8.593.511-18.115-1.882-7.9-7.989-14.053-14-19.487,3.586,6.354,2.862,14.189,3.764,21.471",
    transform: "translate(-28.552 -1.681)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76165",
    "data-name": "Path 76165",
    d: "M46.864,16.146c10.416.979,16.625-3.245,17.817-3.262,0,0-5.212-7.887-17.408-7.154-7.342.213-14.862,1.107-21.8-.468,6.294,5.127,13.3,10.127,21.394,10.885",
    transform: "translate(-25.47 -5.261)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76166",
    "data-name": "Path 76166",
    d: "M34.288,35.833C36,41.787,41.9,47.765,41.9,47.765c3.415-4.08,4.463-12.273,4.139-17.332C45.155,16.389,36,11.773,30.8,3.316c2.427,11.123.4,21.829,3.492,32.517",
    transform: "translate(-30.796 -3.316)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76167",
    "data-name": "Path 76167",
    d: "M50,22.856c4.855,1.431,13.278.324,17.6-2.768,0,0-3.858-6.711-9.65-8.9C47.524,7.271,37.866,8.957,27.3,6.964c8.014,5.868,9.241,11.9,22.706,15.892",
    transform: "translate(-27.297 -6.964)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76168",
    "data-name": "Path 76168",
    d: "M35.93,22.405C34.448,27.49,33.051,31.3,33,39.269c-.017,4.139,6.422,14.8,6.422,14.8,1.814-1.925,6.967-7.486,7.955-14.061C49.2,27.822,44.336,16.529,38.885,5.542c.1,5.715-1.346,11.353-2.955,16.863",
    transform: "translate(-33 -5.542)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76169",
    "data-name": "Path 76169",
    d: "M53.914,29.165a34.234,34.234,0,0,0,11.66.5c1.524-.128,2.879-.264,4.045-.264,0,0-4.165-10.033-7.784-12.043-5-2.785-12.545-3-18.141-4.224S33.908,11.679,28.9,8.9c7.188,9.965,14.93,17.783,25.014,20.262",
    transform: "translate(-28.9 -8.903)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76170",
    "data-name": "Path 76170",
    d: "M37.834,31.606c-4.071,11.029-4.591,20.713.7,32.628C40.423,62.284,49,59.1,51.282,43.206c1.763-12.239-2.768-23.873-7.716-34.689-.647,9.326-2.9,15.424-5.732,23.089",
    transform: "translate(-34.673 -8.517)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76171",
    "data-name": "Path 76171",
    d: "M69.184,38.656c-1.124-4.028-1.678-9.658-4.1-13.09-2.4-3.381-7.844-6.711-11.787-7.614-4.216-.962-7.367-1.584-11.634-2.283s-7.52-1.235-11.114-3.7c7.2,14.683,21.335,26.947,38.632,26.692",
    transform: "translate(-30.552 -11.964)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76172",
    "data-name": "Path 76172",
    d: "M40.6,33.255a36.11,36.11,0,0,0-5.263,18.652c-.009,2.64.128,6.26.128,6.26,2.461-2.061,10.655-1,16.506-13.635,4.25-9.828,2.274-21.1,2.419-31.24C51.452,20.863,44.843,26.34,40.6,33.255",
    transform: "translate(-35.338 -13.292)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76173",
    "data-name": "Path 76173",
    d: "M46.536,41.157c6.345,5.289,12.554,5.459,14.487,6.26,1.158-.128.494-10.714.068-11.736-3.679-8.875-15.083-11.8-20.824-14.921A35.366,35.366,0,0,1,31.8,14.712c3.867,8.84,4.139,17.613,14.734,26.445",
    transform: "translate(-31.802 -14.712)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76174",
    "data-name": "Path 76174",
    d: "M43.693,32.7c-4.412,3.918-5.664,8.917-6.916,14.666-.383,1.763-2.112,8.278-2.112,8.278,3.824-1.806,10.033-1.278,15.722-6.958,7.9-7.9,10.578-19.452,11.975-30.431C58.342,24.545,49.9,27.2,43.693,32.7",
    transform: "translate(-34.665 -18.251)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76175",
    "data-name": "Path 76175",
    d: "M36.658,39.528c4.948,14.138,14.734,17.315,15.6,19.027.145.281,3.177-6.66,3.509-14.121.17-4.02-1.652-7.248-4.224-10.288C45.873,27.477,38,24.377,32.212,17.9c1.209,7.231,2.01,14.666,4.446,21.624",
    transform: "translate(-32.212 -17.904)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76176",
    "data-name": "Path 76176",
    d: "M31.866,39.379c-.341,14.9,8.21,22.169,8.312,24.256,0,0,6-5.86,6.754-12.622.588-5.374-.792-10.144-3.041-14.939-3.041-6.464-7.026-8.67-9.428-15.058-.945,5.315-2.47,12.971-2.6,18.362",
    transform: "translate(-31.856 -21.017)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76177",
    "data-name": "Path 76177",
    d: "M43.913,35.1c-3.654,3.356-10.1,12.435-10.987,15.8,3.4-.477,15.611.673,21.258-3.926,7.554-6.141,9.394-15,14.266-24.281C59.626,26.766,50.7,28.861,43.913,35.1",
    transform: "translate(-32.926 -22.695)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76178",
    "data-name": "Path 76178",
    d: "M31.761,41.876c-4.795,19.359,1.141,20.287,2.717,27.1-.017-.111,7.716-5.212,8.892-10.518,1.261-5.706,1.789-11.787.1-17.306-1.823-5.962-3.833-12.809-5.587-17.664-.988,6.4-4.565,12.111-6.124,18.388",
    transform: "translate(-29.926 -23.488)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76179",
    "data-name": "Path 76179",
    d: "M55.542,27.451A30.429,30.429,0,0,0,40.68,32.6a47.464,47.464,0,0,0-10.1,10.655c7.963,1.61,16.778,3.16,23.8-.979,4.727-2.785,7.7-7.657,11.7-11.353,1.329-1.218,2.989-2.027,4.284-3.2a27.27,27.27,0,0,0-6.907-.75c-2.742,0-5.536.247-7.921.485",
    transform: "translate(-30.579 -26.966)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76180",
    "data-name": "Path 76180",
    d: "M28.484,42.62c-1.559,12.409,2.989,16.753,2,18.754,3.816-1.678,10.433-8.2,10.433-8.2C44.1,44.715,37.861,33.805,34.19,26.5c.026-.085.034-.128.017-.128-.213.009-4.727,8.338-5.723,16.25",
    transform: "translate(-28.155 -26.37)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76181",
    "data-name": "Path 76181",
    d: "M42.915,29.47C36,29.981,28.47,39.043,28.47,39.043c3.083.741,6.66,5.229,15.645,4.565,5.715-.443,9.547-3.509,14.657-5.817a33.731,33.731,0,0,1,7-1.84c-1.806-1.891-6.9-4.046-9.334-4.761a57.527,57.527,0,0,0-12.46-1.754c-.383,0-.741.009-1.065.034",
    transform: "translate(-28.47 -29.436)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76182",
    "data-name": "Path 76182",
    d: "M26.448,57.282c0-.043,10.7-3.952,13.269-8.1,1.456-7.4-.656-14.138-5.945-20.611C32.189,36.365,24,45.878,26.448,57.282",
    transform: "translate(-25.996 -28.572)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76183",
    "data-name": "Path 76183",
    d: "M38.075,31.435c-4.761.945-8.023,4.2-12.034,6.916,2.044.468,6.072,4.2,12.154,4.752,5.417.511,9.011-.809,12.409-2.129,3.058-1.175,5.962-2.368,9.914-2.231-2.1-2.691-11.31-7.606-19.257-7.606a16.293,16.293,0,0,0-3.185.3",
    transform: "translate(-26.041 -31.137)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76184",
    "data-name": "Path 76184",
    d: "M30.884,33.6a45.79,45.79,0,0,0-7.444,3.747c2.146.554,5.6,4.292,10.041,5.4a35.276,35.276,0,0,0,11.157.954,19.141,19.141,0,0,1,6.635.46c-4.224-6.481-10.092-10.433-13.712-11.2a11.828,11.828,0,0,0-2.478-.281,10.489,10.489,0,0,0-4.2.92",
    transform: "translate(-23.44 -32.684)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76185",
    "data-name": "Path 76185",
    d: "M28.125,40.974c-5.417,6.737-3.96,12.554-4.752,14.4.162.852,11.549-3.977,12.4-5.51,2.972-5.366,2.734-10.655,2.478-19.64-2.657,3.552-7.095,6.694-10.127,10.748",
    transform: "translate(-23.373 -30.226)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76186",
    "data-name": "Path 76186",
    d: "M21.232,37.522c2.512.528,4.378,2.078,7.776,4.25,3.449,2.189,10.586,3.015,14.283,1.559-2.376-1.456-3.9-3.807-4.974-4.872-2.291-2.265-3.262-4.454-5.987-4.778a7.592,7.592,0,0,0-.775-.043c-4.4,0-10.322,3.884-10.322,3.884",
    transform: "translate(-21.232 -33.638)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76187",
    "data-name": "Path 76187",
    d: "M26.934,40.743c-3.194,2.9-5.706,7.1-5.74,11.421,0-.026,11.889-4.65,11.924-4.659A21.955,21.955,0,0,0,36.056,31.7c-3.441,3.756-5.928,6.132-9.122,9.045",
    transform: "translate(-21.194 -31.698)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-294"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2357",
    "data-name": "Rectangle 2357",
    width: 14.838,
    height: 26.091,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-296"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2359",
    "data-name": "Rectangle 2359",
    width: 15.259,
    height: 28.625,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-298"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2361",
    "data-name": "Rectangle 2361",
    width: 33.904,
    height: 9.224,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2362",
    "data-name": "Rectangle 2362",
    width: 31.092,
    height: 10.261,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-301"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2364",
    "data-name": "Rectangle 2364",
    width: 27.991,
    height: 18.656,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-302"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2365",
    "data-name": "Rectangle 2365",
    width: 23.568,
    height: 21.845,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-303"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2366",
    "data-name": "Rectangle 2366",
    width: 23.517,
    height: 24.907,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2367",
    "data-name": "Rectangle 2367",
    width: 12.601,
    height: 30.183,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2368",
    "data-name": "Rectangle 2368",
    width: 25.691,
    height: 13.574,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-306"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2369",
    "data-name": "Rectangle 2369",
    width: 14.547,
    height: 31.21,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-309"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2372",
    "data-name": "Rectangle 2372",
    width: 25.464,
    height: 6.545,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-319"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2382",
    "data-name": "Rectangle 2382",
    width: 19.429,
    height: 2.452,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2383",
    "data-name": "Rectangle 2383",
    width: 3.84,
    height: 19.151,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-321"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2384",
    "data-name": "Rectangle 2384",
    width: 3.962,
    height: 23.012,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-322"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2385",
    "data-name": "Rectangle 2385",
    width: 19.398,
    height: 1.467,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-324"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2387",
    "data-name": "Rectangle 2387",
    width: 2.39,
    height: 24.865,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-325"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2388",
    "data-name": "Rectangle 2388",
    width: 24.058,
    height: 7.379,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2393",
    "data-name": "Rectangle 2393",
    width: 18.641,
    height: 19.58,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-331"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2394",
    "data-name": "Rectangle 2394",
    width: 14.622,
    height: 22.632,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2396",
    "data-name": "Rectangle 2396",
    width: 6.095,
    height: 23.052,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-334"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2397",
    "data-name": "Rectangle 2397",
    width: 22.971,
    height: 6.963,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2398",
    "data-name": "Rectangle 2398",
    width: 2.222,
    height: 23.81,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2399",
    "data-name": "Rectangle 2399",
    width: 21.003,
    height: 2.35,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-337"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2400",
    "data-name": "Rectangle 2400",
    width: 21.003,
    height: 1.839,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-341"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2404",
    "data-name": "Rectangle 2404",
    width: 6.598,
    height: 17.666,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76241",
    "data-name": "Path 76241",
    d: "M58.106,1.078a.092.092,0,0,0,.009.128s1.1,1.073,3.381,2.853,5.851,4.08,10.212,7.214c8.628,6.422,21.428,15.041,34.221,28.378,12.835,13.116,26.487,30.09,36.248,50.905a127.809,127.809,0,0,1,10.484,33.573,123.752,123.752,0,0,1,.46,36.179,128.473,128.473,0,0,1-9.692,34.928,126.664,126.664,0,0,1-18.788,29.69c-14.87,17.5-32.96,29.741-49.125,38.36-8.091,4.361-15.807,7.8-22.7,10.723s-12.963,5.74-17.843,8.168c-4.872,2.351-8.636,4.335-11.208,5.791a30.131,30.131,0,0,0-3.977,2.461,1.45,1.45,0,0,0-.017,2.044,1.426,1.426,0,0,0,.945.426h.153a1.423,1.423,0,0,0,.928-.409,20.2,20.2,0,0,1,3.1-2.819,64.179,64.179,0,0,1,10.646-6.3c4.786-2.342,10.9-5.119,17.834-8.006s14.717-6.277,22.91-10.621c16.335-8.568,34.706-20.79,49.943-38.453a128.671,128.671,0,0,0,19.342-30.09,131.032,131.032,0,0,0,10.118-35.507c3.339-24.75-1.618-50.1-11.838-70.928C133.744,68.8,119.8,51.881,106.746,38.842,93.757,25.624,80.854,16.928,72.133,10.659c-4.471-2.989-7.98-5.323-10.382-6.924-2.359-1.652-3.526-2.657-3.526-2.657l-.06-.017-.06.017",
    transform: "translate(-19.358 -1.061)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-348"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 267,
    height: 61,
    rx: 30.5,
    transform: "translate(103 4554)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6515",
    "data-name": "Group 6515",
    transform: "translate(-4682.173 -5008.447)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Star_performer_award",
    "data-name": "Star performer award",
    transform: "translate(4843.173 5122)",
    fill: "#121111",
    fontSize: 18,
    fontFamily: "'Manrope', sans-serif",
    fontWeight: 600,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -65.502,
    y: 0
  }, "Star performer"), /*#__PURE__*/React.createElement("tspan", {
    x: -26.5,
    y: 24
  }, "award"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "By_siddhashila_and_ADI_group",
    "data-name": "By siddhashila and ADI group",
    transform: "translate(4843.173 5244)",
    fill: "#121111",
    fontSize: 14,
    fontFamily: "'Manrope', sans-serif",
    fontWeight: 600,
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -64.061,
    y: 0
  }, "By siddhashila and"), /*#__PURE__*/React.createElement("tspan", {
    x: -33.534,
    y: 17
  }, "ADI group"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776",
    transform: "translate(4682.173 5015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2395",
    "data-name": "Group 2395"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1934",
    "data-name": "Group 1934",
    transform: "translate(100.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 39.438,
    height: 37.142,
    transform: "matrix(0.818, -0.576, 0.576, 0.818, -10.701, 7.533)",
    fill: "#182a51"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1936",
    "data-name": "Group 1936",
    transform: "translate(80.901 2.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1935",
    "data-name": "Group 1935",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1214",
    "data-name": "Rectangle 1214",
    width: 43.143,
    height: 44.456,
    transform: "matrix(0.78, -0.626, 0.626, 0.78, -18.844, 13.905)",
    fill: "#182a51"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1938",
    "data-name": "Group 1938",
    transform: "translate(81.446 24.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1937",
    "data-name": "Group 1937",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 38.001,
    height: 39.629,
    transform: "translate(-8.465 9.458) rotate(-48.158)",
    fill: "#182a51"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    "data-name": "Group 1940",
    transform: "translate(64.919 14.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1939",
    "data-name": "Group 1939",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1216",
    "data-name": "Rectangle 1216",
    width: 34.386,
    height: 40.305,
    transform: "matrix(0.832, -0.555, 0.555, 0.832, -18.772, 11.574)",
    fill: "#182a51"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942",
    transform: "translate(66.797 44.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 30.53,
    height: 39.888,
    transform: "matrix(0.513, -0.858, 0.858, 0.513, -5.341, 8.676)",
    fill: "#182a51"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944",
    transform: "translate(45.347 28.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 41.103,
    height: 43.615,
    transform: "matrix(0.749, -0.662, 0.662, 0.749, -22.32, 19.496)",
    fill: "#182a51"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1946",
    "data-name": "Group 1946",
    transform: "translate(50.147 59.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1945",
    "data-name": "Group 1945",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 33.068,
    height: 43.828,
    transform: "matrix(0.433, -0.901, 0.901, 0.433, -6.762, 14.079)",
    fill: "#182a51"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1948",
    "data-name": "Group 1948",
    transform: "translate(27.112 47.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 48.309,
    height: 42.532,
    transform: "matrix(0.612, -0.791, 0.791, 0.612, -24.927, 30.35)",
    fill: "#182a51"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950",
    transform: "translate(36.077 75.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    width: 27.674,
    height: 43.643,
    transform: "matrix(0.162, -0.987, 0.987, 0.162, -3.418, 20.794)",
    fill: "#182a51"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952",
    transform: "translate(10.636 72.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 59.13,
    height: 37.565,
    transform: "matrix(0.34, -0.94, 0.94, 0.34, -19.184, 49.281)",
    fill: "#182a51"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1954",
    "data-name": "Group 1954",
    transform: "translate(24.094 101.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 38.632,
    height: 26.947,
    transform: "translate(0 0.004)",
    fill: "#182a51"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1956",
    "data-name": "Group 1956",
    transform: "translate(2.578 113.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1955",
    "data-name": "Group 1955",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1224",
    "data-name": "Rectangle 1224",
    width: 47.925,
    height: 28.702,
    transform: "translate(-9.518 43.396) rotate(-79.526)",
    fill: "#182a51"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1958",
    "data-name": "Group 1958",
    transform: "translate(22.213 125.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 38.772,
    height: 40.289,
    transform: "translate(-9.849 2.932) rotate(-17.413)",
    fill: "#182a51"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960",
    transform: "translate(0 155.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1959",
    "data-name": "Group 1959",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1226",
    "data-name": "Rectangle 1226",
    width: 36.727,
    height: 43.458,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, -9.68, 2.706)",
    fill: "#182a51"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1962",
    "data-name": "Group 1962",
    transform: "translate(25.02 152.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1227",
    "data-name": "Rectangle 1227",
    width: 37.398,
    height: 46.855,
    transform: "matrix(0.926, -0.377, 0.377, 0.926, -14.442, 5.812)",
    fill: "#182a51"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1964",
    "data-name": "Group 1964",
    transform: "translate(36.41 178.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 36.738,
    height: 44.413,
    transform: "matrix(0.836, -0.548, 0.548, 0.836, -19.991, 12.809)",
    fill: "#182a51"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1966",
    "data-name": "Group 1966",
    transform: "translate(6.984 193.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1965",
    "data-name": "Group 1965",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1229",
    "data-name": "Rectangle 1229",
    width: 44.06,
    height: 40.584,
    transform: "translate(-10.496 4.527) rotate(-23.311)",
    fill: "#182a51"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1968",
    "data-name": "Group 1968",
    transform: "translate(53.453 200.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1967",
    "data-name": "Group 1967",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1230",
    "data-name": "Rectangle 1230",
    width: 46.1,
    height: 43.797,
    transform: "translate(-23.197 25.457) rotate(-48.419)",
    fill: "#182a51"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970",
    transform: "translate(22.706 229.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1969",
    "data-name": "Group 1969",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1231",
    "data-name": "Rectangle 1231",
    width: 43.665,
    height: 38.996,
    transform: "matrix(0.812, -0.583, 0.583, 0.812, -9.21, 6.613)",
    fill: "#182a51"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972",
    transform: "translate(69.505 224.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1232",
    "data-name": "Rectangle 1232",
    width: 38.987,
    height: 30.652,
    transform: "translate(-15.986 28.425) rotate(-64.299)",
    fill: "#182a51"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1974",
    "data-name": "Group 1974",
    transform: "translate(43.155 250.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1973",
    "data-name": "Group 1973",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1233",
    "data-name": "Rectangle 1233",
    width: 38.927,
    height: 33.87,
    transform: "translate(-7.042 5.091) rotate(-35.842)",
    fill: "#182a51"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976",
    transform: "translate(87.36 243.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1975",
    "data-name": "Group 1975",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1234",
    "data-name": "Rectangle 1234",
    width: 32.862,
    height: 25.988,
    transform: "translate(-10.263 25.333) rotate(-69.928)",
    fill: "#182a51"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1978",
    "data-name": "Group 1978",
    transform: "translate(66.67 265.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1235",
    "data-name": "Rectangle 1235",
    width: 30.359,
    height: 35.225,
    transform: "translate(-5.933 8.17) rotate(-53.998)",
    fill: "#182a51"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980",
    transform: "translate(95.474 278.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1236",
    "data-name": "Rectangle 1236",
    width: 25.369,
    height: 29.385,
    transform: "matrix(0.574, -0.819, 0.819, 0.574, -5.394, 7.708)",
    fill: "#182a51"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982",
    transform: "translate(108.847 257.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1981",
    "data-name": "Group 1981",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 29.715,
    height: 23.37,
    transform: "translate(-8.081 23.452) rotate(-71.735)",
    fill: "#182a51"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1984",
    "data-name": "Group 1984",
    transform: "translate(120.045 286.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 23.03,
    height: 23.863,
    transform: "translate(-5.542 6.179) rotate(-48.093)",
    fill: "#182a51"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1986",
    "data-name": "Group 1986",
    transform: "translate(127.166 269.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1985",
    "data-name": "Group 1985",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1239",
    "data-name": "Rectangle 1239",
    width: 23.431,
    height: 20.067,
    transform: "translate(-5.069 19.53) rotate(-77.625)",
    fill: "#182a51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989",
    transform: "translate(100.521 -0.004)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75427",
    "data-name": "Path 75427",
    d: "M24.059,8.057C30.974,4.08,37.839,3.381,44.005,0,36.613,2.376,30.8,3.168,24.059,6.473,16.9,9.973,12.527,19.751,11.8,22.493c1.542-3.739,6.243-10.978,12.256-14.436",
    transform: "translate(-11.8)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992",
    transform: "translate(81.394 2.091)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75428",
    "data-name": "Path 75428",
    d: "M17.273,12.289C21.412,7.306,29.674,3.057,34.281.416c.043-.051.068-.119.111-.17C28.175,2.869,21.821,5.714,17.273,10.7A31.655,31.655,0,0,0,9.557,28.556s2.189-9.607,7.716-16.267",
    transform: "translate(-9.556 -0.246)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995",
    transform: "translate(86.868 24.568)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1993",
    "data-name": "Group 1993",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75429",
    "data-name": "Path 75429",
    d: "M27.958,6.574c4.556-.485,11.481-1.806,14.751-3.688C38.433,4.513,32.472,5.16,27.915,5.645c-7.069.767-12.826,1.882-17.715,5.306,5.076-2.538,11.157-3.662,17.758-4.378",
    transform: "translate(-10.197 -2.878)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998",
    transform: "translate(64.926 14.309)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75430",
    "data-name": "Path 75430",
    d: "M9.114,21.048C12.061,12.736,17.231,7.992,22.46,1.681c-6.021,5.442-12.128,11.591-14,19.5a30.668,30.668,0,0,0-.835,6.592,27.71,27.71,0,0,1,1.49-6.72",
    transform: "translate(-7.618 -1.678)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "translate(72.793 44.884)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75431",
    "data-name": "Path 75431",
    d: "M21.569,6.855c6.694.2,15.032-.077,19.674-1.584-6.8,1.414-14.121.6-21.275.383A21.574,21.574,0,0,0,8.547,7.92,35.99,35.99,0,0,1,21.569,6.855",
    transform: "translate(-8.546 -5.267)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004",
    transform: "translate(45.392 28.243)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75432",
    "data-name": "Path 75432",
    d: "M20.591,3.317C15.379,11.774,6.231,16.39,5.337,30.426c-.026.451.017,1.022.017,1.516C6.283,17.957,18.164,11.331,20.591,3.317",
    transform: "translate(-5.335 -3.314)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007",
    transform: "translate(55.953 59.313)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75433",
    "data-name": "Path 75433",
    d: "M15,10.652c10.953-1.976,20.159-.528,26.061-3.688C30.494,8.948,20.836,7.271,10.42,11.2a14.336,14.336,0,0,0-3.85,2.24A33.448,33.448,0,0,1,15,10.652",
    transform: "translate(-6.567 -6.97)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(42.897 75.826)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75434",
    "data-name": "Path 75434",
    d: "M24.336,14.244c5.6-1.235,11.4-2.453,14.6-5.34-5.008,2.776-9.2,3-14.794,4.224S11.007,14.576,6,17.361a5.832,5.832,0,0,0-.962.767c5.025-2.725,13.738-2.657,19.3-3.884",
    transform: "translate(-5.034 -8.901)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(31.636 101.893)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75435",
    "data-name": "Path 75435",
    d: "M12.129,18.956c4.216-.962,7.81-1.346,12.068-2.053s7.759-1.925,10.612-4.94c-3.6,2.47-6.856,3-11.123,3.7S16.276,17,12.06,17.951a23.612,23.612,0,0,0-8.346,4.275,35.182,35.182,0,0,1,8.415-3.27",
    transform: "translate(-3.718 -11.966)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016",
    transform: "translate(2.911 113.212)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75436",
    "data-name": "Path 75436",
    d: "M18.524,44.516a35.678,35.678,0,0,0-4.386-11.268C9.888,26.341,3.288,20.856.341,13.293,2.368,22.236,9.394,28.18,13.636,35.1a61.217,61.217,0,0,1,4.889,9.42",
    transform: "translate(-0.348 -13.295)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(24.084 125.301)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75437",
    "data-name": "Path 75437",
    d: "M22.357,22.344a23.716,23.716,0,0,0,8.466-7.631,35.366,35.366,0,0,1-8.466,6.047c-5.2,2.828-14.981,5.536-19.529,12.6,5.05-6.064,14.649-8.372,19.529-11.021",
    transform: "translate(-2.826 -14.71)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(0 155.443)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75438",
    "data-name": "Path 75438",
    d: "M18.669,34.281a26.7,26.7,0,0,1,4.9,5.817,17.874,17.874,0,0,0-4.9-7.4C12.46,27.195,4.011,24.537,0,18.252,3.211,25.44,12.46,28.779,18.669,34.281",
    transform: "translate(0 -18.25)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    transform: "translate(25.075 152.481)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75439",
    "data-name": "Path 75439",
    d: "M9.357,33.413c6.456-5.928,14.308-8.27,17.1-15.509C20.668,24.385,12.8,27.468,7.126,34.154c-2.265,2.674-3.892,5.51-4.182,8.662a24.336,24.336,0,0,1,6.413-9.4",
    transform: "translate(-2.946 -17.904)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028",
    transform: "translate(36.413 178.996)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75440",
    "data-name": "Path 75440",
    d: "M4.449,51.2A32.086,32.086,0,0,1,8.375,36.884c2.768-4.616,8.355-9.547,8.5-15.867-2.4,6.4-6.388,8.593-9.428,15.066C5.2,40.878,3.818,45.639,4.415,51.013a1.221,1.221,0,0,0,.034.187",
    transform: "translate(-4.273 -21.019)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(6.983 193.288)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75441",
    "data-name": "Path 75441",
    d: "M25.357,35.1C18.569,28.861,9.643,26.775.82,22.695c6.728,5.434,18.516,8.364,25.687,13.576-.4-.426-.792-.843-1.15-1.167",
    transform: "translate(-0.819 -22.698)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(53.455 200.044)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75442",
    "data-name": "Path 75442",
    d: "M7.857,42.873C9.68,36.912,11.076,32.6,12.831,27.756c1.5,5.97,4.8,11.319,6.362,17.6a57.008,57.008,0,0,1,1.618,9.334,49.019,49.019,0,0,0-1.763-12.826c-1.559-6.277-5.136-11.983-6.124-18.379-1.754,4.855-3.764,11.7-5.587,17.664a30.394,30.394,0,0,0-.664,13.039A31.874,31.874,0,0,1,7.857,42.873",
    transform: "translate(-6.276 -23.486)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037",
    transform: "translate(22.703 229.663)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75443",
    "data-name": "Path 75443",
    d: "M20.976,29.267a102.116,102.116,0,0,1,10.05,2.53A31.21,31.21,0,0,0,17.5,27.453C12.987,27,7.06,26.524,2.665,27.717l.2.145a89.042,89.042,0,0,1,18.115,1.405",
    transform: "translate(-2.671 -26.969)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040",
    transform: "translate(69.588 224.592)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75444",
    "data-name": "Path 75444",
    d: "M15.7,28.969c-.409-1.15,4.088,6.422,5.732,14.146-.017-.17-.017-.315-.034-.494-1.065-8.457-6.158-17.391-5.706-16.131-2.981,5.928-7.546,14.189-7.52,21.616.613-6.7,4.786-13.678,7.529-19.137",
    transform: "translate(-8.168 -26.37)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043",
    transform: "translate(43.156 250.704)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75445",
    "data-name": "Path 75445",
    d: "M30.532,30.025a10.248,10.248,0,0,0-2.615-.554,53.264,53.264,0,0,0-13.508,1.72c-2.436.715-7.537,2.862-9.343,4.752l.23.034c4.914-3.764,19.444-6.013,25.235-5.953",
    transform: "translate(-5.068 -29.436)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046",
    transform: "translate(87.458 243.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75446",
    "data-name": "Path 75446",
    d: "M16.247,31.323c1.15,3.032,3.236,5.953,5.068,9.258C19.458,36.2,17.3,32.192,16.57,28.572c-4.2,5.144-6.3,10.476-6.3,16.148.332-4.65,2.231-8.806,5.979-13.4",
    transform: "translate(-10.275 -28.574)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(66.671 265.187)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75447",
    "data-name": "Path 75447",
    d: "M30.679,31.572c-.145-.034-.256-.1-.4-.136-8.474-1.695-20.057,4.25-22.45,7.316l.06.009c3.483-2.9,14.768-7.18,22.791-7.188",
    transform: "translate(-7.83 -31.14)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    transform: "translate(96.451 278.389)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75448",
    "data-name": "Path 75448",
    d: "M26.34,32.949a7.764,7.764,0,0,1,.928-.23,11.114,11.114,0,0,0-3.219.23c-3.356.707-8.6,4.267-12.724,9.939,4.633-5.2,12.017-8.755,15.015-9.939",
    transform: "translate(-11.322 -32.689)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055",
    transform: "translate(108.601 257.028)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75449",
    "data-name": "Path 75449",
    d: "M13.875,32.854c3.432,3.781,7.784,6.456,10.816,10.493A20.525,20.525,0,0,0,23,40.928c-3.041-4.054-7.469-7.188-10.127-10.748-.2,7.018-.332,11.77,1.014,16.08-.715-4.548-.341-9-.017-13.405",
    transform: "translate(-12.753 -30.175)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058",
    transform: "translate(120.043 286.525)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75450",
    "data-name": "Path 75450",
    d: "M25.694,33.656c-.2.008-.426-.026-.63-.009-2.725.324-3.7,2.521-5.987,4.778C18,39.49,16.479,41.849,14.094,43.3a34.1,34.1,0,0,0,5.468-3.781c1.865-1.848,3.5-4.718,6.132-5.86",
    transform: "translate(-14.101 -33.645)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061",
    transform: "translate(127.568 269.965)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75451",
    "data-name": "Path 75451",
    d: "M24.909,42.336a21.864,21.864,0,0,1,3.458,4.114A18.985,18.985,0,0,0,24.1,40.743c-3.185-2.913-5.681-5.289-9.122-9.045,2.47,4.574,6.737,7.725,9.931,10.638",
    transform: "translate(-14.981 -31.7)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064",
    transform: "translate(27.133 47.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75452",
    "data-name": "Path 75452",
    d: "M11.293,10.08a56.232,56.232,0,0,0,4.948,16.65c-.383-1.414-.8-2.819-1.243-4.318-1.61-5.5-3.058-11.14-2.947-16.872C7.238,15.259,2.895,25.2,3.2,35.776c.332-9,3.764-16.957,8.091-25.7",
    transform: "translate(-3.182 -5.538)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    transform: "translate(10.663 72.537)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75453",
    "data-name": "Path 75453",
    d: "M8.95,12.351c.307,8.687,4.931,16.957,7.767,24.554a54.7,54.7,0,0,0-1.661-5.3C12.229,23.933,9.98,17.835,9.342,8.518c-4.4,9.607-8.449,19.87-8.065,30.635.3-9.428,3.7-18.115,7.674-26.8",
    transform: "translate(-1.259 -8.513)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(84.16 17.302)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75454",
    "data-name": "Path 75454",
    d: "M18.68,2.032a28.758,28.758,0,0,0-1.184,2.8l-2.342,6.277a42.785,42.785,0,0,1-2.87,6.09,18.633,18.633,0,0,1-1.763,2.555l-.639-.562a17.636,17.636,0,0,0,1.789-2.368,43.141,43.141,0,0,0,3.092-5.885c.945-2.24,1.9-4.48,2.615-6.158a29.684,29.684,0,0,1,1.3-2.751",
    transform: "translate(-9.879 -2.032)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2073",
    "data-name": "Group 2073",
    transform: "translate(84.475 32.837)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75455",
    "data-name": "Path 75455",
    d: "M29.346,3.856a27.1,27.1,0,0,1-3.023.307c-1.823.094-4.25.221-6.686.349a41.318,41.318,0,0,0-6.566.9,17.05,17.05,0,0,0-2.836.894l-.315-.792a17.667,17.667,0,0,1,3-.809,42.621,42.621,0,0,1,6.7-.622c2.436-.017,4.872-.043,6.694-.06a26.2,26.2,0,0,0,3.032-.17",
    transform: "translate(-9.916 -3.856)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    transform: "translate(68.537 30.186)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75456",
    "data-name": "Path 75456",
    d: "M11.888,3.545c-.2-.034-.767,4.761-1.014,9.607a37.444,37.444,0,0,1-1,6.626A14.431,14.431,0,0,1,8.8,22.7l-.749-.409A13.18,13.18,0,0,0,9.18,19.583a36.586,36.586,0,0,0,1.269-6.473c.46-4.812,1.235-9.616,1.439-9.564",
    transform: "translate(-8.049 -3.544)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(50.026 48.612)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75457",
    "data-name": "Path 75457",
    d: "M9.834,5.708a21.707,21.707,0,0,0-.647,3.56c-.247,2.163-.3,5.059-.46,7.963a45.732,45.732,0,0,1-1.014,7.963A27.838,27.838,0,0,1,6.666,28.72l-.792-.315a26.227,26.227,0,0,0,1.141-3.381A45.447,45.447,0,0,0,8.3,17.206c.264-2.887.426-5.791.758-7.955a21.515,21.515,0,0,1,.775-3.543",
    transform: "translate(-5.872 -5.711)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(68.209 49.203)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75458",
    "data-name": "Path 75458",
    d: "M27.4,6.632c.017.213-4.855.162-9.675-.2a37.84,37.84,0,0,0-6.592.162,13.158,13.158,0,0,0-2.853.656l-.273-.809a13.972,13.972,0,0,1,3.049-.562,37.654,37.654,0,0,1,6.7.136c4.821.571,9.633.835,9.641.622",
    transform: "translate(-8.006 -5.777)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085",
    transform: "translate(50.649 67.615)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75459",
    "data-name": "Path 75459",
    d: "M28.959,7.939a21.515,21.515,0,0,1-3.543.775c-2.163.332-5.068.5-7.955.767a45.2,45.2,0,0,0-7.81,1.286,26.8,26.8,0,0,0-3.39,1.15l-.315-.792a27.838,27.838,0,0,1,3.526-1.048,45.783,45.783,0,0,1,7.963-1.022c2.9-.162,5.8-.221,7.963-.468a21.708,21.708,0,0,0,3.56-.647",
    transform: "translate(-5.946 -7.943)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    transform: "translate(34.726 69.104)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75460",
    "data-name": "Path 75460",
    d: "M4.125,8.114A25.644,25.644,0,0,0,4.3,12c.256,2.325.843,5.383,1.346,8.466a55,55,0,0,1,.818,8.576,31.078,31.078,0,0,1-.221,3.935L5.4,32.864a31.4,31.4,0,0,0,.349-3.833,55.19,55.19,0,0,0-.52-8.508c-.4-3.083-.886-6.175-1.056-8.508a25.844,25.844,0,0,1-.051-3.9",
    transform: "translate(-4.077 -8.117)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2091",
    "data-name": "Group 2091",
    transform: "translate(36.572 86.724)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75461",
    "data-name": "Path 75461",
    d: "M28.354,10.183a24.987,24.987,0,0,1-3.679,1.3c-2.248.656-5.314,1.26-8.346,1.967a53.153,53.153,0,0,0-8.159,2.461,32.456,32.456,0,0,0-3.475,1.644l-.4-.749a32.047,32.047,0,0,1,3.62-1.567,53.768,53.768,0,0,1,8.329-2.206c3.066-.6,6.132-1.107,8.4-1.678a25.514,25.514,0,0,0,3.713-1.175",
    transform: "translate(-4.295 -10.185)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094",
    transform: "translate(17.998 97.72)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2093",
    "data-name": "Group 2093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2092",
    "data-name": "Group 2092",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75462",
    "data-name": "Path 75462",
    d: "M2.113,11.474a23.08,23.08,0,0,0,.843,4.395C3.663,18.458,5,21.788,6.193,25.178a47.233,47.233,0,0,1,2.461,9.59A30.013,30.013,0,0,1,8.918,39.3l-.852-.034a28.985,28.985,0,0,0-.128-4.412,46.812,46.812,0,0,0-2.155-9.547C4.7,21.9,3.459,18.517,2.828,15.9a22.579,22.579,0,0,1-.715-4.429",
    transform: "translate(-2.115 -11.477)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2097",
    "data-name": "Group 2097",
    transform: "translate(24.798 111.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75463",
    "data-name": "Path 75463",
    d: "M28.47,13.073a22.769,22.769,0,0,1-3.824,2.334c-2.4,1.226-5.774,2.487-9.07,3.875a46.476,46.476,0,0,0-8.645,4.582A27.959,27.959,0,0,0,3.49,26.649l-.579-.639a28.648,28.648,0,0,1,3.611-2.734A47,47,0,0,1,15.414,18.9c3.347-1.3,6.745-2.453,9.173-3.611a22.771,22.771,0,0,0,3.884-2.214",
    transform: "translate(-2.916 -13.077)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2100",
    "data-name": "Group 2100",
    transform: "translate(8.828 131.828)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2098",
    "data-name": "Group 2098",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75464",
    "data-name": "Path 75464",
    d: "M1.036,15.479a15.985,15.985,0,0,0,1.78,3.79c1.32,2.155,3.543,4.693,5.587,7.376a30.622,30.622,0,0,1,4.642,8.065,22.539,22.539,0,0,1,1.1,4.139l-.843.128a22.191,22.191,0,0,0-.928-4.028,29.948,29.948,0,0,0-4.3-8.057c-1.959-2.725-4.114-5.34-5.366-7.554a15.336,15.336,0,0,1-1.669-3.858",
    transform: "translate(-1.04 -15.479)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103",
    transform: "translate(21.595 138.189)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2101",
    "data-name": "Group 2101",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75465",
    "data-name": "Path 75465",
    d: "M24.2,16.226a15.723,15.723,0,0,1-3.126,2.811c-2.061,1.482-5.11,2.964-8.023,4.625A30.126,30.126,0,0,0,5.771,29.18,22.359,22.359,0,0,0,3.25,32.459l-.715-.468a22.921,22.921,0,0,1,2.717-3.3,30.675,30.675,0,0,1,7.588-5.4C15.83,21.711,18.9,20.34,21,18.926a15.325,15.325,0,0,0,3.2-2.7",
    transform: "translate(-2.54 -16.225)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106",
    transform: "translate(8.817 170.829)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75466",
    "data-name": "Path 75466",
    d: "M1.035,20.058a15.7,15.7,0,0,0,2.691,3.211c1.823,1.746,4.616,3.628,7.29,5.7a30.478,30.478,0,0,1,6.549,6.618,23.006,23.006,0,0,1,2.112,3.722l-.784.332a22.412,22.412,0,0,0-1.925-3.654A29.963,29.963,0,0,0,10.744,29.3c-2.581-2.138-5.332-4.122-7.112-5.936a15.621,15.621,0,0,1-2.6-3.3",
    transform: "translate(-1.037 -20.061)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109",
    transform: "translate(26.936 166.886)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75467",
    "data-name": "Path 75467",
    d: "M17.785,19.6a15.281,15.281,0,0,1-1.925,3.739c-1.388,2.121-3.713,4.591-5.843,7.188a30.223,30.223,0,0,0-4.829,7.75A22.319,22.319,0,0,0,4,42.224l-.835-.179a23.355,23.355,0,0,1,1.363-4.054,30.67,30.67,0,0,1,5.17-7.75c2.223-2.538,4.608-4.914,6.064-6.984A15.288,15.288,0,0,0,17.785,19.6",
    transform: "translate(-3.168 -19.598)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112",
    transform: "translate(20.976 206.611)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75468",
    "data-name": "Path 75468",
    d: "M2.463,24.26a13.1,13.1,0,0,0,3.015,2.18c1.959,1.1,4.795,2.061,7.563,3.228a26.086,26.086,0,0,1,7.112,4.267,19.785,19.785,0,0,1,2.606,2.785l-.681.5a19.662,19.662,0,0,0-2.41-2.751,25.076,25.076,0,0,0-6.8-4.412c-2.708-1.252-5.527-2.325-7.461-3.5a13.273,13.273,0,0,1-2.947-2.3",
    transform: "translate(-2.462 -24.257)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2115",
    "data-name": "Group 2115",
    transform: "translate(40.588 196.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75469",
    "data-name": "Path 75469",
    d: "M10.856,23.035a13.144,13.144,0,0,1-.537,3.7c-.571,2.18-1.857,4.914-2.938,7.691a25.23,25.23,0,0,0-1.84,7.887,19.46,19.46,0,0,0,.179,3.662l-.843.111a20.218,20.218,0,0,1-.051-3.816A25.779,25.779,0,0,1,6.99,34.269c1.184-2.759,2.555-5.417,3.2-7.571a12.854,12.854,0,0,0,.664-3.662",
    transform: "translate(-4.763 -23.038)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118",
    transform: "translate(38.224 237.135)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75470",
    "data-name": "Path 75470",
    d: "M4.488,27.844A13.21,13.21,0,0,0,8,29.1c2.18.511,5.178.639,8.159.988a25.757,25.757,0,0,1,8.023,2.1,20.1,20.1,0,0,1,3.279,1.942l-.511.681a19.344,19.344,0,0,0-3.083-1.976A25.355,25.355,0,0,0,16.1,30.5c-2.938-.443-5.953-.69-8.134-1.278a12.945,12.945,0,0,1-3.475-1.38",
    transform: "translate(-4.488 -27.84)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121",
    transform: "translate(59.656 220.036)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75471",
    "data-name": "Path 75471",
    d: "M8.011,25.836a12.888,12.888,0,0,1,.477,3.7c.043,2.265-.468,5.238-.758,8.2a25.007,25.007,0,0,0,.341,8.1,19.233,19.233,0,0,0,1.158,3.475l-.792.332a19.981,19.981,0,0,1-1.065-3.662A25.734,25.734,0,0,1,7.3,37.7c.4-2.981,1.014-5.911,1.056-8.159a12.958,12.958,0,0,0-.349-3.7",
    transform: "translate(-7.001 -25.836)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124",
    transform: "translate(58.348 256.311)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75472",
    "data-name": "Path 75472",
    d: "M6.851,30.731a26.438,26.438,0,0,0,3.287.026c1.976-.068,4.582-.434,7.231-.6a25.331,25.331,0,0,1,7.282.511,21.69,21.69,0,0,1,3.2.988l-.332.784a23.8,23.8,0,0,0-10.144-1.857c-2.615.051-5.255.315-7.231.307a27.373,27.373,0,0,1-3.3-.162",
    transform: "translate(-6.85 -30.094)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127",
    transform: "translate(78.675 269.51)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75473",
    "data-name": "Path 75473",
    d: "M9.238,33.475a27.18,27.18,0,0,0,3.279-.264c1.959-.238,4.522-.835,7.146-1.226a25.329,25.329,0,0,1,7.307-.136,21.926,21.926,0,0,1,3.27.707l-.256.809a23.842,23.842,0,0,0-10.271-.954c-2.606.281-5.2.775-7.18.937a26.141,26.141,0,0,1-3.3.128",
    transform: "translate(-9.235 -31.643)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130",
    transform: "translate(104.886 280.859)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75474",
    "data-name": "Path 75474",
    d: "M12.315,37.765a19.551,19.551,0,0,0,2.529-.843c1.456-.664,3.407-1.55,5.349-2.436a18.134,18.134,0,0,1,8.483-1.465l-.085.843a17.362,17.362,0,0,0-8.244,1.022l-5.459,2.155a17.967,17.967,0,0,1-2.572.724",
    transform: "translate(-12.316 -32.973)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133",
    transform: "translate(127.258 288.074)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2132",
    "data-name": "Group 2132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2131",
    "data-name": "Group 2131",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75475",
    "data-name": "Path 75475",
    d: "M14.942,39.548a13.221,13.221,0,0,0,1.661-.962L20.027,36.1a13.155,13.155,0,0,1,5.817-2.274l.077.852a12.258,12.258,0,0,0-5.664,1.78c-1.3.818-2.606,1.635-3.586,2.24a13.107,13.107,0,0,1-1.729.852",
    transform: "translate(-14.942 -33.822)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(75.742 237.261)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75476",
    "data-name": "Path 75476",
    d: "M8.893,27.858a26.454,26.454,0,0,1,.434,3.27c.179,1.967.136,4.616.307,7.239a23.889,23.889,0,0,0,2.7,9.948l-.758.392A22.768,22.768,0,0,1,10.324,45.6a25.309,25.309,0,0,1-1.116-7.214c-.06-2.649.085-5.28-.009-7.248a26.826,26.826,0,0,0-.307-3.279",
    transform: "translate(-8.895 -27.861)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(92.861 253.276)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75477",
    "data-name": "Path 75477",
    d: "M10.9,29.739a22.666,22.666,0,0,1,.954,2.759c.417,1.695.979,3.969,1.542,6.226A20.945,20.945,0,0,0,17.5,46.866l-.664.537a21.726,21.726,0,0,1-3.85-8.568c-.46-2.291-.92-4.582-1.26-6.3a22.775,22.775,0,0,0-.826-2.794",
    transform: "translate(-10.905 -29.737)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(112.673 266.7)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75478",
    "data-name": "Path 75478",
    d: "M13.229,31.315a19.532,19.532,0,0,1,1.3,2.342c.622,1.473,1.448,3.432,2.283,5.4a17.343,17.343,0,0,0,5.068,6.584l-.545.656a18.08,18.08,0,0,1-4.9-7.069c-.749-2.01-1.49-4.011-2.044-5.519a18.523,18.523,0,0,0-1.167-2.393",
    transform: "translate(-13.233 -31.315)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145",
    transform: "translate(131.075 278.883)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2144",
    "data-name": "Group 2144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75479",
    "data-name": "Path 75479",
    d: "M15.39,32.745a14.775,14.775,0,0,1,1.082,1.593c.537,1.022,1.269,2.376,1.993,3.73a12.367,12.367,0,0,0,4.02,4.369l-.485.7a13.23,13.23,0,0,1-3.909-4.872c-.63-1.4-1.269-2.8-1.737-3.858a13.182,13.182,0,0,0-.962-1.661",
    transform: "translate(-15.391 -32.749)",
    fill: "#182a51"
  }))))))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(20.696 9.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2148",
    "data-name": "Group 2148",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1294",
    "data-name": "Rectangle 1294",
    width: 139.812,
    height: 291.846,
    transform: "translate(-2.299 -0.004)",
    fill: "#182a51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2157",
    "data-name": "Group 2157",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2156",
    "data-name": "Group 2156",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2155",
    "data-name": "Group 2155",
    transform: "translate(20.694 24.897)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2154",
    "data-name": "Group 2154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2153",
    "data-name": "Group 2153",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    "data-name": "Group 2152",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75481",
    "data-name": "Path 75481",
    d: "M14.649,183.353a133.252,133.252,0,0,1-10.127-35.9A128.037,128.037,0,0,1,15.91,75.777c10.109-21.19,24.5-38.326,37.559-51.51A198.842,198.842,0,0,1,78.321,2.924,201.821,201.821,0,0,0,52.413,24.829C39.356,37.869,25.414,54.791,15.3,75.76,5.093,96.592.128,121.938,3.458,146.688A131.12,131.12,0,0,0,13.593,182.2a130.031,130.031,0,0,0,14.462,24.017,131.877,131.877,0,0,1-13.405-22.868",
    transform: "translate(-2.434 -2.922)",
    fill: "#182a51"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_75482",
    "data-name": "Path 75482",
    d: "M23.922,37.718c6.882,2.93,12.835,5.664,17.706,8.091,4.872,2.351,8.713,4.7,11.276,6.149a27.246,27.246,0,0,1,3.977,2.47c.068.068.051.17.111.247a1.38,1.38,0,0,0-.375-1.175,27.752,27.752,0,0,0-3.977-2.461c-2.564-1.456-6.328-3.449-11.2-5.8C36.561,42.819,30.48,40.009,23.6,37.07c-3.211-1.354-6.635-2.862-10.161-4.488a92.709,92.709,0,0,0,10.484,5.136",
    transform: "translate(80.318 220.012)",
    fill: "#182a51"
  }))))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2159",
    "data-name": "Group 2159",
    transform: "translate(190.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2158",
    "data-name": "Group 2158",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1298",
    "data-name": "Rectangle 1298",
    width: 37.147,
    height: 39.445,
    transform: "translate(-10.701 15.19) rotate(-54.843)",
    fill: "#182a51"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161",
    transform: "translate(216.702 2.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2160",
    "data-name": "Group 2160",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1299",
    "data-name": "Rectangle 1299",
    width: 44.462,
    height: 43.15,
    transform: "matrix(0.626, -0.78, 0.78, 0.626, -17.303, 21.542)",
    fill: "#182a51"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163",
    transform: "translate(203.552 24.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    "data-name": "Group 2162",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1300",
    "data-name": "Rectangle 1300",
    width: 39.623,
    height: 37.995,
    transform: "matrix(0.745, -0.667, 0.667, 0.745, -8.465, 7.584)",
    fill: "#182a51"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    transform: "translate(243.172 14.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1301",
    "data-name": "Rectangle 1301",
    width: 40.305,
    height: 34.386,
    transform: "translate(-17.355 26.036) rotate(-56.31)",
    fill: "#182a51"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(216.924 44.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1302",
    "data-name": "Rectangle 1302",
    width: 39.88,
    height: 30.526,
    transform: "translate(-5.341 2.932) rotate(-30.864)",
    fill: "#182a51"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(262.284 28.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1303",
    "data-name": "Rectangle 1303",
    width: 43.609,
    height: 41.097,
    transform: "translate(-22.052 24.954) rotate(-48.527)",
    fill: "#182a51"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(232.484 59.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1304",
    "data-name": "Rectangle 1304",
    width: 43.828,
    height: 33.068,
    transform: "matrix(0.901, -0.433, 0.433, 0.901, -6.762, 3.253)",
    fill: "#182a51"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173",
    transform: "translate(281.055 47.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1305",
    "data-name": "Rectangle 1305",
    width: 42.532,
    height: 48.309,
    transform: "matrix(0.791, -0.612, 0.612, 0.791, -23.51, 18.179)",
    fill: "#182a51"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175",
    transform: "translate(246.136 75.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 43.643,
    height: 27.674,
    transform: "translate(-3.418 0.566) rotate(-9.335)",
    fill: "#182a51"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177",
    transform: "translate(295.303 72.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1307",
    "data-name": "Rectangle 1307",
    width: 37.565,
    height: 59.13,
    transform: "translate(-19.244 6.445) rotate(-19.876)",
    fill: "#182a51"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179",
    transform: "translate(260.206 101.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1308",
    "data-name": "Rectangle 1308",
    width: 38.632,
    height: 26.947,
    transform: "translate(0 0.004)",
    fill: "#182a51"
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181",
    transform: "translate(300.967 113.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1309",
    "data-name": "Rectangle 1309",
    width: 28.702,
    height: 47.925,
    transform: "translate(-8.03 1.487) rotate(-10.474)",
    fill: "#182a51"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(270.852 125.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    width: 40.289,
    height: 38.772,
    transform: "translate(-9.336 29.772) rotate(-72.587)",
    fill: "#182a51"
  })))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(295.236 155.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1311",
    "data-name": "Rectangle 1311",
    width: 43.458,
    height: 36.727,
    transform: "matrix(0.269, -0.963, 0.963, 0.269, -9.68, 34.692)",
    fill: "#182a51"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187",
    transform: "translate(274.344 152.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 46.855,
    height: 37.398,
    transform: "translate(-14.282 35.128) rotate(-67.872)",
    fill: "#182a51"
  })))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    transform: "translate(271.311 178.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    width: 44.413,
    height: 36.738,
    transform: "translate(-19.869 29.817) rotate(-56.76)",
    fill: "#182a51"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191",
    transform: "translate(280.425 193.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1314",
    "data-name": "Rectangle 1314",
    width: 40.581,
    height: 44.053,
    transform: "translate(-10.496 24.362) rotate(-66.689)",
    fill: "#182a51"
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193",
    transform: "translate(254.871 200.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1315",
    "data-name": "Rectangle 1315",
    width: 43.797,
    height: 46.1,
    transform: "translate(-25.542 20.04) rotate(-41.581)",
    fill: "#182a51"
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(260.436 229.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1316",
    "data-name": "Rectangle 1316",
    width: 38.996,
    height: 43.665,
    transform: "translate(-9.21 12.839) rotate(-54.338)",
    fill: "#182a51"
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(239.795 224.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 30.659,
    height: 38.991,
    transform: "matrix(0.901, -0.434, 0.434, 0.901, -14.909, 6.587)",
    fill: "#182a51"
  })))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(242.474 250.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1318",
    "data-name": "Rectangle 1318",
    width: 33.87,
    height: 38.927,
    transform: "matrix(0.586, -0.811, 0.811, 0.586, -7.042, 9.754)",
    fill: "#182a51"
  })))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201",
    transform: "translate(221.403 243.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 25.98,
    height: 32.859,
    transform: "matrix(0.939, -0.343, 0.343, 0.939, -11.247, 3.386)",
    fill: "#182a51"
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203",
    transform: "translate(221.787 265.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1320",
    "data-name": "Rectangle 1320",
    width: 35.225,
    height: 30.359,
    transform: "translate(-5.933 4.315) rotate(-36.002)",
    fill: "#182a51"
  })))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205",
    transform: "translate(199.634 278.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1321",
    "data-name": "Rectangle 1321",
    width: 29.385,
    height: 25.369,
    transform: "translate(-5.394 3.781) rotate(-34.999)",
    fill: "#182a51"
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207",
    transform: "translate(199.064 257.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1322",
    "data-name": "Rectangle 1322",
    width: 23.379,
    height: 29.718,
    transform: "matrix(0.95, -0.313, 0.313, 0.95, -8.403, 2.558)",
    fill: "#182a51"
  })))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(180.829 286.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1323",
    "data-name": "Rectangle 1323",
    width: 23.863,
    height: 23.031,
    transform: "translate(-5.542 4.978) rotate(-41.907)",
    fill: "#182a51"
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211",
    transform: "translate(180.506 269.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1324",
    "data-name": "Rectangle 1324",
    width: 20.059,
    height: 23.429,
    transform: "translate(-4.284 0.944) rotate(-12.375)",
    fill: "#182a51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214",
    transform: "translate(190.209 -0.004)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75510",
    "data-name": "Path 75510",
    d: "M42.28,8.057C35.365,4.08,28.5,3.381,22.334,0c7.393,2.376,13.21,3.168,19.946,6.473,7.154,3.5,11.532,13.278,12.256,16.02C52.995,18.754,48.285,11.515,42.28,8.057",
    transform: "translate(-22.328)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217",
    transform: "translate(216.701 2.091)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75511",
    "data-name": "Path 75511",
    d: "M42.57,12.289C38.431,7.306,30.161,3.057,25.562.416a2.07,2.07,0,0,0-.119-.17C31.669,2.869,38.022,5.714,42.57,10.7a31.655,31.655,0,0,1,7.716,17.851S48.1,18.949,42.57,12.289",
    transform: "translate(-25.451 -0.246)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    "data-name": "Group 2220",
    transform: "translate(203.552 24.568)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75512",
    "data-name": "Path 75512",
    d: "M38.651,6.574C34.095,6.088,27.17,4.768,23.9,2.886,28.175,4.513,34.137,5.16,38.694,5.645c7.077.767,12.826,1.882,17.724,5.306C51.333,8.413,45.252,7.289,38.651,6.574",
    transform: "translate(-23.9 -2.878)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223",
    transform: "translate(243.17 14.309)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    "data-name": "Group 2222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75513",
    "data-name": "Path 75513",
    d: "M41.9,21.048C38.96,12.736,33.781,7.992,28.552,1.681c6.021,5.442,12.128,11.591,14,19.5a30.667,30.667,0,0,1,.835,6.592,27.709,27.709,0,0,0-1.49-6.72",
    transform: "translate(-28.549 -1.678)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226",
    transform: "translate(217.447 44.884)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75514",
    "data-name": "Path 75514",
    d: "M45.206,6.855c-6.694.2-15.032-.077-19.674-1.584,6.8,1.414,14.121.6,21.275.383A21.574,21.574,0,0,1,58.228,7.92,35.99,35.99,0,0,0,45.206,6.855",
    transform: "translate(-25.528 -5.267)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(262.283 28.243)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75515",
    "data-name": "Path 75515",
    d: "M30.8,3.317C36.008,11.774,45.155,16.39,46.05,30.426c.026.451-.017,1.022-.017,1.516C45.1,17.957,33.223,11.331,30.8,3.317",
    transform: "translate(-30.795 -3.314)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232",
    transform: "translate(232.484 59.313)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75516",
    "data-name": "Path 75516",
    d: "M53.359,10.652C42.406,8.676,33.2,10.124,27.3,6.964c10.569,1.984,20.227.307,30.644,4.233a14.336,14.336,0,0,1,3.85,2.24,33.449,33.449,0,0,0-8.432-2.785",
    transform: "translate(-27.297 -6.97)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235",
    transform: "translate(246.135 75.826)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    "data-name": "Group 2233",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75517",
    "data-name": "Path 75517",
    d: "M43.5,14.244c-5.6-1.235-11.4-2.453-14.6-5.34,5.008,2.776,9.2,3,14.794,4.224s13.133,1.448,18.141,4.233a6.209,6.209,0,0,1,.962.767C57.772,15.4,49.059,15.47,43.5,14.244",
    transform: "translate(-28.898 -8.901)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    "data-name": "Group 2238",
    transform: "translate(260.208 101.893)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2237",
    "data-name": "Group 2237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2236",
    "data-name": "Group 2236",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75518",
    "data-name": "Path 75518",
    d: "M53.232,18.956c-4.216-.962-7.81-1.346-12.068-2.053s-7.759-1.925-10.612-4.94c3.6,2.47,6.856,3,11.123,3.7S49.085,17,53.3,17.951a23.612,23.612,0,0,1,8.346,4.275,35.046,35.046,0,0,0-8.415-3.27",
    transform: "translate(-30.554 -11.966)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241",
    transform: "translate(301.843 113.212)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    "data-name": "Group 2240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75519",
    "data-name": "Path 75519",
    d: "M35.441,44.516a35.678,35.678,0,0,1,4.386-11.268c4.25-6.907,10.85-12.392,13.8-19.955C51.6,22.236,44.571,28.18,40.33,35.1a61.215,61.215,0,0,0-4.889,9.42",
    transform: "translate(-35.439 -13.295)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2244",
    "data-name": "Group 2244",
    transform: "translate(270.859 125.301)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75520",
    "data-name": "Path 75520",
    d: "M40.268,22.344A23.716,23.716,0,0,1,31.8,14.713a35.366,35.366,0,0,0,8.466,6.047c5.2,2.828,14.981,5.536,19.529,12.6-5.05-6.064-14.649-8.372-19.529-11.021",
    transform: "translate(-31.809 -14.71)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(299.367 155.443)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2246",
    "data-name": "Group 2246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75521",
    "data-name": "Path 75521",
    d: "M40.047,34.281a26.7,26.7,0,0,0-4.9,5.817,17.874,17.874,0,0,1,4.9-7.4c6.209-5.5,14.649-8.159,18.669-14.445-3.211,7.188-12.46,10.527-18.669,16.029",
    transform: "translate(-35.15 -18.25)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(274.342 152.481)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75522",
    "data-name": "Path 75522",
    d: "M49.314,33.413c-6.456-5.928-14.308-8.27-17.1-15.509C38,24.385,45.873,27.468,51.545,34.154c2.266,2.674,3.9,5.51,4.182,8.662a24.336,24.336,0,0,0-6.413-9.4",
    transform: "translate(-32.21 -17.904)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2253",
    "data-name": "Group 2253",
    transform: "translate(273.921 178.996)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2252",
    "data-name": "Group 2252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75523",
    "data-name": "Path 75523",
    d: "M44.588,51.2a32.085,32.085,0,0,0-3.926-14.317c-2.768-4.616-8.355-9.547-8.5-15.867,2.4,6.4,6.388,8.593,9.428,15.066,2.248,4.795,3.628,9.556,3.032,14.93a1.216,1.216,0,0,1-.034.187",
    transform: "translate(-32.165 -21.019)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256",
    transform: "translate(290.26 193.288)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75524",
    "data-name": "Path 75524",
    d: "M35.231,35.1c6.788-6.243,15.714-8.329,24.537-12.409-6.728,5.434-18.516,8.364-25.687,13.576.4-.426.792-.843,1.15-1.167",
    transform: "translate(-34.079 -22.698)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    transform: "translate(254.933 200.044)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75525",
    "data-name": "Path 75525",
    d: "M42.894,42.873C41.072,36.912,39.675,32.6,37.92,27.756c-1.5,5.97-4.8,11.319-6.362,17.6a57.006,57.006,0,0,0-1.618,9.334A49.019,49.019,0,0,1,31.7,41.868c1.559-6.277,5.136-11.983,6.124-18.379,1.754,4.855,3.764,11.7,5.587,17.664a30.394,30.394,0,0,1,.664,13.039,31.874,31.874,0,0,0-1.184-11.319",
    transform: "translate(-29.931 -23.486)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262",
    transform: "translate(271.871 229.663)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75526",
    "data-name": "Path 75526",
    d: "M41.972,29.267a102.115,102.115,0,0,0-10.05,2.53,31.21,31.21,0,0,1,13.525-4.344c4.514-.451,10.442-.928,14.836.264l-.2.145a89.042,89.042,0,0,0-18.115,1.405",
    transform: "translate(-31.919 -26.969)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(240.085 224.592)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75527",
    "data-name": "Path 75527",
    d: "M33.921,28.969c.409-1.15-4.088,6.422-5.732,14.146.026-.17.017-.315.043-.494,1.056-8.457,6.149-17.391,5.7-16.131,2.981,5.928,7.546,14.189,7.52,21.616-.613-6.7-4.786-13.678-7.529-19.137",
    transform: "translate(-28.193 -26.37)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(254.314 250.704)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75528",
    "data-name": "Path 75528",
    d: "M29.86,30.025a10.262,10.262,0,0,1,2.606-.554,53.281,53.281,0,0,1,13.516,1.72c2.436.715,7.537,2.862,9.343,4.752l-.23.034c-4.914-3.764-19.444-6.013-25.235-5.953",
    transform: "translate(-29.862 -29.436)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(224.436 243.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75529",
    "data-name": "Path 75529",
    d: "M31.42,31.323c-1.15,3.032-3.236,5.953-5.068,9.258,1.857-4.378,4.011-8.389,4.744-12.009,4.2,5.144,6.3,10.476,6.294,16.148-.324-4.65-2.223-8.806-5.97-13.4",
    transform: "translate(-26.353 -28.574)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    transform: "translate(233.414 265.187)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2272",
    "data-name": "Group 2272",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75530",
    "data-name": "Path 75530",
    d: "M27.406,31.572c.145-.034.256-.1.4-.136,8.474-1.695,20.057,4.25,22.45,7.316l-.06.009c-3.483-2.9-14.768-7.18-22.791-7.188",
    transform: "translate(-27.408 -31.14)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(210.544 278.389)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75531",
    "data-name": "Path 75531",
    d: "M25.648,32.949a7.764,7.764,0,0,0-.928-.23,11.134,11.134,0,0,1,3.219.23c3.356.707,8.6,4.267,12.724,9.939-4.633-5.2-12.017-8.755-15.015-9.939",
    transform: "translate(-24.728 -32.689)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280",
    transform: "translate(202.393 257.028)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75532",
    "data-name": "Path 75532",
    d: "M34.58,32.854C31.148,36.636,26.8,39.31,23.764,43.347a20.527,20.527,0,0,1,1.686-2.419c3.041-4.054,7.469-7.188,10.127-10.748.2,7.018.332,11.77-1.014,16.08.715-4.548.341-9,.017-13.405",
    transform: "translate(-23.763 -30.175)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    transform: "translate(191.295 286.525)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75533",
    "data-name": "Path 75533",
    d: "M22.461,33.656c.2.008.434-.026.63-.009,2.725.324,3.7,2.521,5.987,4.778,1.073,1.065,2.6,3.424,4.982,4.872a34.093,34.093,0,0,1-5.468-3.781c-1.865-1.848-3.5-4.718-6.132-5.86",
    transform: "translate(-22.459 -33.645)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286",
    transform: "translate(181.98 269.965)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75534",
    "data-name": "Path 75534",
    d: "M24.825,42.336a21.864,21.864,0,0,0-3.458,4.114,18.986,18.986,0,0,1,4.267-5.706c3.194-2.913,5.681-5.289,9.122-9.045-2.47,4.574-6.737,7.725-9.931,10.638",
    transform: "translate(-21.368 -31.7)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(282.742 47.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75535",
    "data-name": "Path 75535",
    d: "M38.146,10.08A56.232,56.232,0,0,1,33.2,26.731c.383-1.414.8-2.819,1.243-4.318,1.61-5.5,3.058-11.14,2.947-16.872C42.2,15.259,46.544,25.2,46.237,35.776c-.332-9-3.764-16.957-8.091-25.7",
    transform: "translate(-33.198 -5.538)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(296.806 72.537)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75536",
    "data-name": "Path 75536",
    d: "M42.617,12.351c-.307,8.687-4.931,16.957-7.767,24.554.46-1.746,1-3.5,1.661-5.3,2.828-7.674,5.076-13.772,5.723-23.089,4.395,9.607,8.44,19.87,8.057,30.635-.3-9.428-3.7-18.115-7.674-26.8",
    transform: "translate(-34.845 -8.513)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295",
    transform: "translate(229.974 17.302)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75537",
    "data-name": "Path 75537",
    d: "M27,2.032a29.68,29.68,0,0,1,1.3,2.751c.715,1.678,1.669,3.918,2.615,6.158a43.141,43.141,0,0,0,3.092,5.885A16.8,16.8,0,0,0,35.8,19.193l-.639.562A18.634,18.634,0,0,1,33.4,17.2a42.786,42.786,0,0,1-2.87-6.09L28.186,4.834C27.547,3.122,27,2.032,27,2.032",
    transform: "translate(-27.005 -2.032)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    transform: "translate(219.032 32.837)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75538",
    "data-name": "Path 75538",
    d: "M25.718,3.856a26.2,26.2,0,0,0,3.032.17c1.823.017,4.258.043,6.694.06a42.62,42.62,0,0,1,6.7.622,17.668,17.668,0,0,1,3,.809l-.315.792a17,17,0,0,0-2.845-.894,41.06,41.06,0,0,0-6.558-.9c-2.436-.128-4.863-.256-6.686-.349a27.105,27.105,0,0,1-3.023-.307",
    transform: "translate(-25.714 -3.856)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(250.558 30.186)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75539",
    "data-name": "Path 75539",
    d: "M29.419,3.545c.2-.051.979,4.752,1.439,9.564a36.589,36.589,0,0,0,1.269,6.473,13.18,13.18,0,0,0,1.133,2.708l-.75.409a14.431,14.431,0,0,1-1.073-2.921,37.444,37.444,0,0,1-1-6.626c-.247-4.846-.809-9.641-1.014-9.607",
    transform: "translate(-29.421 -3.544)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    transform: "translate(268.946 48.612)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75540",
    "data-name": "Path 75540",
    d: "M31.578,5.708a21.515,21.515,0,0,1,.775,3.543c.324,2.163.494,5.068.758,7.955A45.446,45.446,0,0,0,34.4,25.024a26.23,26.23,0,0,0,1.141,3.381l-.792.315A27.839,27.839,0,0,1,33.7,25.195a45.733,45.733,0,0,1-1.013-7.963c-.162-2.9-.213-5.8-.46-7.963a21.706,21.706,0,0,0-.647-3.56",
    transform: "translate(-31.58 -5.711)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(235.328 49.203)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75541",
    "data-name": "Path 75541",
    d: "M27.631,6.632c.009.213,4.821-.051,9.641-.622a37.654,37.654,0,0,1,6.7-.136,14.135,14.135,0,0,1,3.058.562l-.281.809A13.157,13.157,0,0,0,43.9,6.589a37.84,37.84,0,0,0-6.592-.162c-4.821.366-9.692.417-9.675.2",
    transform: "translate(-27.631 -5.777)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(249.276 67.615)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75542",
    "data-name": "Path 75542",
    d: "M29.269,7.939a21.708,21.708,0,0,0,3.56.647c2.163.247,5.059.307,7.963.468a45.783,45.783,0,0,1,7.963,1.022,27.839,27.839,0,0,1,3.526,1.048l-.315.792a26.8,26.8,0,0,0-3.39-1.15,45.2,45.2,0,0,0-7.81-1.286c-2.887-.264-5.791-.434-7.955-.767a21.516,21.516,0,0,1-3.543-.775",
    transform: "translate(-29.266 -7.943)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(285.819 69.104)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75543",
    "data-name": "Path 75543",
    d: "M35.9,8.114a25.846,25.846,0,0,1-.051,3.9c-.17,2.334-.656,5.425-1.056,8.508a55.185,55.185,0,0,0-.52,8.508,31.4,31.4,0,0,0,.349,3.833l-.843.111a31.078,31.078,0,0,1-.221-3.935,55.007,55.007,0,0,1,.818-8.576c.5-3.083,1.09-6.141,1.346-8.466A25.643,25.643,0,0,0,35.9,8.114",
    transform: "translate(-33.562 -8.117)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(262.304 86.724)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75544",
    "data-name": "Path 75544",
    d: "M30.8,10.183a25.592,25.592,0,0,0,3.7,1.175c2.265.571,5.34,1.082,8.406,1.678a53.769,53.769,0,0,1,8.329,2.206,32.048,32.048,0,0,1,3.62,1.567l-.4.749a32.456,32.456,0,0,0-3.475-1.644,53.152,53.152,0,0,0-8.159-2.461c-3.032-.707-6.1-1.312-8.355-1.967a25.077,25.077,0,0,1-3.671-1.3",
    transform: "translate(-30.801 -10.185)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    transform: "translate(298.125 97.72)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75545",
    "data-name": "Path 75545",
    d: "M41.816,11.474A22.58,22.58,0,0,1,41.1,15.9c-.63,2.615-1.874,6-2.964,9.4a47.317,47.317,0,0,0-2.146,9.547,28.985,28.985,0,0,0-.128,4.412l-.852.034a30.01,30.01,0,0,1,.264-4.531,47.233,47.233,0,0,1,2.461-9.59c1.192-3.39,2.529-6.72,3.236-9.309a23.081,23.081,0,0,0,.843-4.395",
    transform: "translate(-35.005 -11.477)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322",
    transform: "translate(272.581 111.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75546",
    "data-name": "Path 75546",
    d: "M32.005,13.073a22.77,22.77,0,0,0,3.884,2.214c2.427,1.158,5.826,2.308,9.173,3.611a47,47,0,0,1,8.892,4.378,28.65,28.65,0,0,1,3.611,2.734l-.579.639a27.96,27.96,0,0,0-3.441-2.785A46.477,46.477,0,0,0,44.9,19.282c-3.3-1.388-6.669-2.649-9.07-3.875a22.769,22.769,0,0,1-3.824-2.334",
    transform: "translate(-32.005 -13.077)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    transform: "translate(301.008 131.828)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75547",
    "data-name": "Path 75547",
    d: "M48.442,15.479a15.337,15.337,0,0,1-1.669,3.858c-1.252,2.214-3.407,4.829-5.357,7.554a30.242,30.242,0,0,0-4.31,8.057,22.539,22.539,0,0,0-.92,4.028l-.843-.128a22.866,22.866,0,0,1,1.09-4.139,30.622,30.622,0,0,1,4.642-8.065c2.053-2.683,4.267-5.221,5.587-7.376a15.57,15.57,0,0,0,1.78-3.79",
    transform: "translate(-35.34 -15.479)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    transform: "translate(279.676 138.189)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75548",
    "data-name": "Path 75548",
    d: "M32.838,16.226a15.325,15.325,0,0,0,3.2,2.7c2.1,1.414,5.17,2.785,8.159,4.361a30.676,30.676,0,0,1,7.588,5.4,22.922,22.922,0,0,1,2.717,3.3l-.715.468a22.358,22.358,0,0,0-2.521-3.279,30.126,30.126,0,0,0-7.282-5.519c-2.913-1.661-5.962-3.143-8.023-4.625a15.722,15.722,0,0,1-3.126-2.811",
    transform: "translate(-32.839 -16.225)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331",
    transform: "translate(295.478 170.829)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75549",
    "data-name": "Path 75549",
    d: "M53.336,20.058a15.622,15.622,0,0,1-2.6,3.3c-1.78,1.814-4.531,3.8-7.112,5.936A29.962,29.962,0,0,0,37.4,35.984a22.411,22.411,0,0,0-1.925,3.654l-.784-.332a23,23,0,0,1,2.112-3.722,30.478,30.478,0,0,1,6.549-6.618c2.674-2.07,5.468-3.952,7.29-5.7a15.7,15.7,0,0,0,2.691-3.211",
    transform: "translate(-34.696 -20.061)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(281.377 166.886)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75550",
    "data-name": "Path 75550",
    d: "M33.038,19.6a15.678,15.678,0,0,0,2.027,3.662c1.456,2.07,3.841,4.446,6.064,6.984a30.671,30.671,0,0,1,5.17,7.75,23.357,23.357,0,0,1,1.363,4.054l-.835.179a22.318,22.318,0,0,0-1.192-3.952,30.223,30.223,0,0,0-4.829-7.75c-2.129-2.6-4.454-5.068-5.843-7.188A15.281,15.281,0,0,1,33.038,19.6",
    transform: "translate(-33.036 -19.598)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337",
    transform: "translate(281.662 206.611)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2335",
    "data-name": "Group 2335",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75551",
    "data-name": "Path 75551",
    d: "M53.367,24.26a13.215,13.215,0,0,1-2.955,2.3c-1.925,1.175-4.744,2.248-7.452,3.5a25.077,25.077,0,0,0-6.8,4.412,19.664,19.664,0,0,0-2.41,2.751l-.681-.5a19.784,19.784,0,0,1,2.606-2.785,26.086,26.086,0,0,1,7.112-4.267c2.768-1.167,5.6-2.129,7.563-3.228a13.1,13.1,0,0,0,3.015-2.18",
    transform: "translate(-33.073 -24.257)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340",
    transform: "translate(276.252 196.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75552",
    "data-name": "Path 75552",
    d: "M32.438,23.035A12.853,12.853,0,0,0,33.1,26.7c.639,2.155,2.018,4.812,3.2,7.571a25.779,25.779,0,0,1,2.163,8.006,20.762,20.762,0,0,1-.043,3.816l-.852-.111a19.462,19.462,0,0,0,.179-3.662,25.231,25.231,0,0,0-1.84-7.887c-1.082-2.776-2.368-5.51-2.938-7.691a13.145,13.145,0,0,1-.537-3.7",
    transform: "translate(-32.438 -23.038)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343",
    transform: "translate(261.74 237.135)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75553",
    "data-name": "Path 75553",
    d: "M53.7,27.844a12.945,12.945,0,0,1-3.475,1.38c-2.18.588-5.2.835-8.134,1.278a25.355,25.355,0,0,0-7.767,2.334,19.344,19.344,0,0,0-3.083,1.976l-.511-.681a20.1,20.1,0,0,1,3.279-1.942,25.757,25.757,0,0,1,8.023-2.1c2.981-.349,5.979-.477,8.159-.988A13.209,13.209,0,0,0,53.7,27.844",
    transform: "translate(-30.733 -27.84)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    transform: "translate(261.057 220.036)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75554",
    "data-name": "Path 75554",
    d: "M31.861,25.836a12.958,12.958,0,0,0-.349,3.7c.043,2.248.656,5.178,1.056,8.159a25.734,25.734,0,0,1-.068,8.287,19.982,19.982,0,0,1-1.065,3.662l-.784-.332a19.707,19.707,0,0,0,1.15-3.475,25.008,25.008,0,0,0,.341-8.1c-.29-2.964-.8-5.936-.758-8.2a12.888,12.888,0,0,1,.477-3.7",
    transform: "translate(-30.651 -25.836)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    transform: "translate(243.583 256.311)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75555",
    "data-name": "Path 75555",
    d: "M49.6,30.731a27.373,27.373,0,0,1-3.3.162c-1.976.009-4.616-.255-7.231-.307a23.8,23.8,0,0,0-10.144,1.857L28.6,31.66a21.69,21.69,0,0,1,3.2-.988,25.331,25.331,0,0,1,7.282-.511c2.649.162,5.255.528,7.231.6a26.438,26.438,0,0,0,3.287-.026",
    transform: "translate(-28.602 -30.094)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352",
    transform: "translate(223.256 269.51)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2350",
    "data-name": "Group 2350",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75556",
    "data-name": "Path 75556",
    d: "M47.216,33.475a26.141,26.141,0,0,1-3.3-.128c-1.976-.162-4.574-.656-7.18-.937a23.842,23.842,0,0,0-10.271.954l-.256-.809a21.926,21.926,0,0,1,3.27-.707,25.328,25.328,0,0,1,7.307.136c2.623.392,5.187.988,7.146,1.226a27.18,27.18,0,0,0,3.279.264",
    transform: "translate(-26.21 -31.643)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2355",
    "data-name": "Group 2355",
    transform: "translate(201.687 280.859)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2354",
    "data-name": "Group 2354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75557",
    "data-name": "Path 75557",
    d: "M40.042,37.765a17.968,17.968,0,0,1-2.572-.724L32.01,34.886a17.362,17.362,0,0,0-8.244-1.022l-.085-.843a18.134,18.134,0,0,1,8.483,1.465c1.95.886,3.892,1.772,5.357,2.436a19.238,19.238,0,0,0,2.521.843",
    transform: "translate(-23.681 -32.973)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    transform: "translate(184.699 288.074)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2357",
    "data-name": "Group 2357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2356",
    "data-name": "Group 2356",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75558",
    "data-name": "Path 75558",
    d: "M32.664,39.548a13.107,13.107,0,0,1-1.729-.852c-.979-.6-2.283-1.422-3.586-2.24a12.258,12.258,0,0,0-5.664-1.78l.077-.852A13.155,13.155,0,0,1,27.58,36.1L31,38.586a13.221,13.221,0,0,0,1.661.962",
    transform: "translate(-21.689 -33.822)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    transform: "translate(243.751 237.261)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75559",
    "data-name": "Path 75559",
    d: "M32.061,27.858a26.825,26.825,0,0,0-.307,3.279c-.094,1.967.051,4.6-.009,7.248A25.308,25.308,0,0,1,30.63,45.6a22.032,22.032,0,0,1-1.26,3.109l-.749-.392a23.889,23.889,0,0,0,2.7-9.948c.17-2.623.128-5.272.307-7.239a26.451,26.451,0,0,1,.434-3.27",
    transform: "translate(-28.619 -27.861)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    transform: "translate(223.476 253.276)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75560",
    "data-name": "Path 75560",
    d: "M32.84,29.739a22.776,22.776,0,0,0-.826,2.794c-.341,1.72-.8,4.011-1.26,6.3A21.726,21.726,0,0,1,26.9,47.4l-.664-.537a20.945,20.945,0,0,0,4.105-8.142c.562-2.257,1.124-4.531,1.542-6.226a22.666,22.666,0,0,1,.954-2.759",
    transform: "translate(-26.242 -29.737)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    transform: "translate(201.613 266.7)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2366",
    "data-name": "Group 2366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75561",
    "data-name": "Path 75561",
    d: "M32.325,31.315a18.521,18.521,0,0,0-1.167,2.393c-.554,1.507-1.295,3.509-2.036,5.519A18.151,18.151,0,0,1,24.217,46.3l-.545-.656a17.366,17.366,0,0,0,5.059-6.584c.843-1.967,1.678-3.926,2.3-5.4a18.911,18.911,0,0,1,1.295-2.342",
    transform: "translate(-23.675 -31.315)",
    fill: "#182a51"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    transform: "translate(184.761 278.883)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2368",
    "data-name": "Group 2368",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75562",
    "data-name": "Path 75562",
    d: "M28.789,32.745a13.182,13.182,0,0,0-.962,1.661c-.468,1.056-1.107,2.461-1.737,3.858a13.23,13.23,0,0,1-3.909,4.872l-.485-.7a12.366,12.366,0,0,0,4.02-4.369c.724-1.354,1.448-2.708,1.993-3.73a14.77,14.77,0,0,1,1.082-1.593",
    transform: "translate(-21.691 -32.749)",
    fill: "#182a51"
  }))))))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(164.873 9.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1379",
    "data-name": "Rectangle 1379",
    width: 139.821,
    height: 291.846,
    transform: "translate(-0.149 -0.004)",
    fill: "#182a51"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2382",
    "data-name": "Group 2382",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2381",
    "data-name": "Group 2381",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2380",
    "data-name": "Group 2380",
    transform: "translate(164.924 24.897)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2379",
    "data-name": "Group 2379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2378",
    "data-name": "Group 2378",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377",
    transform: "translate(61.432)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75564",
    "data-name": "Path 75564",
    d: "M90.249,183.353a133.563,133.563,0,0,0,10.127-35.9A128.037,128.037,0,0,0,88.988,75.777c-10.109-21.19-24.5-38.326-37.559-51.51A198.84,198.84,0,0,0,26.577,2.924,201.819,201.819,0,0,1,52.485,24.829c13.056,13.039,27,29.962,37.108,50.931C99.8,96.592,104.77,121.938,101.44,146.688A131.12,131.12,0,0,1,91.3,182.2a130.029,130.029,0,0,1-14.462,24.017,131.876,131.876,0,0,0,13.405-22.868",
    transform: "translate(-26.581 -2.922)",
    fill: "#182a51"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75565",
    "data-name": "Path 75565",
    d: "M52.446,37.718c-6.882,2.93-12.835,5.664-17.706,8.091-4.872,2.351-8.713,4.7-11.276,6.149a27.243,27.243,0,0,0-3.977,2.47c-.068.068-.06.17-.111.247A1.38,1.38,0,0,1,19.75,53.5a27.752,27.752,0,0,1,3.977-2.461c2.564-1.456,6.328-3.449,11.2-5.8,4.88-2.419,10.961-5.229,17.843-8.168,3.211-1.354,6.635-2.862,10.161-4.488a92.708,92.708,0,0,1-10.484,5.136",
    transform: "translate(-19.362 220.012)",
    fill: "#182a51"
  }))))))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2384",
    "data-name": "Group 2384",
    transform: "translate(152.179 35.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2383",
    "data-name": "Group 2383",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1383",
    "data-name": "Rectangle 1383",
    width: 24.488,
    height: 24.541,
    transform: "matrix(0.674, -0.739, 0.739, 0.674, -8.438, 9.259)",
    fill: "#182a51"
  })))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2386",
    "data-name": "Group 2386",
    transform: "translate(181.817 42.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2385",
    "data-name": "Group 2385",
    clipPath: "url(#clip-path-172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1384",
    "data-name": "Rectangle 1384",
    width: 20.167,
    height: 20.211,
    transform: "matrix(0.674, -0.739, 0.739, 0.674, -6.945, 7.622)",
    fill: "#182a51"
  })))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2388",
    "data-name": "Group 2388",
    transform: "translate(126.483 42.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1385",
    "data-name": "Rectangle 1385",
    width: 20.167,
    height: 20.211,
    transform: "matrix(0.674, -0.739, 0.739, 0.674, -6.945, 7.622)",
    fill: "#182a51"
  })))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2390",
    "data-name": "Group 2390",
    transform: "translate(205.741 56.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2389",
    "data-name": "Group 2389",
    clipPath: "url(#clip-path-174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1386",
    "data-name": "Rectangle 1386",
    width: 18.1,
    height: 18.14,
    transform: "translate(-6.233 6.84) rotate(-47.658)",
    fill: "#182a51"
  })))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2392",
    "data-name": "Group 2392",
    transform: "translate(104.059 56.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1387",
    "data-name": "Rectangle 1387",
    width: 18.1,
    height: 18.14,
    transform: "matrix(0.674, -0.739, 0.739, 0.674, -6.233, 6.84)",
    fill: "#182a51"
  })))))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_158",
    "data-name": "Mask Group 158",
    transform: "translate(4510.173 637)",
    clipPath: "url(#clip-path-176)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo_1_",
    "data-name": "logo (1)",
    width: 56,
    height: 66,
    transform: "translate(304.827 4519)",
    fill: "url(#pattern)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_157",
    "data-name": "Mask Group 157",
    transform: "translate(869.14)",
    clipPath: "url(#clip-path-177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4228",
    "data-name": "Group 4228",
    transform: "translate(3813.173 5015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4227",
    "data-name": "Group 4227"
  }, _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778",
    transform: "translate(100.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777",
    clipPath: "url(#clip-path-178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2242",
    "data-name": "Rectangle 2242",
    width: 39.438,
    height: 37.142,
    transform: "matrix(0.818, -0.576, 0.576, 0.818, -10.701, 7.533)",
    fill: "url(#linear-gradient)"
  })))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780",
    transform: "translate(80.901 2.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2243",
    "data-name": "Rectangle 2243",
    width: 43.143,
    height: 44.456,
    transform: "matrix(0.78, -0.626, 0.626, 0.78, -18.844, 13.905)",
    fill: "url(#linear-gradient)"
  })))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782",
    transform: "translate(81.446 24.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781",
    clipPath: "url(#clip-path-180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2244",
    "data-name": "Rectangle 2244",
    width: 38.001,
    height: 39.629,
    transform: "translate(-8.465 9.458) rotate(-48.158)",
    fill: "url(#linear-gradient)"
  })))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784",
    transform: "translate(64.919 14.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783",
    clipPath: "url(#clip-path-181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2245",
    "data-name": "Rectangle 2245",
    width: 34.386,
    height: 40.305,
    transform: "matrix(0.832, -0.555, 0.555, 0.832, -18.772, 11.574)",
    fill: "url(#linear-gradient)"
  })))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786",
    transform: "translate(66.797 44.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785",
    clipPath: "url(#clip-path-182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2246",
    "data-name": "Rectangle 2246",
    width: 30.53,
    height: 39.888,
    transform: "matrix(0.513, -0.858, 0.858, 0.513, -5.341, 8.676)",
    fill: "url(#linear-gradient)"
  })))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788",
    transform: "translate(45.347 28.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787",
    clipPath: "url(#clip-path-183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2247",
    "data-name": "Rectangle 2247",
    width: 41.103,
    height: 43.615,
    transform: "matrix(0.749, -0.662, 0.662, 0.749, -22.32, 19.496)",
    fill: "url(#linear-gradient)"
  })))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(50.147 59.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789",
    clipPath: "url(#clip-path-184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2248",
    "data-name": "Rectangle 2248",
    width: 33.068,
    height: 43.828,
    transform: "matrix(0.433, -0.901, 0.901, 0.433, -6.762, 14.079)",
    fill: "url(#linear-gradient)"
  })))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792",
    transform: "translate(27.112 47.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791",
    clipPath: "url(#clip-path-185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2249",
    "data-name": "Rectangle 2249",
    width: 48.309,
    height: 42.532,
    transform: "matrix(0.612, -0.791, 0.791, 0.612, -24.927, 30.35)",
    fill: "url(#linear-gradient)"
  })))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794",
    transform: "translate(36.077 75.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793",
    clipPath: "url(#clip-path-186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2250",
    "data-name": "Rectangle 2250",
    width: 27.674,
    height: 43.643,
    transform: "matrix(0.162, -0.987, 0.987, 0.162, -3.418, 20.794)",
    fill: "url(#linear-gradient)"
  })))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796",
    transform: "translate(10.636 72.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795",
    clipPath: "url(#clip-path-187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2251",
    "data-name": "Rectangle 2251",
    width: 59.13,
    height: 37.565,
    transform: "matrix(0.34, -0.94, 0.94, 0.34, -19.184, 49.281)",
    fill: "url(#linear-gradient)"
  })))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798",
    transform: "translate(24.094 101.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797",
    clipPath: "url(#clip-path-188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2252",
    "data-name": "Rectangle 2252",
    width: 38.632,
    height: 26.947,
    transform: "translate(0 0.004)",
    fill: "url(#linear-gradient)"
  })))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800",
    transform: "translate(2.578 113.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799",
    clipPath: "url(#clip-path-189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2253",
    "data-name": "Rectangle 2253",
    width: 47.925,
    height: 28.702,
    transform: "translate(-9.518 43.396) rotate(-79.526)",
    fill: "url(#linear-gradient)"
  })))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802",
    transform: "translate(22.213 125.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801",
    clipPath: "url(#clip-path-190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2254",
    "data-name": "Rectangle 2254",
    width: 38.772,
    height: 40.289,
    transform: "translate(-9.849 2.932) rotate(-17.413)",
    fill: "url(#linear-gradient)"
  })))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804",
    transform: "translate(0 155.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803",
    clipPath: "url(#clip-path-191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2255",
    "data-name": "Rectangle 2255",
    width: 36.727,
    height: 43.458,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, -9.68, 2.706)",
    fill: "url(#linear-gradient)"
  })))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806",
    transform: "translate(25.02 152.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    clipPath: "url(#clip-path-192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2256",
    "data-name": "Rectangle 2256",
    width: 37.398,
    height: 46.855,
    transform: "matrix(0.926, -0.377, 0.377, 0.926, -14.442, 5.812)",
    fill: "url(#linear-gradient)"
  })))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808",
    transform: "translate(36.41 178.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807",
    clipPath: "url(#clip-path-193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2257",
    "data-name": "Rectangle 2257",
    width: 36.738,
    height: 44.413,
    transform: "matrix(0.836, -0.548, 0.548, 0.836, -19.991, 12.809)",
    fill: "url(#linear-gradient)"
  })))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810",
    transform: "translate(6.984 193.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2258",
    "data-name": "Rectangle 2258",
    width: 44.06,
    height: 40.584,
    transform: "translate(-10.496 4.527) rotate(-23.311)",
    fill: "url(#linear-gradient)"
  })))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812",
    transform: "translate(53.453 200.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811",
    clipPath: "url(#clip-path-195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2259",
    "data-name": "Rectangle 2259",
    width: 46.1,
    height: 43.797,
    transform: "translate(-23.197 25.457) rotate(-48.419)",
    fill: "url(#linear-gradient)"
  })))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814",
    transform: "translate(22.706 229.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813",
    clipPath: "url(#clip-path-196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2260",
    "data-name": "Rectangle 2260",
    width: 43.665,
    height: 38.996,
    transform: "matrix(0.812, -0.583, 0.583, 0.812, -9.21, 6.613)",
    fill: "url(#linear-gradient)"
  })))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816",
    transform: "translate(69.505 224.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815",
    clipPath: "url(#clip-path-197)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2261",
    "data-name": "Rectangle 2261",
    width: 38.987,
    height: 30.652,
    transform: "translate(-15.986 28.425) rotate(-64.299)",
    fill: "url(#linear-gradient)"
  })))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818",
    transform: "translate(43.155 250.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817",
    clipPath: "url(#clip-path-198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2262",
    "data-name": "Rectangle 2262",
    width: 38.927,
    height: 33.87,
    transform: "translate(-7.042 5.091) rotate(-35.842)",
    fill: "url(#linear-gradient)"
  })))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820",
    transform: "translate(87.36 243.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819",
    clipPath: "url(#clip-path-199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2263",
    "data-name": "Rectangle 2263",
    width: 32.862,
    height: 25.988,
    transform: "translate(-10.263 25.333) rotate(-69.928)",
    fill: "url(#linear-gradient)"
  })))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822",
    transform: "translate(66.67 265.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821",
    clipPath: "url(#clip-path-200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    width: 30.359,
    height: 35.225,
    transform: "translate(-5.933 8.17) rotate(-53.998)",
    fill: "url(#linear-gradient)"
  })))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824",
    transform: "translate(95.474 278.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823",
    clipPath: "url(#clip-path-201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2265",
    "data-name": "Rectangle 2265",
    width: 25.369,
    height: 29.385,
    transform: "matrix(0.574, -0.819, 0.819, 0.574, -5.394, 7.708)",
    fill: "url(#linear-gradient)"
  })))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826",
    transform: "translate(108.847 257.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825",
    clipPath: "url(#clip-path-202)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2266",
    "data-name": "Rectangle 2266",
    width: 29.715,
    height: 23.37,
    transform: "translate(-8.081 23.452) rotate(-71.735)",
    fill: "url(#linear-gradient)"
  })))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828",
    transform: "translate(120.045 286.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827",
    clipPath: "url(#clip-path-203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2267",
    "data-name": "Rectangle 2267",
    width: 23.03,
    height: 23.863,
    transform: "translate(-5.542 6.179) rotate(-48.093)",
    fill: "url(#linear-gradient)"
  })))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830",
    transform: "translate(127.166 269.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829",
    clipPath: "url(#clip-path-204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2268",
    "data-name": "Rectangle 2268",
    width: 23.431,
    height: 20.067,
    transform: "translate(-5.069 19.53) rotate(-77.625)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3991",
    "data-name": "Group 3991",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3990",
    "data-name": "Group 3990",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833",
    transform: "translate(100.521 -0.004)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831",
    clipPath: "url(#clip-path-206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76105",
    "data-name": "Path 76105",
    d: "M24.059,8.057C30.974,4.08,37.839,3.381,44.005,0,36.613,2.376,30.8,3.168,24.059,6.473,16.9,9.973,12.527,19.751,11.8,22.493c1.542-3.739,6.243-10.978,12.256-14.436",
    transform: "translate(-11.8)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836",
    transform: "translate(81.394 2.091)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834",
    clipPath: "url(#clip-path-207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76106",
    "data-name": "Path 76106",
    d: "M17.273,12.289C21.412,7.306,29.674,3.057,34.281.416c.043-.051.068-.119.111-.17C28.175,2.869,21.821,5.714,17.273,10.7A31.655,31.655,0,0,0,9.557,28.556s2.189-9.607,7.716-16.267",
    transform: "translate(-9.556 -0.246)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839",
    transform: "translate(86.868 24.568)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837",
    clipPath: "url(#clip-path-208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76107",
    "data-name": "Path 76107",
    d: "M27.958,6.574c4.556-.485,11.481-1.806,14.751-3.688C38.433,4.513,32.472,5.16,27.915,5.645c-7.069.767-12.826,1.882-17.715,5.306,5.076-2.538,11.157-3.662,17.758-4.378",
    transform: "translate(-10.197 -2.878)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842",
    transform: "translate(64.926 14.309)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840",
    clipPath: "url(#clip-path-209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76108",
    "data-name": "Path 76108",
    d: "M9.114,21.048C12.061,12.736,17.231,7.992,22.46,1.681c-6.021,5.442-12.128,11.591-14,19.5a30.668,30.668,0,0,0-.835,6.592,27.71,27.71,0,0,1,1.49-6.72",
    transform: "translate(-7.618 -1.678)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845",
    transform: "translate(72.793 44.884)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843",
    clipPath: "url(#clip-path-210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76109",
    "data-name": "Path 76109",
    d: "M21.569,6.855c6.694.2,15.032-.077,19.674-1.584-6.8,1.414-14.121.6-21.275.383A21.574,21.574,0,0,0,8.547,7.92,35.99,35.99,0,0,1,21.569,6.855",
    transform: "translate(-8.546 -5.267)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848",
    transform: "translate(45.392 28.243)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    clipPath: "url(#clip-path-211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76110",
    "data-name": "Path 76110",
    d: "M20.591,3.317C15.379,11.774,6.231,16.39,5.337,30.426c-.026.451.017,1.022.017,1.516C6.283,17.957,18.164,11.331,20.591,3.317",
    transform: "translate(-5.335 -3.314)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851",
    transform: "translate(55.953 59.313)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849",
    clipPath: "url(#clip-path-212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76111",
    "data-name": "Path 76111",
    d: "M15,10.652c10.953-1.976,20.159-.528,26.061-3.688C30.494,8.948,20.836,7.271,10.42,11.2a14.336,14.336,0,0,0-3.85,2.24A33.448,33.448,0,0,1,15,10.652",
    transform: "translate(-6.567 -6.97)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3854",
    "data-name": "Group 3854",
    transform: "translate(42.897 75.826)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3853",
    "data-name": "Group 3853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3852",
    "data-name": "Group 3852",
    clipPath: "url(#clip-path-213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76112",
    "data-name": "Path 76112",
    d: "M24.336,14.244c5.6-1.235,11.4-2.453,14.6-5.34-5.008,2.776-9.2,3-14.794,4.224S11.007,14.576,6,17.361a5.832,5.832,0,0,0-.962.767c5.025-2.725,13.738-2.657,19.3-3.884",
    transform: "translate(-5.034 -8.901)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3857",
    "data-name": "Group 3857",
    transform: "translate(31.636 101.893)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    clipPath: "url(#clip-path-214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76113",
    "data-name": "Path 76113",
    d: "M12.129,18.956c4.216-.962,7.81-1.346,12.068-2.053s7.759-1.925,10.612-4.94c-3.6,2.47-6.856,3-11.123,3.7S16.276,17,12.06,17.951a23.612,23.612,0,0,0-8.346,4.275,35.182,35.182,0,0,1,8.415-3.27",
    transform: "translate(-3.718 -11.966)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860",
    transform: "translate(2.911 113.212)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3859",
    "data-name": "Group 3859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858",
    clipPath: "url(#clip-path-215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76114",
    "data-name": "Path 76114",
    d: "M18.524,44.516a35.678,35.678,0,0,0-4.386-11.268C9.888,26.341,3.288,20.856.341,13.293,2.368,22.236,9.394,28.18,13.636,35.1a61.217,61.217,0,0,1,4.889,9.42",
    transform: "translate(-0.348 -13.295)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863",
    transform: "translate(24.084 125.301)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861",
    clipPath: "url(#clip-path-216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76115",
    "data-name": "Path 76115",
    d: "M22.357,22.344a23.716,23.716,0,0,0,8.466-7.631,35.366,35.366,0,0,1-8.466,6.047c-5.2,2.828-14.981,5.536-19.529,12.6,5.05-6.064,14.649-8.372,19.529-11.021",
    transform: "translate(-2.826 -14.71)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3866",
    "data-name": "Group 3866",
    transform: "translate(0 155.443)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3865",
    "data-name": "Group 3865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3864",
    "data-name": "Group 3864",
    clipPath: "url(#clip-path-217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76116",
    "data-name": "Path 76116",
    d: "M18.669,34.281a26.7,26.7,0,0,1,4.9,5.817,17.874,17.874,0,0,0-4.9-7.4C12.46,27.195,4.011,24.537,0,18.252,3.211,25.44,12.46,28.779,18.669,34.281",
    transform: "translate(0 -18.25)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869",
    transform: "translate(25.075 152.481)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3868",
    "data-name": "Group 3868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3867",
    "data-name": "Group 3867",
    clipPath: "url(#clip-path-218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76117",
    "data-name": "Path 76117",
    d: "M9.357,33.413c6.456-5.928,14.308-8.27,17.1-15.509C20.668,24.385,12.8,27.468,7.126,34.154c-2.265,2.674-3.892,5.51-4.182,8.662a24.336,24.336,0,0,1,6.413-9.4",
    transform: "translate(-2.946 -17.904)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3872",
    "data-name": "Group 3872",
    transform: "translate(36.413 178.996)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3871",
    "data-name": "Group 3871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3870",
    "data-name": "Group 3870",
    clipPath: "url(#clip-path-219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76118",
    "data-name": "Path 76118",
    d: "M4.449,51.2A32.086,32.086,0,0,1,8.375,36.884c2.768-4.616,8.355-9.547,8.5-15.867-2.4,6.4-6.388,8.593-9.428,15.066C5.2,40.878,3.818,45.639,4.415,51.013a1.221,1.221,0,0,0,.034.187",
    transform: "translate(-4.273 -21.019)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3875",
    "data-name": "Group 3875",
    transform: "translate(6.983 193.288)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3874",
    "data-name": "Group 3874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873",
    clipPath: "url(#clip-path-220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76119",
    "data-name": "Path 76119",
    d: "M25.357,35.1C18.569,28.861,9.643,26.775.82,22.695c6.728,5.434,18.516,8.364,25.687,13.576-.4-.426-.792-.843-1.15-1.167",
    transform: "translate(-0.819 -22.698)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3878",
    "data-name": "Group 3878",
    transform: "translate(53.455 200.044)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3877",
    "data-name": "Group 3877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3876",
    "data-name": "Group 3876",
    clipPath: "url(#clip-path-221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76120",
    "data-name": "Path 76120",
    d: "M7.857,42.873C9.68,36.912,11.076,32.6,12.831,27.756c1.5,5.97,4.8,11.319,6.362,17.6a57.008,57.008,0,0,1,1.618,9.334,49.019,49.019,0,0,0-1.763-12.826c-1.559-6.277-5.136-11.983-6.124-18.379-1.754,4.855-3.764,11.7-5.587,17.664a30.394,30.394,0,0,0-.664,13.039A31.874,31.874,0,0,1,7.857,42.873",
    transform: "translate(-6.276 -23.486)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3881",
    "data-name": "Group 3881",
    transform: "translate(22.703 229.663)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3880",
    "data-name": "Group 3880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879",
    clipPath: "url(#clip-path-222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76121",
    "data-name": "Path 76121",
    d: "M20.976,29.267a102.116,102.116,0,0,1,10.05,2.53A31.21,31.21,0,0,0,17.5,27.453C12.987,27,7.06,26.524,2.665,27.717l.2.145a89.042,89.042,0,0,1,18.115,1.405",
    transform: "translate(-2.671 -26.969)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3884",
    "data-name": "Group 3884",
    transform: "translate(69.588 224.592)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3883",
    "data-name": "Group 3883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882",
    clipPath: "url(#clip-path-223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76122",
    "data-name": "Path 76122",
    d: "M15.7,28.969c-.409-1.15,4.088,6.422,5.732,14.146-.017-.17-.017-.315-.034-.494-1.065-8.457-6.158-17.391-5.706-16.131-2.981,5.928-7.546,14.189-7.52,21.616.613-6.7,4.786-13.678,7.529-19.137",
    transform: "translate(-8.168 -26.37)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(43.156 250.704)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885",
    clipPath: "url(#clip-path-224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76123",
    "data-name": "Path 76123",
    d: "M30.532,30.025a10.248,10.248,0,0,0-2.615-.554,53.264,53.264,0,0,0-13.508,1.72c-2.436.715-7.537,2.862-9.343,4.752l.23.034c4.914-3.764,19.444-6.013,25.235-5.953",
    transform: "translate(-5.068 -29.436)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890",
    transform: "translate(87.458 243.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888",
    clipPath: "url(#clip-path-225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76124",
    "data-name": "Path 76124",
    d: "M16.247,31.323c1.15,3.032,3.236,5.953,5.068,9.258C19.458,36.2,17.3,32.192,16.57,28.572c-4.2,5.144-6.3,10.476-6.3,16.148.332-4.65,2.231-8.806,5.979-13.4",
    transform: "translate(-10.275 -28.574)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893",
    transform: "translate(66.671 265.187)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891",
    clipPath: "url(#clip-path-226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76125",
    "data-name": "Path 76125",
    d: "M30.679,31.572c-.145-.034-.256-.1-.4-.136-8.474-1.695-20.057,4.25-22.45,7.316l.06.009c3.483-2.9,14.768-7.18,22.791-7.188",
    transform: "translate(-7.83 -31.14)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896",
    transform: "translate(96.451 278.389)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894",
    clipPath: "url(#clip-path-227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76126",
    "data-name": "Path 76126",
    d: "M26.34,32.949a7.764,7.764,0,0,1,.928-.23,11.114,11.114,0,0,0-3.219.23c-3.356.707-8.6,4.267-12.724,9.939,4.633-5.2,12.017-8.755,15.015-9.939",
    transform: "translate(-11.322 -32.689)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899",
    transform: "translate(108.601 257.028)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897",
    clipPath: "url(#clip-path-228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76127",
    "data-name": "Path 76127",
    d: "M13.875,32.854c3.432,3.781,7.784,6.456,10.816,10.493A20.525,20.525,0,0,0,23,40.928c-3.041-4.054-7.469-7.188-10.127-10.748-.2,7.018-.332,11.77,1.014,16.08-.715-4.548-.341-9-.017-13.405",
    transform: "translate(-12.753 -30.175)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902",
    transform: "translate(120.043 286.525)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    clipPath: "url(#clip-path-229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76128",
    "data-name": "Path 76128",
    d: "M25.694,33.656c-.2.008-.426-.026-.63-.009-2.725.324-3.7,2.521-5.987,4.778C18,39.49,16.479,41.849,14.094,43.3a34.1,34.1,0,0,0,5.468-3.781c1.865-1.848,3.5-4.718,6.132-5.86",
    transform: "translate(-14.101 -33.645)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    transform: "translate(127.568 269.965)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903",
    clipPath: "url(#clip-path-230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76129",
    "data-name": "Path 76129",
    d: "M24.909,42.336a21.864,21.864,0,0,1,3.458,4.114A18.985,18.985,0,0,0,24.1,40.743c-3.185-2.913-5.681-5.289-9.122-9.045,2.47,4.574,6.737,7.725,9.931,10.638",
    transform: "translate(-14.981 -31.7)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908",
    transform: "translate(27.133 47.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906",
    clipPath: "url(#clip-path-231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76130",
    "data-name": "Path 76130",
    d: "M11.293,10.08a56.232,56.232,0,0,0,4.948,16.65c-.383-1.414-.8-2.819-1.243-4.318-1.61-5.5-3.058-11.14-2.947-16.872C7.238,15.259,2.895,25.2,3.2,35.776c.332-9,3.764-16.957,8.091-25.7",
    transform: "translate(-3.182 -5.538)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911",
    transform: "translate(10.663 72.537)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909",
    clipPath: "url(#clip-path-232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76131",
    "data-name": "Path 76131",
    d: "M8.95,12.351c.307,8.687,4.931,16.957,7.767,24.554a54.7,54.7,0,0,0-1.661-5.3C12.229,23.933,9.98,17.835,9.342,8.518c-4.4,9.607-8.449,19.87-8.065,30.635.3-9.428,3.7-18.115,7.674-26.8",
    transform: "translate(-1.259 -8.513)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914",
    transform: "translate(84.16 17.302)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912",
    clipPath: "url(#clip-path-233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76132",
    "data-name": "Path 76132",
    d: "M18.68,2.032a28.758,28.758,0,0,0-1.184,2.8l-2.342,6.277a42.785,42.785,0,0,1-2.87,6.09,18.633,18.633,0,0,1-1.763,2.555l-.639-.562a17.636,17.636,0,0,0,1.789-2.368,43.141,43.141,0,0,0,3.092-5.885c.945-2.24,1.9-4.48,2.615-6.158a29.684,29.684,0,0,1,1.3-2.751",
    transform: "translate(-9.879 -2.032)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(84.475 32.837)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    clipPath: "url(#clip-path-234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76133",
    "data-name": "Path 76133",
    d: "M29.346,3.856a27.1,27.1,0,0,1-3.023.307c-1.823.094-4.25.221-6.686.349a41.318,41.318,0,0,0-6.566.9,17.05,17.05,0,0,0-2.836.894l-.315-.792a17.667,17.667,0,0,1,3-.809,42.621,42.621,0,0,1,6.7-.622c2.436-.017,4.872-.043,6.694-.06a26.2,26.2,0,0,0,3.032-.17",
    transform: "translate(-9.916 -3.856)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920",
    transform: "translate(68.537 30.186)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918",
    clipPath: "url(#clip-path-235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76134",
    "data-name": "Path 76134",
    d: "M11.888,3.545c-.2-.034-.767,4.761-1.014,9.607a37.444,37.444,0,0,1-1,6.626A14.431,14.431,0,0,1,8.8,22.7l-.749-.409A13.18,13.18,0,0,0,9.18,19.583a36.586,36.586,0,0,0,1.269-6.473c.46-4.812,1.235-9.616,1.439-9.564",
    transform: "translate(-8.049 -3.544)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3923",
    "data-name": "Group 3923",
    transform: "translate(50.026 48.612)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3922",
    "data-name": "Group 3922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3921",
    "data-name": "Group 3921",
    clipPath: "url(#clip-path-236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76135",
    "data-name": "Path 76135",
    d: "M9.834,5.708a21.707,21.707,0,0,0-.647,3.56c-.247,2.163-.3,5.059-.46,7.963a45.732,45.732,0,0,1-1.014,7.963A27.838,27.838,0,0,1,6.666,28.72l-.792-.315a26.227,26.227,0,0,0,1.141-3.381A45.447,45.447,0,0,0,8.3,17.206c.264-2.887.426-5.791.758-7.955a21.515,21.515,0,0,1,.775-3.543",
    transform: "translate(-5.872 -5.711)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3926",
    "data-name": "Group 3926",
    transform: "translate(68.209 49.203)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3924",
    "data-name": "Group 3924",
    clipPath: "url(#clip-path-237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76136",
    "data-name": "Path 76136",
    d: "M27.4,6.632c.017.213-4.855.162-9.675-.2a37.84,37.84,0,0,0-6.592.162,13.158,13.158,0,0,0-2.853.656l-.273-.809a13.972,13.972,0,0,1,3.049-.562,37.654,37.654,0,0,1,6.7.136c4.821.571,9.633.835,9.641.622",
    transform: "translate(-8.006 -5.777)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3929",
    "data-name": "Group 3929",
    transform: "translate(50.649 67.615)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3928",
    "data-name": "Group 3928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3927",
    "data-name": "Group 3927",
    clipPath: "url(#clip-path-238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76137",
    "data-name": "Path 76137",
    d: "M28.959,7.939a21.515,21.515,0,0,1-3.543.775c-2.163.332-5.068.5-7.955.767a45.2,45.2,0,0,0-7.81,1.286,26.8,26.8,0,0,0-3.39,1.15l-.315-.792a27.838,27.838,0,0,1,3.526-1.048,45.783,45.783,0,0,1,7.963-1.022c2.9-.162,5.8-.221,7.963-.468a21.708,21.708,0,0,0,3.56-.647",
    transform: "translate(-5.946 -7.943)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932",
    transform: "translate(34.726 69.104)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930",
    clipPath: "url(#clip-path-239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76138",
    "data-name": "Path 76138",
    d: "M4.125,8.114A25.644,25.644,0,0,0,4.3,12c.256,2.325.843,5.383,1.346,8.466a55,55,0,0,1,.818,8.576,31.078,31.078,0,0,1-.221,3.935L5.4,32.864a31.4,31.4,0,0,0,.349-3.833,55.19,55.19,0,0,0-.52-8.508c-.4-3.083-.886-6.175-1.056-8.508a25.844,25.844,0,0,1-.051-3.9",
    transform: "translate(-4.077 -8.117)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935",
    transform: "translate(36.572 86.724)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933",
    clipPath: "url(#clip-path-240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76139",
    "data-name": "Path 76139",
    d: "M28.354,10.183a24.987,24.987,0,0,1-3.679,1.3c-2.248.656-5.314,1.26-8.346,1.967a53.153,53.153,0,0,0-8.159,2.461,32.456,32.456,0,0,0-3.475,1.644l-.4-.749a32.047,32.047,0,0,1,3.62-1.567,53.768,53.768,0,0,1,8.329-2.206c3.066-.6,6.132-1.107,8.4-1.678a25.514,25.514,0,0,0,3.713-1.175",
    transform: "translate(-4.295 -10.185)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    transform: "translate(17.998 97.72)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936",
    clipPath: "url(#clip-path-241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76140",
    "data-name": "Path 76140",
    d: "M2.113,11.474a23.08,23.08,0,0,0,.843,4.395C3.663,18.458,5,21.788,6.193,25.178a47.233,47.233,0,0,1,2.461,9.59A30.013,30.013,0,0,1,8.918,39.3l-.852-.034a28.985,28.985,0,0,0-.128-4.412,46.812,46.812,0,0,0-2.155-9.547C4.7,21.9,3.459,18.517,2.828,15.9a22.579,22.579,0,0,1-.715-4.429",
    transform: "translate(-2.115 -11.477)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941",
    transform: "translate(24.798 111.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939",
    clipPath: "url(#clip-path-242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76141",
    "data-name": "Path 76141",
    d: "M28.47,13.073a22.769,22.769,0,0,1-3.824,2.334c-2.4,1.226-5.774,2.487-9.07,3.875a46.476,46.476,0,0,0-8.645,4.582A27.959,27.959,0,0,0,3.49,26.649l-.579-.639a28.648,28.648,0,0,1,3.611-2.734A47,47,0,0,1,15.414,18.9c3.347-1.3,6.745-2.453,9.173-3.611a22.771,22.771,0,0,0,3.884-2.214",
    transform: "translate(-2.916 -13.077)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3944",
    "data-name": "Group 3944",
    transform: "translate(8.828 131.828)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942",
    clipPath: "url(#clip-path-243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76142",
    "data-name": "Path 76142",
    d: "M1.036,15.479a15.985,15.985,0,0,0,1.78,3.79c1.32,2.155,3.543,4.693,5.587,7.376a30.622,30.622,0,0,1,4.642,8.065,22.539,22.539,0,0,1,1.1,4.139l-.843.128a22.191,22.191,0,0,0-.928-4.028,29.948,29.948,0,0,0-4.3-8.057c-1.959-2.725-4.114-5.34-5.366-7.554a15.336,15.336,0,0,1-1.669-3.858",
    transform: "translate(-1.04 -15.479)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947",
    transform: "translate(21.595 138.189)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3946",
    "data-name": "Group 3946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945",
    clipPath: "url(#clip-path-244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76143",
    "data-name": "Path 76143",
    d: "M24.2,16.226a15.723,15.723,0,0,1-3.126,2.811c-2.061,1.482-5.11,2.964-8.023,4.625A30.126,30.126,0,0,0,5.771,29.18,22.359,22.359,0,0,0,3.25,32.459l-.715-.468a22.921,22.921,0,0,1,2.717-3.3,30.675,30.675,0,0,1,7.588-5.4C15.83,21.711,18.9,20.34,21,18.926a15.325,15.325,0,0,0,3.2-2.7",
    transform: "translate(-2.54 -16.225)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950",
    transform: "translate(8.817 170.829)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948",
    clipPath: "url(#clip-path-245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76144",
    "data-name": "Path 76144",
    d: "M1.035,20.058a15.7,15.7,0,0,0,2.691,3.211c1.823,1.746,4.616,3.628,7.29,5.7a30.478,30.478,0,0,1,6.549,6.618,23.006,23.006,0,0,1,2.112,3.722l-.784.332a22.412,22.412,0,0,0-1.925-3.654A29.963,29.963,0,0,0,10.744,29.3c-2.581-2.138-5.332-4.122-7.112-5.936a15.621,15.621,0,0,1-2.6-3.3",
    transform: "translate(-1.037 -20.061)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953",
    transform: "translate(26.936 166.886)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951",
    clipPath: "url(#clip-path-246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76145",
    "data-name": "Path 76145",
    d: "M17.785,19.6a15.281,15.281,0,0,1-1.925,3.739c-1.388,2.121-3.713,4.591-5.843,7.188a30.223,30.223,0,0,0-4.829,7.75A22.319,22.319,0,0,0,4,42.224l-.835-.179a23.355,23.355,0,0,1,1.363-4.054,30.67,30.67,0,0,1,5.17-7.75c2.223-2.538,4.608-4.914,6.064-6.984A15.288,15.288,0,0,0,17.785,19.6",
    transform: "translate(-3.168 -19.598)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3956",
    "data-name": "Group 3956",
    transform: "translate(20.976 206.611)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954",
    clipPath: "url(#clip-path-247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76146",
    "data-name": "Path 76146",
    d: "M2.463,24.26a13.1,13.1,0,0,0,3.015,2.18c1.959,1.1,4.795,2.061,7.563,3.228a26.086,26.086,0,0,1,7.112,4.267,19.785,19.785,0,0,1,2.606,2.785l-.681.5a19.662,19.662,0,0,0-2.41-2.751,25.076,25.076,0,0,0-6.8-4.412c-2.708-1.252-5.527-2.325-7.461-3.5a13.273,13.273,0,0,1-2.947-2.3",
    transform: "translate(-2.462 -24.257)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959",
    transform: "translate(40.588 196.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3957",
    "data-name": "Group 3957",
    clipPath: "url(#clip-path-248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76147",
    "data-name": "Path 76147",
    d: "M10.856,23.035a13.144,13.144,0,0,1-.537,3.7c-.571,2.18-1.857,4.914-2.938,7.691a25.23,25.23,0,0,0-1.84,7.887,19.46,19.46,0,0,0,.179,3.662l-.843.111a20.218,20.218,0,0,1-.051-3.816A25.779,25.779,0,0,1,6.99,34.269c1.184-2.759,2.555-5.417,3.2-7.571a12.854,12.854,0,0,0,.664-3.662",
    transform: "translate(-4.763 -23.038)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3962",
    "data-name": "Group 3962",
    transform: "translate(38.224 237.135)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3961",
    "data-name": "Group 3961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960",
    clipPath: "url(#clip-path-249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76148",
    "data-name": "Path 76148",
    d: "M4.488,27.844A13.21,13.21,0,0,0,8,29.1c2.18.511,5.178.639,8.159.988a25.757,25.757,0,0,1,8.023,2.1,20.1,20.1,0,0,1,3.279,1.942l-.511.681a19.344,19.344,0,0,0-3.083-1.976A25.355,25.355,0,0,0,16.1,30.5c-2.938-.443-5.953-.69-8.134-1.278a12.945,12.945,0,0,1-3.475-1.38",
    transform: "translate(-4.488 -27.84)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3965",
    "data-name": "Group 3965",
    transform: "translate(59.656 220.036)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3963",
    "data-name": "Group 3963",
    clipPath: "url(#clip-path-250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76149",
    "data-name": "Path 76149",
    d: "M8.011,25.836a12.888,12.888,0,0,1,.477,3.7c.043,2.265-.468,5.238-.758,8.2a25.007,25.007,0,0,0,.341,8.1,19.233,19.233,0,0,0,1.158,3.475l-.792.332a19.981,19.981,0,0,1-1.065-3.662A25.734,25.734,0,0,1,7.3,37.7c.4-2.981,1.014-5.911,1.056-8.159a12.958,12.958,0,0,0-.349-3.7",
    transform: "translate(-7.001 -25.836)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968",
    transform: "translate(58.348 256.311)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3967",
    "data-name": "Group 3967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3966",
    "data-name": "Group 3966",
    clipPath: "url(#clip-path-251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76150",
    "data-name": "Path 76150",
    d: "M6.851,30.731a26.438,26.438,0,0,0,3.287.026c1.976-.068,4.582-.434,7.231-.6a25.331,25.331,0,0,1,7.282.511,21.69,21.69,0,0,1,3.2.988l-.332.784a23.8,23.8,0,0,0-10.144-1.857c-2.615.051-5.255.315-7.231.307a27.373,27.373,0,0,1-3.3-.162",
    transform: "translate(-6.85 -30.094)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3971",
    "data-name": "Group 3971",
    transform: "translate(78.675 269.51)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3970",
    "data-name": "Group 3970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3969",
    "data-name": "Group 3969",
    clipPath: "url(#clip-path-252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76151",
    "data-name": "Path 76151",
    d: "M9.238,33.475a27.18,27.18,0,0,0,3.279-.264c1.959-.238,4.522-.835,7.146-1.226a25.329,25.329,0,0,1,7.307-.136,21.926,21.926,0,0,1,3.27.707l-.256.809a23.842,23.842,0,0,0-10.271-.954c-2.606.281-5.2.775-7.18.937a26.141,26.141,0,0,1-3.3.128",
    transform: "translate(-9.235 -31.643)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3974",
    "data-name": "Group 3974",
    transform: "translate(104.886 280.859)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3973",
    "data-name": "Group 3973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3972",
    "data-name": "Group 3972",
    clipPath: "url(#clip-path-253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76152",
    "data-name": "Path 76152",
    d: "M12.315,37.765a19.551,19.551,0,0,0,2.529-.843c1.456-.664,3.407-1.55,5.349-2.436a18.134,18.134,0,0,1,8.483-1.465l-.085.843a17.362,17.362,0,0,0-8.244,1.022l-5.459,2.155a17.967,17.967,0,0,1-2.572.724",
    transform: "translate(-12.316 -32.973)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3977",
    "data-name": "Group 3977",
    transform: "translate(127.258 288.074)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3976",
    "data-name": "Group 3976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3975",
    "data-name": "Group 3975",
    clipPath: "url(#clip-path-254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76153",
    "data-name": "Path 76153",
    d: "M14.942,39.548a13.221,13.221,0,0,0,1.661-.962L20.027,36.1a13.155,13.155,0,0,1,5.817-2.274l.077.852a12.258,12.258,0,0,0-5.664,1.78c-1.3.818-2.606,1.635-3.586,2.24a13.107,13.107,0,0,1-1.729.852",
    transform: "translate(-14.942 -33.822)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3980",
    "data-name": "Group 3980",
    transform: "translate(75.742 237.261)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3979",
    "data-name": "Group 3979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3978",
    "data-name": "Group 3978",
    clipPath: "url(#clip-path-255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76154",
    "data-name": "Path 76154",
    d: "M8.893,27.858a26.454,26.454,0,0,1,.434,3.27c.179,1.967.136,4.616.307,7.239a23.889,23.889,0,0,0,2.7,9.948l-.758.392A22.768,22.768,0,0,1,10.324,45.6a25.309,25.309,0,0,1-1.116-7.214c-.06-2.649.085-5.28-.009-7.248a26.826,26.826,0,0,0-.307-3.279",
    transform: "translate(-8.895 -27.861)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3983",
    "data-name": "Group 3983",
    transform: "translate(92.861 253.276)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3982",
    "data-name": "Group 3982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3981",
    "data-name": "Group 3981",
    clipPath: "url(#clip-path-256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76155",
    "data-name": "Path 76155",
    d: "M10.9,29.739a22.666,22.666,0,0,1,.954,2.759c.417,1.695.979,3.969,1.542,6.226A20.945,20.945,0,0,0,17.5,46.866l-.664.537a21.726,21.726,0,0,1-3.85-8.568c-.46-2.291-.92-4.582-1.26-6.3a22.775,22.775,0,0,0-.826-2.794",
    transform: "translate(-10.905 -29.737)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3986",
    "data-name": "Group 3986",
    transform: "translate(112.673 266.7)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3985",
    "data-name": "Group 3985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3984",
    "data-name": "Group 3984",
    clipPath: "url(#clip-path-257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76156",
    "data-name": "Path 76156",
    d: "M13.229,31.315a19.532,19.532,0,0,1,1.3,2.342c.622,1.473,1.448,3.432,2.283,5.4a17.343,17.343,0,0,0,5.068,6.584l-.545.656a18.08,18.08,0,0,1-4.9-7.069c-.749-2.01-1.49-4.011-2.044-5.519a18.523,18.523,0,0,0-1.167-2.393",
    transform: "translate(-13.233 -31.315)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3989",
    "data-name": "Group 3989",
    transform: "translate(131.075 278.883)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3988",
    "data-name": "Group 3988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3987",
    "data-name": "Group 3987",
    clipPath: "url(#clip-path-258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76157",
    "data-name": "Path 76157",
    d: "M15.39,32.745a14.775,14.775,0,0,1,1.082,1.593c.537,1.022,1.269,2.376,1.993,3.73a12.367,12.367,0,0,0,4.02,4.369l-.485.7a13.23,13.23,0,0,1-3.909-4.872c-.63-1.4-1.269-2.8-1.737-3.858a13.182,13.182,0,0,0-.962-1.661",
    transform: "translate(-15.391 -32.749)",
    fill: "url(#linear-gradient)"
  }))))))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3993",
    "data-name": "Group 3993",
    transform: "translate(20.696 9.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3992",
    "data-name": "Group 3992",
    clipPath: "url(#clip-path-259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2323",
    "data-name": "Rectangle 2323",
    width: 139.812,
    height: 291.846,
    transform: "translate(-2.299 -0.004)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999",
    transform: "translate(20.694 24.897)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3998",
    "data-name": "Group 3998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997",
    clipPath: "url(#clip-path-261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3995",
    "data-name": "Group 3995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3994",
    "data-name": "Group 3994",
    clipPath: "url(#clip-path-262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76159",
    "data-name": "Path 76159",
    d: "M14.649,183.353a133.252,133.252,0,0,1-10.127-35.9A128.037,128.037,0,0,1,15.91,75.777c10.109-21.19,24.5-38.326,37.559-51.51A198.842,198.842,0,0,1,78.321,2.924,201.821,201.821,0,0,0,52.413,24.829C39.356,37.869,25.414,54.791,15.3,75.76,5.093,96.592.128,121.938,3.458,146.688A131.12,131.12,0,0,0,13.593,182.2a130.031,130.031,0,0,0,14.462,24.017,131.877,131.877,0,0,1-13.405-22.868",
    transform: "translate(-2.434 -2.922)",
    fill: "url(#linear-gradient)"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76160",
    "data-name": "Path 76160",
    d: "M23.922,37.718c6.882,2.93,12.835,5.664,17.706,8.091,4.872,2.351,8.713,4.7,11.276,6.149a27.246,27.246,0,0,1,3.977,2.47c.068.068.051.17.111.247a1.38,1.38,0,0,0-.375-1.175,27.752,27.752,0,0,0-3.977-2.461c-2.564-1.456-6.328-3.449-11.2-5.8C36.561,42.819,30.48,40.009,23.6,37.07c-3.211-1.354-6.635-2.862-10.161-4.488a92.709,92.709,0,0,0,10.484,5.136",
    transform: "translate(80.318 220.012)",
    fill: "url(#linear-gradient)"
  }))))))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(190.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    clipPath: "url(#clip-path-263)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2327",
    "data-name": "Rectangle 2327",
    width: 37.147,
    height: 39.445,
    transform: "translate(-10.701 15.19) rotate(-54.843)",
    fill: "url(#linear-gradient)"
  })))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005",
    transform: "translate(216.702 2.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004",
    clipPath: "url(#clip-path-264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2328",
    "data-name": "Rectangle 2328",
    width: 44.462,
    height: 43.15,
    transform: "matrix(0.626, -0.78, 0.78, 0.626, -17.303, 21.542)",
    fill: "url(#linear-gradient)"
  })))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007",
    transform: "translate(203.552 24.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006",
    clipPath: "url(#clip-path-265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2329",
    "data-name": "Rectangle 2329",
    width: 39.623,
    height: 37.995,
    transform: "matrix(0.745, -0.667, 0.667, 0.745, -8.465, 7.584)",
    fill: "url(#linear-gradient)"
  })))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009",
    transform: "translate(243.172 14.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008",
    clipPath: "url(#clip-path-266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2330",
    "data-name": "Rectangle 2330",
    width: 40.305,
    height: 34.386,
    transform: "translate(-17.355 26.036) rotate(-56.31)",
    fill: "url(#linear-gradient)"
  })))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011",
    transform: "translate(216.924 44.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010",
    clipPath: "url(#clip-path-267)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2331",
    "data-name": "Rectangle 2331",
    width: 39.88,
    height: 30.526,
    transform: "translate(-5.341 2.932) rotate(-30.864)",
    fill: "url(#linear-gradient)"
  })))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013",
    transform: "translate(262.284 28.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012",
    clipPath: "url(#clip-path-268)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2332",
    "data-name": "Rectangle 2332",
    width: 43.609,
    height: 41.097,
    transform: "translate(-22.052 24.954) rotate(-48.527)",
    fill: "url(#linear-gradient)"
  })))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015",
    transform: "translate(232.484 59.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014",
    clipPath: "url(#clip-path-269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2333",
    "data-name": "Rectangle 2333",
    width: 43.828,
    height: 33.068,
    transform: "matrix(0.901, -0.433, 0.433, 0.901, -6.762, 3.253)",
    fill: "url(#linear-gradient)"
  })))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4017",
    "data-name": "Group 4017",
    transform: "translate(281.055 47.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    clipPath: "url(#clip-path-270)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2334",
    "data-name": "Rectangle 2334",
    width: 42.532,
    height: 48.309,
    transform: "matrix(0.791, -0.612, 0.612, 0.791, -23.51, 18.179)",
    fill: "url(#linear-gradient)"
  })))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4019",
    "data-name": "Group 4019",
    transform: "translate(246.136 75.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018",
    clipPath: "url(#clip-path-271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2335",
    "data-name": "Rectangle 2335",
    width: 43.643,
    height: 27.674,
    transform: "translate(-3.418 0.566) rotate(-9.335)",
    fill: "url(#linear-gradient)"
  })))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4021",
    "data-name": "Group 4021",
    transform: "translate(295.303 72.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4020",
    "data-name": "Group 4020",
    clipPath: "url(#clip-path-272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2336",
    "data-name": "Rectangle 2336",
    width: 37.565,
    height: 59.13,
    transform: "translate(-19.244 6.445) rotate(-19.876)",
    fill: "url(#linear-gradient)"
  })))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4023",
    "data-name": "Group 4023",
    transform: "translate(260.206 101.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4022",
    "data-name": "Group 4022",
    clipPath: "url(#clip-path-273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2337",
    "data-name": "Rectangle 2337",
    width: 38.632,
    height: 26.947,
    transform: "translate(0 0.004)",
    fill: "url(#linear-gradient)"
  })))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025",
    transform: "translate(300.967 113.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024",
    clipPath: "url(#clip-path-274)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2338",
    "data-name": "Rectangle 2338",
    width: 28.702,
    height: 47.925,
    transform: "translate(-8.03 1.487) rotate(-10.474)",
    fill: "url(#linear-gradient)"
  })))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027",
    transform: "translate(270.852 125.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026",
    clipPath: "url(#clip-path-275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2339",
    "data-name": "Rectangle 2339",
    width: 40.289,
    height: 38.772,
    transform: "translate(-9.336 29.772) rotate(-72.587)",
    fill: "url(#linear-gradient)"
  })))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(295.236 155.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028",
    clipPath: "url(#clip-path-276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2340",
    "data-name": "Rectangle 2340",
    width: 43.458,
    height: 36.727,
    transform: "matrix(0.269, -0.963, 0.963, 0.269, -9.68, 34.692)",
    fill: "url(#linear-gradient)"
  })))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4031",
    "data-name": "Group 4031",
    transform: "translate(274.344 152.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4030",
    "data-name": "Group 4030",
    clipPath: "url(#clip-path-277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2341",
    "data-name": "Rectangle 2341",
    width: 46.855,
    height: 37.398,
    transform: "translate(-14.282 35.128) rotate(-67.872)",
    fill: "url(#linear-gradient)"
  })))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033",
    transform: "translate(271.311 178.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4032",
    "data-name": "Group 4032",
    clipPath: "url(#clip-path-278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2342",
    "data-name": "Rectangle 2342",
    width: 44.413,
    height: 36.738,
    transform: "translate(-19.869 29.817) rotate(-56.76)",
    fill: "url(#linear-gradient)"
  })))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(280.425 193.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034",
    clipPath: "url(#clip-path-279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2343",
    "data-name": "Rectangle 2343",
    width: 40.581,
    height: 44.053,
    transform: "translate(-10.496 24.362) rotate(-66.689)",
    fill: "url(#linear-gradient)"
  })))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(254.871 200.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    clipPath: "url(#clip-path-280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2344",
    "data-name": "Rectangle 2344",
    width: 43.797,
    height: 46.1,
    transform: "translate(-25.542 20.04) rotate(-41.581)",
    fill: "url(#linear-gradient)"
  })))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(260.436 229.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    clipPath: "url(#clip-path-281)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2345",
    "data-name": "Rectangle 2345",
    width: 38.996,
    height: 43.665,
    transform: "translate(-9.21 12.839) rotate(-54.338)",
    fill: "url(#linear-gradient)"
  })))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041",
    transform: "translate(239.795 224.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040",
    clipPath: "url(#clip-path-282)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2346",
    "data-name": "Rectangle 2346",
    width: 30.659,
    height: 38.991,
    transform: "matrix(0.901, -0.434, 0.434, 0.901, -14.909, 6.587)",
    fill: "url(#linear-gradient)"
  })))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    transform: "translate(242.474 250.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042",
    clipPath: "url(#clip-path-283)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2347",
    "data-name": "Rectangle 2347",
    width: 33.87,
    height: 38.927,
    transform: "matrix(0.586, -0.811, 0.811, 0.586, -7.042, 9.754)",
    fill: "url(#linear-gradient)"
  })))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(221.403 243.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044",
    clipPath: "url(#clip-path-284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2348",
    "data-name": "Rectangle 2348",
    width: 25.98,
    height: 32.859,
    transform: "matrix(0.939, -0.343, 0.343, 0.939, -11.247, 3.386)",
    fill: "url(#linear-gradient)"
  })))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(221.787 265.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    clipPath: "url(#clip-path-285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2349",
    "data-name": "Rectangle 2349",
    width: 35.225,
    height: 30.359,
    transform: "translate(-5.933 4.315) rotate(-36.002)",
    fill: "url(#linear-gradient)"
  })))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049",
    transform: "translate(199.634 278.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048",
    clipPath: "url(#clip-path-286)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2350",
    "data-name": "Rectangle 2350",
    width: 29.385,
    height: 25.369,
    transform: "translate(-5.394 3.781) rotate(-34.999)",
    fill: "url(#linear-gradient)"
  })))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051",
    transform: "translate(199.064 257.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050",
    clipPath: "url(#clip-path-287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2351",
    "data-name": "Rectangle 2351",
    width: 23.379,
    height: 29.718,
    transform: "matrix(0.95, -0.313, 0.313, 0.95, -8.403, 2.558)",
    fill: "url(#linear-gradient)"
  })))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(180.829 286.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052",
    clipPath: "url(#clip-path-288)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 23.863,
    height: 23.031,
    transform: "translate(-5.542 4.978) rotate(-41.907)",
    fill: "url(#linear-gradient)"
  })))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055",
    transform: "translate(180.506 269.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    clipPath: "url(#clip-path-289)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2353",
    "data-name": "Rectangle 2353",
    width: 20.059,
    height: 23.429,
    transform: "translate(-4.284 0.944) rotate(-12.375)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4216",
    "data-name": "Group 4216",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4215",
    "data-name": "Group 4215",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058",
    transform: "translate(190.209 -0.004)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4057",
    "data-name": "Group 4057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056",
    clipPath: "url(#clip-path-206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76188",
    "data-name": "Path 76188",
    d: "M42.28,8.057C35.365,4.08,28.5,3.381,22.334,0c7.393,2.376,13.21,3.168,19.946,6.473,7.154,3.5,11.532,13.278,12.256,16.02C52.995,18.754,48.285,11.515,42.28,8.057",
    transform: "translate(-22.328)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4061",
    "data-name": "Group 4061",
    transform: "translate(216.701 2.091)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4060",
    "data-name": "Group 4060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4059",
    "data-name": "Group 4059",
    clipPath: "url(#clip-path-207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76189",
    "data-name": "Path 76189",
    d: "M42.57,12.289C38.431,7.306,30.161,3.057,25.562.416a2.07,2.07,0,0,0-.119-.17C31.669,2.869,38.022,5.714,42.57,10.7a31.655,31.655,0,0,1,7.716,17.851S48.1,18.949,42.57,12.289",
    transform: "translate(-25.451 -0.246)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4064",
    "data-name": "Group 4064",
    transform: "translate(203.552 24.568)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4063",
    "data-name": "Group 4063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4062",
    "data-name": "Group 4062",
    clipPath: "url(#clip-path-208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76190",
    "data-name": "Path 76190",
    d: "M38.651,6.574C34.095,6.088,27.17,4.768,23.9,2.886,28.175,4.513,34.137,5.16,38.694,5.645c7.077.767,12.826,1.882,17.724,5.306C51.333,8.413,45.252,7.289,38.651,6.574",
    transform: "translate(-23.9 -2.878)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4067",
    "data-name": "Group 4067",
    transform: "translate(243.17 14.309)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4066",
    "data-name": "Group 4066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4065",
    "data-name": "Group 4065",
    clipPath: "url(#clip-path-294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76191",
    "data-name": "Path 76191",
    d: "M41.9,21.048C38.96,12.736,33.781,7.992,28.552,1.681c6.021,5.442,12.128,11.591,14,19.5a30.667,30.667,0,0,1,.835,6.592,27.709,27.709,0,0,0-1.49-6.72",
    transform: "translate(-28.549 -1.678)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070",
    transform: "translate(217.447 44.884)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4069",
    "data-name": "Group 4069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4068",
    "data-name": "Group 4068",
    clipPath: "url(#clip-path-210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76192",
    "data-name": "Path 76192",
    d: "M45.206,6.855c-6.694.2-15.032-.077-19.674-1.584,6.8,1.414,14.121.6,21.275.383A21.574,21.574,0,0,1,58.228,7.92,35.99,35.99,0,0,0,45.206,6.855",
    transform: "translate(-25.528 -5.267)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4073",
    "data-name": "Group 4073",
    transform: "translate(262.283 28.243)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4072",
    "data-name": "Group 4072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    clipPath: "url(#clip-path-296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76193",
    "data-name": "Path 76193",
    d: "M30.8,3.317C36.008,11.774,45.155,16.39,46.05,30.426c.026.451-.017,1.022-.017,1.516C45.1,17.957,33.223,11.331,30.8,3.317",
    transform: "translate(-30.795 -3.314)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4076",
    "data-name": "Group 4076",
    transform: "translate(232.484 59.313)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4075",
    "data-name": "Group 4075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4074",
    "data-name": "Group 4074",
    clipPath: "url(#clip-path-212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76194",
    "data-name": "Path 76194",
    d: "M53.359,10.652C42.406,8.676,33.2,10.124,27.3,6.964c10.569,1.984,20.227.307,30.644,4.233a14.336,14.336,0,0,1,3.85,2.24,33.449,33.449,0,0,0-8.432-2.785",
    transform: "translate(-27.297 -6.97)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4079",
    "data-name": "Group 4079",
    transform: "translate(246.135 75.826)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4078",
    "data-name": "Group 4078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4077",
    "data-name": "Group 4077",
    clipPath: "url(#clip-path-298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76195",
    "data-name": "Path 76195",
    d: "M43.5,14.244c-5.6-1.235-11.4-2.453-14.6-5.34,5.008,2.776,9.2,3,14.794,4.224s13.133,1.448,18.141,4.233a6.209,6.209,0,0,1,.962.767C57.772,15.4,49.059,15.47,43.5,14.244",
    transform: "translate(-28.898 -8.901)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4082",
    "data-name": "Group 4082",
    transform: "translate(260.208 101.893)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4081",
    "data-name": "Group 4081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4080",
    "data-name": "Group 4080",
    clipPath: "url(#clip-path-299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76196",
    "data-name": "Path 76196",
    d: "M53.232,18.956c-4.216-.962-7.81-1.346-12.068-2.053s-7.759-1.925-10.612-4.94c3.6,2.47,6.856,3,11.123,3.7S49.085,17,53.3,17.951a23.612,23.612,0,0,1,8.346,4.275,35.046,35.046,0,0,0-8.415-3.27",
    transform: "translate(-30.554 -11.966)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4085",
    "data-name": "Group 4085",
    transform: "translate(301.843 113.212)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4084",
    "data-name": "Group 4084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4083",
    "data-name": "Group 4083",
    clipPath: "url(#clip-path-215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76197",
    "data-name": "Path 76197",
    d: "M35.441,44.516a35.678,35.678,0,0,1,4.386-11.268c4.25-6.907,10.85-12.392,13.8-19.955C51.6,22.236,44.571,28.18,40.33,35.1a61.215,61.215,0,0,0-4.889,9.42",
    transform: "translate(-35.439 -13.295)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4088",
    "data-name": "Group 4088",
    transform: "translate(270.859 125.301)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4087",
    "data-name": "Group 4087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4086",
    "data-name": "Group 4086",
    clipPath: "url(#clip-path-301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76198",
    "data-name": "Path 76198",
    d: "M40.268,22.344A23.716,23.716,0,0,1,31.8,14.713a35.366,35.366,0,0,0,8.466,6.047c5.2,2.828,14.981,5.536,19.529,12.6-5.05-6.064-14.649-8.372-19.529-11.021",
    transform: "translate(-31.809 -14.71)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4091",
    "data-name": "Group 4091",
    transform: "translate(299.367 155.443)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4090",
    "data-name": "Group 4090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4089",
    "data-name": "Group 4089",
    clipPath: "url(#clip-path-302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76199",
    "data-name": "Path 76199",
    d: "M40.047,34.281a26.7,26.7,0,0,0-4.9,5.817,17.874,17.874,0,0,1,4.9-7.4c6.209-5.5,14.649-8.159,18.669-14.445-3.211,7.188-12.46,10.527-18.669,16.029",
    transform: "translate(-35.15 -18.25)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4094",
    "data-name": "Group 4094",
    transform: "translate(274.342 152.481)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4092",
    "data-name": "Group 4092",
    clipPath: "url(#clip-path-303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76200",
    "data-name": "Path 76200",
    d: "M49.314,33.413c-6.456-5.928-14.308-8.27-17.1-15.509C38,24.385,45.873,27.468,51.545,34.154c2.266,2.674,3.9,5.51,4.182,8.662a24.336,24.336,0,0,0-6.413-9.4",
    transform: "translate(-32.21 -17.904)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4097",
    "data-name": "Group 4097",
    transform: "translate(273.921 178.996)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4096",
    "data-name": "Group 4096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4095",
    "data-name": "Group 4095",
    clipPath: "url(#clip-path-304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76201",
    "data-name": "Path 76201",
    d: "M44.588,51.2a32.085,32.085,0,0,0-3.926-14.317c-2.768-4.616-8.355-9.547-8.5-15.867,2.4,6.4,6.388,8.593,9.428,15.066,2.248,4.795,3.628,9.556,3.032,14.93a1.216,1.216,0,0,1-.034.187",
    transform: "translate(-32.165 -21.019)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100",
    transform: "translate(290.26 193.288)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4099",
    "data-name": "Group 4099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4098",
    "data-name": "Group 4098",
    clipPath: "url(#clip-path-305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76202",
    "data-name": "Path 76202",
    d: "M35.231,35.1c6.788-6.243,15.714-8.329,24.537-12.409-6.728,5.434-18.516,8.364-25.687,13.576.4-.426.792-.843,1.15-1.167",
    transform: "translate(-34.079 -22.698)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4103",
    "data-name": "Group 4103",
    transform: "translate(254.933 200.044)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4102",
    "data-name": "Group 4102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4101",
    "data-name": "Group 4101",
    clipPath: "url(#clip-path-306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76203",
    "data-name": "Path 76203",
    d: "M42.894,42.873C41.072,36.912,39.675,32.6,37.92,27.756c-1.5,5.97-4.8,11.319-6.362,17.6a57.006,57.006,0,0,0-1.618,9.334A49.019,49.019,0,0,1,31.7,41.868c1.559-6.277,5.136-11.983,6.124-18.379,1.754,4.855,3.764,11.7,5.587,17.664a30.394,30.394,0,0,1,.664,13.039,31.874,31.874,0,0,0-1.184-11.319",
    transform: "translate(-29.931 -23.486)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4106",
    "data-name": "Group 4106",
    transform: "translate(271.871 229.663)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4105",
    "data-name": "Group 4105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104",
    clipPath: "url(#clip-path-222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76204",
    "data-name": "Path 76204",
    d: "M41.972,29.267a102.115,102.115,0,0,0-10.05,2.53,31.21,31.21,0,0,1,13.525-4.344c4.514-.451,10.442-.928,14.836.264l-.2.145a89.042,89.042,0,0,0-18.115,1.405",
    transform: "translate(-31.919 -26.969)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4109",
    "data-name": "Group 4109",
    transform: "translate(240.085 224.592)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107",
    clipPath: "url(#clip-path-223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76205",
    "data-name": "Path 76205",
    d: "M33.921,28.969c.409-1.15-4.088,6.422-5.732,14.146.026-.17.017-.315.043-.494,1.056-8.457,6.149-17.391,5.7-16.131,2.981,5.928,7.546,14.189,7.52,21.616-.613-6.7-4.786-13.678-7.529-19.137",
    transform: "translate(-28.193 -26.37)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4112",
    "data-name": "Group 4112",
    transform: "translate(254.314 250.704)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4111",
    "data-name": "Group 4111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4110",
    "data-name": "Group 4110",
    clipPath: "url(#clip-path-309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76206",
    "data-name": "Path 76206",
    d: "M29.86,30.025a10.262,10.262,0,0,1,2.606-.554,53.281,53.281,0,0,1,13.516,1.72c2.436.715,7.537,2.862,9.343,4.752l-.23.034c-4.914-3.764-19.444-6.013-25.235-5.953",
    transform: "translate(-29.862 -29.436)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115",
    transform: "translate(224.436 243.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4114",
    "data-name": "Group 4114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4113",
    "data-name": "Group 4113",
    clipPath: "url(#clip-path-225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76207",
    "data-name": "Path 76207",
    d: "M31.42,31.323c-1.15,3.032-3.236,5.953-5.068,9.258,1.857-4.378,4.011-8.389,4.744-12.009,4.2,5.144,6.3,10.476,6.294,16.148-.324-4.65-2.223-8.806-5.97-13.4",
    transform: "translate(-26.353 -28.574)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4118",
    "data-name": "Group 4118",
    transform: "translate(233.414 265.187)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4116",
    "data-name": "Group 4116",
    clipPath: "url(#clip-path-226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76208",
    "data-name": "Path 76208",
    d: "M27.406,31.572c.145-.034.256-.1.4-.136,8.474-1.695,20.057,4.25,22.45,7.316l-.06.009c-3.483-2.9-14.768-7.18-22.791-7.188",
    transform: "translate(-27.408 -31.14)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4121",
    "data-name": "Group 4121",
    transform: "translate(210.544 278.389)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4120",
    "data-name": "Group 4120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4119",
    "data-name": "Group 4119",
    clipPath: "url(#clip-path-227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76209",
    "data-name": "Path 76209",
    d: "M25.648,32.949a7.764,7.764,0,0,0-.928-.23,11.134,11.134,0,0,1,3.219.23c3.356.707,8.6,4.267,12.724,9.939-4.633-5.2-12.017-8.755-15.015-9.939",
    transform: "translate(-24.728 -32.689)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4124",
    "data-name": "Group 4124",
    transform: "translate(202.393 257.028)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4123",
    "data-name": "Group 4123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122",
    clipPath: "url(#clip-path-228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76210",
    "data-name": "Path 76210",
    d: "M34.58,32.854C31.148,36.636,26.8,39.31,23.764,43.347a20.527,20.527,0,0,1,1.686-2.419c3.041-4.054,7.469-7.188,10.127-10.748.2,7.018.332,11.77-1.014,16.08.715-4.548.341-9,.017-13.405",
    transform: "translate(-23.763 -30.175)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127",
    transform: "translate(191.295 286.525)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125",
    clipPath: "url(#clip-path-229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76211",
    "data-name": "Path 76211",
    d: "M22.461,33.656c.2.008.434-.026.63-.009,2.725.324,3.7,2.521,5.987,4.778,1.073,1.065,2.6,3.424,4.982,4.872a34.093,34.093,0,0,1-5.468-3.781c-1.865-1.848-3.5-4.718-6.132-5.86",
    transform: "translate(-22.459 -33.645)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130",
    transform: "translate(181.98 269.965)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    clipPath: "url(#clip-path-230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76212",
    "data-name": "Path 76212",
    d: "M24.825,42.336a21.864,21.864,0,0,0-3.458,4.114,18.986,18.986,0,0,1,4.267-5.706c3.194-2.913,5.681-5.289,9.122-9.045-2.47,4.574-6.737,7.725-9.931,10.638",
    transform: "translate(-21.368 -31.7)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4133",
    "data-name": "Group 4133",
    transform: "translate(282.742 47.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4132",
    "data-name": "Group 4132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4131",
    "data-name": "Group 4131",
    clipPath: "url(#clip-path-231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76213",
    "data-name": "Path 76213",
    d: "M38.146,10.08A56.232,56.232,0,0,1,33.2,26.731c.383-1.414.8-2.819,1.243-4.318,1.61-5.5,3.058-11.14,2.947-16.872C42.2,15.259,46.544,25.2,46.237,35.776c-.332-9-3.764-16.957-8.091-25.7",
    transform: "translate(-33.198 -5.538)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4136",
    "data-name": "Group 4136",
    transform: "translate(296.806 72.537)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4134",
    "data-name": "Group 4134",
    clipPath: "url(#clip-path-232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76214",
    "data-name": "Path 76214",
    d: "M42.617,12.351c-.307,8.687-4.931,16.957-7.767,24.554.46-1.746,1-3.5,1.661-5.3,2.828-7.674,5.076-13.772,5.723-23.089,4.395,9.607,8.44,19.87,8.057,30.635-.3-9.428-3.7-18.115-7.674-26.8",
    transform: "translate(-34.845 -8.513)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4139",
    "data-name": "Group 4139",
    transform: "translate(229.974 17.302)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4138",
    "data-name": "Group 4138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4137",
    "data-name": "Group 4137",
    clipPath: "url(#clip-path-233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76215",
    "data-name": "Path 76215",
    d: "M27,2.032a29.68,29.68,0,0,1,1.3,2.751c.715,1.678,1.669,3.918,2.615,6.158a43.141,43.141,0,0,0,3.092,5.885A16.8,16.8,0,0,0,35.8,19.193l-.639.562A18.634,18.634,0,0,1,33.4,17.2a42.786,42.786,0,0,1-2.87-6.09L28.186,4.834C27.547,3.122,27,2.032,27,2.032",
    transform: "translate(-27.005 -2.032)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4142",
    "data-name": "Group 4142",
    transform: "translate(219.032 32.837)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4141",
    "data-name": "Group 4141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4140",
    "data-name": "Group 4140",
    clipPath: "url(#clip-path-319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76216",
    "data-name": "Path 76216",
    d: "M25.718,3.856a26.2,26.2,0,0,0,3.032.17c1.823.017,4.258.043,6.694.06a42.62,42.62,0,0,1,6.7.622,17.668,17.668,0,0,1,3,.809l-.315.792a17,17,0,0,0-2.845-.894,41.06,41.06,0,0,0-6.558-.9c-2.436-.128-4.863-.256-6.686-.349a27.105,27.105,0,0,1-3.023-.307",
    transform: "translate(-25.714 -3.856)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4145",
    "data-name": "Group 4145",
    transform: "translate(250.558 30.186)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4144",
    "data-name": "Group 4144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4143",
    "data-name": "Group 4143",
    clipPath: "url(#clip-path-320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76217",
    "data-name": "Path 76217",
    d: "M29.419,3.545c.2-.051.979,4.752,1.439,9.564a36.589,36.589,0,0,0,1.269,6.473,13.18,13.18,0,0,0,1.133,2.708l-.75.409a14.431,14.431,0,0,1-1.073-2.921,37.444,37.444,0,0,1-1-6.626c-.247-4.846-.809-9.641-1.014-9.607",
    transform: "translate(-29.421 -3.544)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4148",
    "data-name": "Group 4148",
    transform: "translate(268.946 48.612)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4147",
    "data-name": "Group 4147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4146",
    "data-name": "Group 4146",
    clipPath: "url(#clip-path-321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76218",
    "data-name": "Path 76218",
    d: "M31.578,5.708a21.515,21.515,0,0,1,.775,3.543c.324,2.163.494,5.068.758,7.955A45.446,45.446,0,0,0,34.4,25.024a26.23,26.23,0,0,0,1.141,3.381l-.792.315A27.839,27.839,0,0,1,33.7,25.195a45.733,45.733,0,0,1-1.013-7.963c-.162-2.9-.213-5.8-.46-7.963a21.706,21.706,0,0,0-.647-3.56",
    transform: "translate(-31.58 -5.711)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4151",
    "data-name": "Group 4151",
    transform: "translate(235.328 49.203)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    "data-name": "Group 4150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4149",
    "data-name": "Group 4149",
    clipPath: "url(#clip-path-322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76219",
    "data-name": "Path 76219",
    d: "M27.631,6.632c.009.213,4.821-.051,9.641-.622a37.654,37.654,0,0,1,6.7-.136,14.135,14.135,0,0,1,3.058.562l-.281.809A13.157,13.157,0,0,0,43.9,6.589a37.84,37.84,0,0,0-6.592-.162c-4.821.366-9.692.417-9.675.2",
    transform: "translate(-27.631 -5.777)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4154",
    "data-name": "Group 4154",
    transform: "translate(249.276 67.615)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4153",
    "data-name": "Group 4153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4152",
    "data-name": "Group 4152",
    clipPath: "url(#clip-path-238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76220",
    "data-name": "Path 76220",
    d: "M29.269,7.939a21.708,21.708,0,0,0,3.56.647c2.163.247,5.059.307,7.963.468a45.783,45.783,0,0,1,7.963,1.022,27.839,27.839,0,0,1,3.526,1.048l-.315.792a26.8,26.8,0,0,0-3.39-1.15,45.2,45.2,0,0,0-7.81-1.286c-2.887-.264-5.791-.434-7.955-.767a21.516,21.516,0,0,1-3.543-.775",
    transform: "translate(-29.266 -7.943)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4157",
    "data-name": "Group 4157",
    transform: "translate(285.819 69.104)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4156",
    "data-name": "Group 4156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4155",
    "data-name": "Group 4155",
    clipPath: "url(#clip-path-324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76221",
    "data-name": "Path 76221",
    d: "M35.9,8.114a25.846,25.846,0,0,1-.051,3.9c-.17,2.334-.656,5.425-1.056,8.508a55.185,55.185,0,0,0-.52,8.508,31.4,31.4,0,0,0,.349,3.833l-.843.111a31.078,31.078,0,0,1-.221-3.935,55.007,55.007,0,0,1,.818-8.576c.5-3.083,1.09-6.141,1.346-8.466A25.643,25.643,0,0,0,35.9,8.114",
    transform: "translate(-33.562 -8.117)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4160",
    "data-name": "Group 4160",
    transform: "translate(262.304 86.724)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4159",
    "data-name": "Group 4159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4158",
    "data-name": "Group 4158",
    clipPath: "url(#clip-path-325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76222",
    "data-name": "Path 76222",
    d: "M30.8,10.183a25.592,25.592,0,0,0,3.7,1.175c2.265.571,5.34,1.082,8.406,1.678a53.769,53.769,0,0,1,8.329,2.206,32.048,32.048,0,0,1,3.62,1.567l-.4.749a32.456,32.456,0,0,0-3.475-1.644,53.152,53.152,0,0,0-8.159-2.461c-3.032-.707-6.1-1.312-8.355-1.967a25.077,25.077,0,0,1-3.671-1.3",
    transform: "translate(-30.801 -10.185)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163",
    transform: "translate(298.125 97.72)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4162",
    "data-name": "Group 4162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4161",
    "data-name": "Group 4161",
    clipPath: "url(#clip-path-241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76223",
    "data-name": "Path 76223",
    d: "M41.816,11.474A22.58,22.58,0,0,1,41.1,15.9c-.63,2.615-1.874,6-2.964,9.4a47.317,47.317,0,0,0-2.146,9.547,28.985,28.985,0,0,0-.128,4.412l-.852.034a30.01,30.01,0,0,1,.264-4.531,47.233,47.233,0,0,1,2.461-9.59c1.192-3.39,2.529-6.72,3.236-9.309a23.081,23.081,0,0,0,.843-4.395",
    transform: "translate(-35.005 -11.477)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166",
    transform: "translate(272.581 111.34)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4165",
    "data-name": "Group 4165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164",
    clipPath: "url(#clip-path-242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76224",
    "data-name": "Path 76224",
    d: "M32.005,13.073a22.77,22.77,0,0,0,3.884,2.214c2.427,1.158,5.826,2.308,9.173,3.611a47,47,0,0,1,8.892,4.378,28.65,28.65,0,0,1,3.611,2.734l-.579.639a27.96,27.96,0,0,0-3.441-2.785A46.477,46.477,0,0,0,44.9,19.282c-3.3-1.388-6.669-2.649-9.07-3.875a22.769,22.769,0,0,1-3.824-2.334",
    transform: "translate(-32.005 -13.077)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(301.008 131.828)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    clipPath: "url(#clip-path-243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76225",
    "data-name": "Path 76225",
    d: "M48.442,15.479a15.337,15.337,0,0,1-1.669,3.858c-1.252,2.214-3.407,4.829-5.357,7.554a30.242,30.242,0,0,0-4.31,8.057,22.539,22.539,0,0,0-.92,4.028l-.843-.128a22.866,22.866,0,0,1,1.09-4.139,30.622,30.622,0,0,1,4.642-8.065c2.053-2.683,4.267-5.221,5.587-7.376a15.57,15.57,0,0,0,1.78-3.79",
    transform: "translate(-35.34 -15.479)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172",
    transform: "translate(279.676 138.189)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    "data-name": "Group 4170",
    clipPath: "url(#clip-path-244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76226",
    "data-name": "Path 76226",
    d: "M32.838,16.226a15.325,15.325,0,0,0,3.2,2.7c2.1,1.414,5.17,2.785,8.159,4.361a30.676,30.676,0,0,1,7.588,5.4,22.922,22.922,0,0,1,2.717,3.3l-.715.468a22.358,22.358,0,0,0-2.521-3.279,30.126,30.126,0,0,0-7.282-5.519c-2.913-1.661-5.962-3.143-8.023-4.625a15.722,15.722,0,0,1-3.126-2.811",
    transform: "translate(-32.839 -16.225)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4175",
    "data-name": "Group 4175",
    transform: "translate(295.478 170.829)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173",
    clipPath: "url(#clip-path-330)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76227",
    "data-name": "Path 76227",
    d: "M53.336,20.058a15.622,15.622,0,0,1-2.6,3.3c-1.78,1.814-4.531,3.8-7.112,5.936A29.962,29.962,0,0,0,37.4,35.984a22.411,22.411,0,0,0-1.925,3.654l-.784-.332a23,23,0,0,1,2.112-3.722,30.478,30.478,0,0,1,6.549-6.618c2.674-2.07,5.468-3.952,7.29-5.7a15.7,15.7,0,0,0,2.691-3.211",
    transform: "translate(-34.696 -20.061)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4178",
    "data-name": "Group 4178",
    transform: "translate(281.377 166.886)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4177",
    "data-name": "Group 4177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4176",
    "data-name": "Group 4176",
    clipPath: "url(#clip-path-331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76228",
    "data-name": "Path 76228",
    d: "M33.038,19.6a15.678,15.678,0,0,0,2.027,3.662c1.456,2.07,3.841,4.446,6.064,6.984a30.671,30.671,0,0,1,5.17,7.75,23.357,23.357,0,0,1,1.363,4.054l-.835.179a22.318,22.318,0,0,0-1.192-3.952,30.223,30.223,0,0,0-4.829-7.75c-2.129-2.6-4.454-5.068-5.843-7.188A15.281,15.281,0,0,1,33.038,19.6",
    transform: "translate(-33.036 -19.598)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4181",
    "data-name": "Group 4181",
    transform: "translate(281.662 206.611)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4180",
    "data-name": "Group 4180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4179",
    "data-name": "Group 4179",
    clipPath: "url(#clip-path-247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76229",
    "data-name": "Path 76229",
    d: "M53.367,24.26a13.215,13.215,0,0,1-2.955,2.3c-1.925,1.175-4.744,2.248-7.452,3.5a25.077,25.077,0,0,0-6.8,4.412,19.664,19.664,0,0,0-2.41,2.751l-.681-.5a19.784,19.784,0,0,1,2.606-2.785,26.086,26.086,0,0,1,7.112-4.267c2.768-1.167,5.6-2.129,7.563-3.228a13.1,13.1,0,0,0,3.015-2.18",
    transform: "translate(-33.073 -24.257)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4184",
    "data-name": "Group 4184",
    transform: "translate(276.252 196.184)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4183",
    "data-name": "Group 4183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4182",
    "data-name": "Group 4182",
    clipPath: "url(#clip-path-333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76230",
    "data-name": "Path 76230",
    d: "M32.438,23.035A12.853,12.853,0,0,0,33.1,26.7c.639,2.155,2.018,4.812,3.2,7.571a25.779,25.779,0,0,1,2.163,8.006,20.762,20.762,0,0,1-.043,3.816l-.852-.111a19.462,19.462,0,0,0,.179-3.662,25.231,25.231,0,0,0-1.84-7.887c-1.082-2.776-2.368-5.51-2.938-7.691a13.145,13.145,0,0,1-.537-3.7",
    transform: "translate(-32.438 -23.038)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4187",
    "data-name": "Group 4187",
    transform: "translate(261.74 237.135)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4185",
    "data-name": "Group 4185",
    clipPath: "url(#clip-path-334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76231",
    "data-name": "Path 76231",
    d: "M53.7,27.844a12.945,12.945,0,0,1-3.475,1.38c-2.18.588-5.2.835-8.134,1.278a25.355,25.355,0,0,0-7.767,2.334,19.344,19.344,0,0,0-3.083,1.976l-.511-.681a20.1,20.1,0,0,1,3.279-1.942,25.757,25.757,0,0,1,8.023-2.1c2.981-.349,5.979-.477,8.159-.988A13.209,13.209,0,0,0,53.7,27.844",
    transform: "translate(-30.733 -27.84)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4190",
    "data-name": "Group 4190",
    transform: "translate(261.057 220.036)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4189",
    "data-name": "Group 4189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4188",
    "data-name": "Group 4188",
    clipPath: "url(#clip-path-335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76232",
    "data-name": "Path 76232",
    d: "M31.861,25.836a12.958,12.958,0,0,0-.349,3.7c.043,2.248.656,5.178,1.056,8.159a25.734,25.734,0,0,1-.068,8.287,19.982,19.982,0,0,1-1.065,3.662l-.784-.332a19.707,19.707,0,0,0,1.15-3.475,25.008,25.008,0,0,0,.341-8.1c-.29-2.964-.8-5.936-.758-8.2a12.888,12.888,0,0,1,.477-3.7",
    transform: "translate(-30.651 -25.836)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4193",
    "data-name": "Group 4193",
    transform: "translate(243.583 256.311)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4192",
    "data-name": "Group 4192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4191",
    "data-name": "Group 4191",
    clipPath: "url(#clip-path-336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76233",
    "data-name": "Path 76233",
    d: "M49.6,30.731a27.373,27.373,0,0,1-3.3.162c-1.976.009-4.616-.255-7.231-.307a23.8,23.8,0,0,0-10.144,1.857L28.6,31.66a21.69,21.69,0,0,1,3.2-.988,25.331,25.331,0,0,1,7.282-.511c2.649.162,5.255.528,7.231.6a26.438,26.438,0,0,0,3.287-.026",
    transform: "translate(-28.602 -30.094)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4196",
    "data-name": "Group 4196",
    transform: "translate(223.256 269.51)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4195",
    "data-name": "Group 4195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4194",
    "data-name": "Group 4194",
    clipPath: "url(#clip-path-337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76234",
    "data-name": "Path 76234",
    d: "M47.216,33.475a26.141,26.141,0,0,1-3.3-.128c-1.976-.162-4.574-.656-7.18-.937a23.842,23.842,0,0,0-10.271.954l-.256-.809a21.926,21.926,0,0,1,3.27-.707,25.328,25.328,0,0,1,7.307.136c2.623.392,5.187.988,7.146,1.226a27.18,27.18,0,0,0,3.279.264",
    transform: "translate(-26.21 -31.643)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4199",
    "data-name": "Group 4199",
    transform: "translate(201.687 280.859)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4198",
    "data-name": "Group 4198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4197",
    "data-name": "Group 4197",
    clipPath: "url(#clip-path-253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76235",
    "data-name": "Path 76235",
    d: "M40.042,37.765a17.968,17.968,0,0,1-2.572-.724L32.01,34.886a17.362,17.362,0,0,0-8.244-1.022l-.085-.843a18.134,18.134,0,0,1,8.483,1.465c1.95.886,3.892,1.772,5.357,2.436a19.238,19.238,0,0,0,2.521.843",
    transform: "translate(-23.681 -32.973)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4202",
    "data-name": "Group 4202",
    transform: "translate(184.699 288.074)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4201",
    "data-name": "Group 4201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    "data-name": "Group 4200",
    clipPath: "url(#clip-path-254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76236",
    "data-name": "Path 76236",
    d: "M32.664,39.548a13.107,13.107,0,0,1-1.729-.852c-.979-.6-2.283-1.422-3.586-2.24a12.258,12.258,0,0,0-5.664-1.78l.077-.852A13.155,13.155,0,0,1,27.58,36.1L31,38.586a13.221,13.221,0,0,0,1.661.962",
    transform: "translate(-21.689 -33.822)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4205",
    "data-name": "Group 4205",
    transform: "translate(243.751 237.261)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4204",
    "data-name": "Group 4204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4203",
    "data-name": "Group 4203",
    clipPath: "url(#clip-path-255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76237",
    "data-name": "Path 76237",
    d: "M32.061,27.858a26.825,26.825,0,0,0-.307,3.279c-.094,1.967.051,4.6-.009,7.248A25.308,25.308,0,0,1,30.63,45.6a22.032,22.032,0,0,1-1.26,3.109l-.749-.392a23.889,23.889,0,0,0,2.7-9.948c.17-2.623.128-5.272.307-7.239a26.451,26.451,0,0,1,.434-3.27",
    transform: "translate(-28.619 -27.861)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208",
    transform: "translate(223.476 253.276)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4207",
    "data-name": "Group 4207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4206",
    "data-name": "Group 4206",
    clipPath: "url(#clip-path-341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76238",
    "data-name": "Path 76238",
    d: "M32.84,29.739a22.776,22.776,0,0,0-.826,2.794c-.341,1.72-.8,4.011-1.26,6.3A21.726,21.726,0,0,1,26.9,47.4l-.664-.537a20.945,20.945,0,0,0,4.105-8.142c.562-2.257,1.124-4.531,1.542-6.226a22.666,22.666,0,0,1,.954-2.759",
    transform: "translate(-26.242 -29.737)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4211",
    "data-name": "Group 4211",
    transform: "translate(201.613 266.7)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4210",
    "data-name": "Group 4210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4209",
    "data-name": "Group 4209",
    clipPath: "url(#clip-path-257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76239",
    "data-name": "Path 76239",
    d: "M32.325,31.315a18.521,18.521,0,0,0-1.167,2.393c-.554,1.507-1.295,3.509-2.036,5.519A18.151,18.151,0,0,1,24.217,46.3l-.545-.656a17.366,17.366,0,0,0,5.059-6.584c.843-1.967,1.678-3.926,2.3-5.4a18.911,18.911,0,0,1,1.295-2.342",
    transform: "translate(-23.675 -31.315)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4214",
    "data-name": "Group 4214",
    transform: "translate(184.761 278.883)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4213",
    "data-name": "Group 4213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4212",
    "data-name": "Group 4212",
    clipPath: "url(#clip-path-258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76240",
    "data-name": "Path 76240",
    d: "M28.789,32.745a13.182,13.182,0,0,0-.962,1.661c-.468,1.056-1.107,2.461-1.737,3.858a13.23,13.23,0,0,1-3.909,4.872l-.485-.7a12.366,12.366,0,0,0,4.02-4.369c.724-1.354,1.448-2.708,1.993-3.73a14.77,14.77,0,0,1,1.082-1.593",
    transform: "translate(-21.691 -32.749)",
    fill: "url(#linear-gradient)"
  }))))))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4218",
    "data-name": "Group 4218",
    transform: "translate(164.873 9.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4217",
    "data-name": "Group 4217",
    clipPath: "url(#clip-path-344)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2408",
    "data-name": "Rectangle 2408",
    width: 139.821,
    height: 291.846,
    transform: "translate(-0.149 -0.004)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4226",
    "data-name": "Group 4226",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4225",
    "data-name": "Group 4225",
    clipPath: "url(#clip-path-205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4224",
    "data-name": "Group 4224",
    transform: "translate(164.924 24.897)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4223",
    "data-name": "Group 4223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4222",
    "data-name": "Group 4222",
    clipPath: "url(#clip-path-261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4221",
    "data-name": "Group 4221",
    transform: "translate(61.432)",
    opacity: 0.8,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4220",
    "data-name": "Group 4220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4219",
    "data-name": "Group 4219",
    clipPath: "url(#clip-path-262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76242",
    "data-name": "Path 76242",
    d: "M90.249,183.353a133.563,133.563,0,0,0,10.127-35.9A128.037,128.037,0,0,0,88.988,75.777c-10.109-21.19-24.5-38.326-37.559-51.51A198.84,198.84,0,0,0,26.577,2.924,201.819,201.819,0,0,1,52.485,24.829c13.056,13.039,27,29.962,37.108,50.931C99.8,96.592,104.77,121.938,101.44,146.688A131.12,131.12,0,0,1,91.3,182.2a130.029,130.029,0,0,1-14.462,24.017,131.876,131.876,0,0,0,13.405-22.868",
    transform: "translate(-26.581 -2.922)",
    fill: "url(#linear-gradient)"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76243",
    "data-name": "Path 76243",
    d: "M52.446,37.718c-6.882,2.93-12.835,5.664-17.706,8.091-4.872,2.351-8.713,4.7-11.276,6.149a27.243,27.243,0,0,0-3.977,2.47c-.068.068-.06.17-.111.247A1.38,1.38,0,0,1,19.75,53.5a27.752,27.752,0,0,1,3.977-2.461c2.564-1.456,6.328-3.449,11.2-5.8,4.88-2.419,10.961-5.229,17.843-8.168,3.211-1.354,6.635-2.862,10.161-4.488a92.708,92.708,0,0,1-10.484,5.136",
    transform: "translate(-19.362 220.012)",
    fill: "url(#linear-gradient)"
  })))))))))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_156",
    "data-name": "Mask Group 156",
    transform: "translate(4601 728)",
    clipPath: "url(#clip-path-348)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "award-3",
    width: 300,
    height: 300,
    transform: "translate(86 4320.651)",
    xlinkHref: "data:image/jpeg;base64,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"
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4189",
    "data-name": "Rectangle 4189",
    transform: "translate(4704 5282)",
    fill: "none",
    stroke: "rgba(112,112,112,0.1)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 61,
    rx: 30.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 266,
    height: 60,
    rx: 30,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards1);
export default __webpack_public_path__ + "static/media/awards-1.0b37b476c3d21fda446afdc12ac343fc.svg";
export { ForwardRef as ReactComponent };